import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, Renderer2, Input, OnInit, ViewChild, ViewEncapsulation, ElementRef } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { ToastrService } from "ngx-toastr";
import { invoiceFilter } from "../../common-functions";

import { DatePipe } from '@angular/common';
import { TitleCasePipe } from '@angular/common';
import * as saveAs from 'file-saver';
import { SignaturePad } from 'angular2-signaturepad';
import { Observable, ReplaySubject, Subject, ignoreElements, startWith, takeUntil } from 'rxjs';
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "../../../environments/environment";
import { JsonPipe, KeyValue } from '@angular/common';
import { HeaderComponent } from './../../layouts/header/header.component';
import { SharedService } from './../../services/sharedService/shared.service'
import { PDFDocument } from 'pdf-lib'
// import { PhoneFormatPipe } from 'src/app/pipes/phone-format.pipe';
import { PhoneFormatPipe } from "../../pipes/phone-format.pipe";
// import { Modal } from 'bootstrap';
import { LoaderService } from 'src/app/loader.service';
import { ConfirmationDialogComponent } from './../confirmation-dialog/confirmation-dialog.component';
import { floatWith2Decimals, groupBy, sumBy, adjustWith2DecimalsForUI } from "../../common-functions";


import { state } from '@angular/animations';
// import { MaskNumberPipe } from '../pipes/mask-number.pipe';
import SwiperCore, { Navigation, EffectCoverflow, Pagination, SwiperOptions, Swiper, Virtual } from "swiper";
import {

  SafeResourceUrl,

  DomSanitizer,

  SafeHtml,

  SafeUrl,

  SafeStyle,

  SafeScript,

  EventManager,

} from "@angular/platform-browser";
import jsPDF from 'jspdf';
import { type } from 'jquery';
// import { moment } from 'ngx-bootstrap/chronos/testing/chain';

import * as moment from "moment";
import { DecimalPipe, } from "@angular/common";
import { postServiceWorkerMessage } from 'src/serviceworker/message';
import { WorkerMessageType } from 'src/serviceworker/service/events/message';
import { WorkerUrlPrefetchResult } from 'src/serviceworker/service/prefetch';
import { CommonPatternsService } from 'src/app/common-patterns.service';
import { LoggerService } from 'src/app/services/logger.service';
import { CustomDatePipe } from 'src/app/pipes/customdate.pipe';
import { GlobalStoreService } from 'src/app/services/global-store.service';
import { Store } from '@ngrx/store';
import { selectMemberData, selectMemberError, selectMemberLoading } from 'src/app/state/selectors/member.selector';
import { loadMemberData, loadMemberDataSuccess } from 'src/app/state/actions/members.actions';
import { decompress } from 'compress-json';
import { selectLanguageData } from 'src/app/state/selectors';
import { loadLanguageData } from '../../state/actions'
import { AuthorizeNetService } from 'src/app/services/authorize-net.service';
import { InvoiceModuleComponent } from 'src/app/invoice-module/invoice-module.component';
import { memberFormConfigData } from 'src/app/state/actions/memberFormConfig.actions';
import { selectMemberFormConfigData } from 'src/app/state/selectors/memberFormConfig.selectors';

SwiperCore.use([Navigation, Pagination, EffectCoverflow]);
// import M from 'materialize-css';
// import { ReCaptchaV3Service } from 'ng-recaptcha';
declare var $: any;

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.css'],
  providers: [DatePipe, TitleCasePipe, DecimalPipe, PhoneFormatPipe, CustomDatePipe],
  // encapsulation: ViewEncapsulation.None
})
export class OverviewComponent implements OnInit {
  greenValue: any;
  yellowValue: any;
  public formData: any;
  public allFormData: any = {};
  public lastUpdatedType: any = "";
  public signUpData: any = {};
  public premiums: any = {};
  names: any[] = [
    { label: 'Guaranteed', position: 10 },    // Display "Start" at 0%
    { label: 'Pending', position: 0 }, // Display "Quarter" at 25%

  ];
  rangeValues: any = [];
  productobj: any;
  minValue = 0;
  maxValue: any;
  dob: any;
  public planssummarymainLife: any = [];
  showyellowbar = false
  plansObj: any[];
  myDateValue: Date;
  spouseDob: Date = new Date();
  currencySymbol: string = "$";
  planEnrollmentDates: any
  hoverStates: {
    [index: number]: boolean
  } = {};

  emailForm: FormGroup = new FormGroup({
    email: new FormControl('')
  })
  addressform: FormGroup = new FormGroup({
    line1: new FormControl(''),
    line2: new FormControl(''),
    city: new FormControl(''),
    country: new FormControl(''),
    province: new FormControl(''),
    postalCode: new FormControl(''),
    primaryPhone: new FormControl(''),
    secondaryPhone: new FormControl(''),
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    email: new FormControl(''),
    gender: new FormControl(''),
    dob: new FormControl('')

  });

  phoneform: FormGroup = new FormGroup({
    primaryPhone: new FormControl(''),
    secondaryPhone: new FormControl(''),
  });

  uploadService: FormGroup = new FormGroup({
    uploadhealthCard: new FormControl(''),
    uploadhealthCardProvider: new FormControl(''),
    uploadhealthCardFile: new FormControl('')
  })
  uploadApplication: FormGroup = new FormGroup({
    uploadApplicationType: new FormControl(''),
    uploadApplicationFile: new FormControl('')
  })

  spouseform: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    dob: new FormControl(this.spouseDob.toISOString().split("T")[0]),
    email: new FormControl(''),
    coveredByAnotherPlan: new FormControl(''),
    healthPlan: new FormControl(''),
    insurer: new FormControl(''),
    martialStatus: new FormControl(''),
    effectiveDate: new FormControl(''),
    gender: new FormControl(''),
  });

  dependentform: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    dob: new FormControl(''),
    gender: new FormControl(''),
    age: new FormControl(''),
    phoneNum: new FormControl(''),
    coveredByAnotherPlan: new FormControl(''),
    carrierName: new FormControl(''),
    specialNeeds: new FormControl(''),
    postSecondaryStudent: new FormControl(''),
    graduationDate: new FormControl(''),
    // martialStatus: new FormControl(''),
    effectiveDate: new FormControl(''),
  });

  paymentform: FormGroup = new FormGroup({
    cutomerId: new FormControl(''),
    // Id: new FormControl(''),
    PublicApiKey: new FormControl(''),
    SuccessUri: new FormControl(''),
    FailUri: new FormControl(''),
    FirstName: new FormControl(''),
    LastName: new FormControl(''),
    email: new FormControl(''),
    CardNumber: new FormControl(''),
    ExpirationMonth: new FormControl(''),
    ExpirationYear: new FormControl(''),
    Cvv: new FormControl(''),
    nameonthecard: new FormControl(''),
    aptcheck: new FormControl(''),
    streetaddress: new FormControl(''),
    streetaddressline2: new FormControl(''),
    city: new FormControl(''),
    stateId: new FormControl(''),
    postalcode: new FormControl(''),
    recaptchaReactive: new FormControl(''),
  });

  ccform: FormGroup = new FormGroup({
    cutomerId: new FormControl(''),
    Id: new FormControl(''),
    PublicApiKey: new FormControl(''),
    SuccessUri: new FormControl(''),
    FailUri: new FormControl(''),
    FirstName: new FormControl(''),
    LastName: new FormControl(''),
    email: new FormControl(''),
    CardNumber: new FormControl(''),
    ExpirationMonth: new FormControl(''),
    ExpirationYear: new FormControl(''),
    Cvv: new FormControl(''),
    nameonthecard: new FormControl(''),
    aptcheck: new FormControl(''),
    streetaddress: new FormControl(''),
    streetaddressline2: new FormControl(''),
    city: new FormControl(''),
    stateId: new FormControl(''),
    postalcode: new FormControl(''),
    recaptchaReactive: new FormControl(''),
  });

  padform: FormGroup = new FormGroup({
    bankcode: new FormControl(''),
    transitNumber: new FormControl(''),
    accountNo: new FormControl(''),
    bankdetails: new FormControl(''),
    file: new FormControl(''),
  });

  paymentMethodForm: FormGroup = new FormGroup({
    bankCode: new FormControl(''),
    branchCode: new FormControl(''),
    accountNumber: new FormControl(''),
    files: new FormControl(''),
    paymentmethod: new FormControl(''),
  });

  valisignform: FormGroup = new FormGroup({
    code: new FormControl(''),
  });

  addPlanForm: FormGroup = new FormGroup({

    planEnrollmentDate: new FormControl(''),

  });
  cancelPlanForm: FormGroup = new FormGroup({

    terminationDate: new FormControl(''),

  });

  cancelplanFormDetails: FormGroup = new FormGroup({
    reason: new FormControl(''),
    memberstatus: new FormControl(''),
    terminationDate: new FormControl(''),
    proceedWithEquitable: new FormControl(''),
    proceedWithGreenshield: new FormControl(''),
    proceedWithPHR: new FormControl(''),
    proceedWithRefund: new FormControl(''),
    proceedWithSmartchoice: new FormControl(''),
    proceedWithSubscriptionExpiry: new FormControl(''),
    proceedWithCancelCustomer: new FormControl(''),

  });

  addplanFormDetails: FormGroup = new FormGroup({
    reason: new FormControl(''),
    memberstatus: new FormControl(''),
    terminationDate: new FormControl(''),
    proceedWithEquitableRegistration: new FormControl(''),
    proceedWithEquitableTermination: new FormControl(''),
    proceedWithGreenshieldRegistration: new FormControl(''),
    proceedWithGreenshieldTermination: new FormControl(''),
    proceedWithRefund: new FormControl(''),
    proceedWithSmartchoice: new FormControl(''),
    proceedWithSubscriptionExpiry: new FormControl(''),
    proceedWithCancelCustomer: new FormControl(''),

  });

  @ViewChild(ConfirmationDialogComponent) confirmationDialog: ConfirmationDialogComponent;
  @ViewChild('dp') dpicker: ElementRef;
  invoicesList: any[] = [];
  hicList: any[] = [];
  @Input() customerId: any;
  customerData: any = [];
  childrenInfo: any[] = [];
  childrenId: any;

  // UpdateAddressComponent = false;
  // UpdateSpousePlanComponent = false;
  spouseInsurer: any;
  roe: any;
  MemberfusebillId: any;
  role: string = sessionStorage.getItem('role')
  viewRoe: boolean = true;
  formConfiguration: any = {};
  selectedTab: any = 'tab1';
  healthCard: any = false;
  src: any;
  spouseCoverage: any;
  childCoverage: any;
  specialNeeds: any;
  postSecondaryStudent: any;
  graduationDate = true;
  coverage: any = 'open';
  dependentCoverage = 'open';
  bookletList: any[] = [];
  allbrokerslist: any[] = [];
  bookletList1: any[] = [];
  serviceDetailsarray: any[] = [];
  // declare var $: any;
  // display:any = 'none';
  displayStyle = 'none';
  displayBooklet = 'none';
  roeUrl: any;
  advisortype: any;
  advisorName: any;
  secondaryPhone: any;
  invalidpostalcodeprivince: boolean = false;
  configprovinceres: any;
  openUpdatePaymentForm: any;
  provincialZipcodes: any;
  provincelistid: any;
  state_id: any;
  statename: any;
  postalvalue: any;
  resetButton = false;
  resetbutton = false;
  uploadCheque = false;
  bankInfo: any;
  bank: any;
  bankAddress: any[] = [];
  displayTimer: any;
  showTimer: any;
  startTimer: any;
  customerid: any;
  accessToken: any;
  invoiceResponse: any;
  creditCardNo: any;
  expire: any;
  bookletLink: any;
  invoiceslink: any;
  booklet_link: any;
  support_link: any;
  health_card: any;
  hidebooklet: any = false;
  upcomingInvoice: any;
  spouseId: any;
  fusebillId: any;
  advisor: any;
  corporateDetails: any;
  paymentVoidCheque: any;
  imagedisplay: any;
  address: any;
  fileExtension: any;
  signatureImg: any;
  encBank: any
  signaturePadOptions: Object = {
    'minWidth': 2,
    'canvasWidth': 700,
    'canvasHeight': 300
  };
  spouseData: any;
  spouseUpdate: any;
  spouseStatus: any;
  spouseInfo: any;
  dependentData: any;
  dependentUpdate: any;
  dependentStatus: any;
  // selectedBase64: string | null = null;
  selectedBase64: any;
  expireMonth: any;
  expireYear: any;
  invalidExpiration = false;
  showImage = false;
  bankDetails = false;
  bankinfo = false;
  cheque = false;
  pad: any;
  signedPad: any;
  PADdetails: any;
  bankCode: any;
  transitNumber: any;
  accountNumber: any;
  banknameres: any;
  items: any = 1;
  cardNumber: any;
  currentIndex = 1;
  link: any;
  customerInvoices: any;
  displayCardsMessage: any = true;
  customerDraftInvoices: any;
  customerUpcomingInvoices: any;


  @ViewChild(SignaturePad)
  signaturePad!: SignaturePad;
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('closePhonemodal') closePhonemodal: any;
  @ViewChild('closeAddressmodal') closeAddressmodal: any;
  @ViewChild('closeExecutivesmodal') closeExecutivesmodal: any;
  @ViewChild('closeSpousemodal') closeSpousemodal: any;
  @ViewChild('closeDependentmodal') closeDependentmodal: any;
  @ViewChild('closePaymentmodal') closePaymentmodal: any;
  @ViewChild('openRoe') openRoe: any;
  @ViewChild('videoPopup') openPopup: any;
  @ViewChild('iframePopup') openiframe: any;
  @ViewChild('equitablePopup') openequitable: any;
  @ViewChild('supportPopup') opensupport: any;
  @ViewChild('closePaymenttoPAD') closePaymenttoPAD: any;
  @ViewChild('myFileInput') myFileInput: ElementRef;
  @ViewChild('myFileInputService') myFileInputService: ElementRef;
  paymentMethod: any;
  // @ViewChild(HeaderComponent)
  // headerComponent!: HeaderComponent;
  filename: any;
  padfilename: any;
  ext: any;
  mimetype: any;
  previewbutton: boolean = false;
  updatepreviewbutton: boolean = false;
  changetopad: boolean = false;
  invoicedraftData: any;
  paymentUri: any;
  paymentsuccessuri: any;
  publicapikey: any;
  paymentform2: any;
  recaptchaResponse: any;
  fusbillinfocaptchavalue: any;
  fullName: any;
  voidCheque1: any;
  voidCheque2: any;
  bankinformation: any;
  paymentMethodId: any;
  padAgreement: any;
  existVoid: any;
  review: any;
  fuseBillKey: any;
  voidCheckImage: any;
  voidCheckFileType: any;
  ccDetails: any;
  stateId: any;
  countryId: any;
  customerID: any;
  card: any;
  spouse: any;
  index: any = 1;
  lang: any = {};
  selectedLanguage: any;
  lang1: any = {};
  gender: any;
  dependentBackgroundColor: any[] = [];
  plans: any;
  benefits: any;
  unlistener: any;
  videoLink: any;
  videoTitle: any;
  videoPopup: any = 'none';
  iframeLink: any;
  iframeTitle: any;
  currentIndexOfSwipperDependents: any = 1;

  currentIndexOfSwipperDownload: any = 1;

  currentIndexOfSwipperPlan: any = 1;

  currentIndexOfSwipperBenifits: any = 1;
  @ViewChild('videoPlayer') videoplayer: any;

  public startedPlay: boolean = false;

  public show: boolean = false;
  logo: any;
  editSpouse: boolean = true;
  editChild: boolean = false;
  logoimage: any;
  headerName: any;
  voidCheckPdf: any;
  url: any;
  minAddPlanDate: any
  minDate: any;
  maxDate: any;
  minDatechild: Date = new Date();
  dependentTypeForm: FormGroup = new FormGroup({
    dependentType: new FormControl(''),
    marriageType: new FormControl(''),
    marriageDate: new FormControl(''),
    childrenCountData: new FormControl('0'),
    effectiveDate: new FormControl('')
  });
dependentType: string;
totalSummaryPrice: number;
addDependentWithSpouse: boolean;
totalCount: number;
  validateCheck: boolean;
  isMarried: boolean;
  childCount: number;
  showValidatePlans: boolean;
  showPlanDetails: boolean;
  showSpouseInfo: boolean;
  plansSummaryObj: any[];
  isCommonLaw: boolean;
  showChildForm: boolean;
  childrenDetails: any[];
  normalSpouseRegistration: boolean;
  normalDependentRegistration: boolean;
  marriageType: any;
;
  minDateHire: any;
  maxDatechild: Date = new Date();
  memberportalgreensShildCheck: any;
  memberportalEquitabelCheck: any;
  customerPlans: any;
  lifePlansData: any[];
  executivePlanOptions: any
  executivePlanOptionsValues: any[];
  addOptions:boolean=false;
  executivePlanOptionsValuesArray: any[];
  showexecutiveoptions: boolean = false;
  fubsillstatus: any;
  specialpackages: any = [{ groups: [{ plans: [] }] }];
  disabledelement: string;
  planobjdata: { packageId: any; packageName: any; planproductname: any; groupid: any; groupName: any; id: any; name: any; planLevel: any; planLevelParent: any; fusebillPlanID: any; planFrequencyID: any; isBundle: any; coverage: any; planCoverage: any; bundledProducts: any[]; products: any[]; };
  planssummarymain: any[];
  planssummaryopt: any[];
  plansskumain: any[] = [];
  cartcheckvalue: boolean;
  planAmount: any;
  plandetailsobjvalue: any;
  optionstitle: any[];
  optionmessage: any;
  showoptions: boolean = false;
  isFileUploaded: boolean;
  bankfile: any;
  Shared: any;
  pdfview: boolean;
  normalview: boolean;
  selectServiceError: boolean = false;
  servicesDetails: any;
  showProvider: boolean = false;
  providersArray: any = [];
  userName: any;
  showViewPlansLoading: boolean = true;
  showFifh: boolean = true;
  showLoadrForDownloadBookLets: boolean = true;
  showPadLoader: boolean = true;
  showVoidCheque: boolean = true;
  showvoidCheque2: boolean = true;
  achDetails: any;
  checkEmailKey: boolean = false;
  noService: boolean = false;
  provianceList: any;
  bankfileArray: any = [];
  secondaryphonecheck: boolean = false;
  customerType: any;
  showinvoiceMessage: any;
  getCustomerDraftDetails: any;
  getCustomerDraftDate: any = '';
  getCustomerDraftDate1: any = '';
  loader: boolean;
  plansError: boolean = false;
  addPlanEnrollmentDate: string;
  title: any;
  terminationDate: string;
  cancelPlanDetails: any;
  cancelPlan: any;
  planName: any;
  planprice: any;
  planSubscriptionId: any;
  taxEntries: { name: any; plan: any; price: any; }[];
  planCoverage: any;
  cancelPlanEnrollmentDates: any;
  addPlansConfigData: any;
  unselected: any = [];
  warningsData: any;
  multiUpload: boolean = false;
  multiUploadArray: any = []
  types: any = [];
  uploadError: boolean = false;
  typesError: boolean = false;
  ischildAccount: any;
  terminationDateValue: any;
  filterInvoice: any = 'All';
  filteredInvoices: any;
  terminationform: FormGroup = new FormGroup({
    reason: new FormControl(''),
    memberstatus: new FormControl(''),
    terminationDate: new FormControl(''),


  });
  terminationformDetails: FormGroup = new FormGroup({
    reason: new FormControl(''),
    memberstatus: new FormControl(''),
    terminationDate: new FormControl(''),
    proceedWithEquitable: new FormControl(''),
    proceedWithGreenshield: new FormControl(''),
    proceedWithPHR: new FormControl(''),
    proceedWithRefund: new FormControl(''),
    refundAmount: new FormControl(),
    proceedWithSmartchoice: new FormControl(''),
    proceedWithSubscriptionExpiry: new FormControl(''),
    proceedWithCancelCustomer: new FormControl(''),

  });
  brokerregform: FormGroup = new FormGroup({
    brokerName: new FormControl(''),
    profile: new FormControl(''),
    effectiveDate: new FormControl(''),


  })
  terminateReasonsWithKeys: any;
  terminateMemberDetails: any;
  terminateReasonsApplicable: any;
  terminationsProvisioning: any[];
  emplomentFirstName: any;
  emplomentLastName: any;
  planenrollmentdate: any;
  memberid: any;
  servicDetails: any;
  staxbillDetails: any;
  cardType: string = '';
  customerFinalInvoices: any = [];
  invoiceMonthsList: any = [];
  customerFinalInvoices1: any = [];
  customerFinalInvoicesIGBMS: any = [];
  allCustomerFinalInvoices1: any = [];
  allCustomerFinalInvoicesIGBMS: any = [];
  filterDateSelection: any = "";
  maxDateForPicker: Date;
  currentYear:any;
  public invalidcreditcard: boolean = false;

  invalidcreditcarddetails: boolean = false;
    planoptionValues: any;
    selectedExecutiveOptions: any;
    additionalDetails: any
    showIAFG: boolean = false;
    ParentBrokerId: any;
    updatedBrokerId: any;
    brokerProfileslistSearch: any;
    profileid: any;
    brokerProfileslist1: any;
  // @ViewChild('content') content: any;
  restLoader: boolean = true;
    loading$: Observable<boolean>;
    error$: Observable<string | null>;
    membersData$: Observable<any>;
    private destroy$ = new Subject<void>();
    sortColumn: string = '';
    sortOrder: 'ASC' | 'DESC' = 'ASC';
    members: any=[];
    languageData$: Observable<any>;
    memberFormConfigData$: Observable<any>;
    fileUpload: any = "null";
    applicationFile: any = "";
    ccExpiryTitle: any = "";
    ccExpiryColor: any = "";
    inviteEmails: any = [];
    newEmail: any = '';
    primaryEmail: any = '';
    beneficiaries: any = '';
    latestPaymentStatus: string|null = null;
    isReauth: boolean = false;
    isRetryPayment: boolean = false;
    paymentPlatform: any = 'Staxbill';
    authorizenetCustomerId: any;
    igbmsId: any;


    selectedInvoice: any;
selectedInvoiceLink: string = '';
showInvoiceModal = false;



  constructor(private logger: LoggerService, private _CustomDatePipe: CustomDatePipe,
    private http: HttpClient, private renderer: Renderer2,
    private toastrService: ToastrService,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private titleCase: TitleCasePipe,
    private SharedService: SharedService,
    private phoneNoFormat: PhoneFormatPipe,
    private route: ActivatedRoute,
    // private maskNumber: MaskNumberPipe,
    private sanitizer: DomSanitizer,
    private renderer2: Renderer2,
    private router: Router,
    private authorizeNetService: AuthorizeNetService,
    private _decimalPipe: DecimalPipe,
    public elementRef: ElementRef,
    public _LoaderService: LoaderService,
    private commonPatternsService: CommonPatternsService,
    private globalStoreService: GlobalStoreService,
    private store: Store<{ memberData: [], languageData: [], memberFormConfigData: [] }>
    ) {
      this.membersData$ = store.select(selectMemberData);
      this.loading$ = store.select(selectMemberLoading);
      this.error$ = store.select(selectMemberError);
      this.languageData$ = store.select(selectLanguageData);
      this.memberFormConfigData$ = store.select(selectMemberFormConfigData);
    }
  ngOnInit() {
    setTimeout(()=>{
      sessionStorage.setItem('pageName', 'View Member');
    },100)
        this.store.dispatch(loadMemberData());

        this.membersData$ = this.store.select(state => state.memberData).pipe(
            // startWith([]),
            // takeUntil(this.destroy$)
        );
        this.currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth();
        this.maxDateForPicker = new Date(this.currentYear, currentMonth + 1);
        this.membersData$.subscribe(data => {
            if(data){
              console.log(data)
              if (data?.memberData == undefined || Object.keys(data.memberData).length <= 0) {
                console.log('No data to process', new Date().toISOString());
                return;
              }
              if(this.members.length>0){
                return;
              }
              const role = sessionStorage.getItem('role');
              if (role == 'ADMINISTRATOR') {
                // this.members = decompress(data.memberData);
                this.members = data.memberData;
                this.members = this.members.map(res=>{
                  return {
                    ...res,
                    isCorporateAccount: res.isCorporateAccount == null || res.isCorporateAccount == undefined ? false : res.isCorporateAccount,
                  }
                })
              } else {
                this.members = data.memberData.map(res => {
                  return {
                    ...res,
                    username: res.user?.username,
                    primaryPhone: res?.contactInformations?.[0]?.primaryPhone || '',
                    isCorporateAccount: res.isCorporateAccount == null || res.isCorporateAccount == undefined ? false : res.isCorporateAccount,
                  };
                });
              }
            }
        })


    this.getLanguageTokens();
    this.closePlans()
    this.terminationform = this.formBuilder.group({
      reason: [''],
      memberstatus: [''],
      terminationDate: ['', [Validators.required],],
    });
    this.brokerregform = this.formBuilder.group({

      brokerName: ['', [Validators.required]],
      profile: ['', [Validators.required]],
      effectiveDate: ['', [Validators.required]],
    });



    this.route.paramMap.subscribe(params => {
      console.log({ params })
      this.customerid = params.get('id');
      sessionStorage.setItem("customerId", this.customerid);

    });
    console.log({ cc: this.customerid })


    this.minDate = moment().subtract(74, "years").calendar();
    this.maxDate = moment().subtract(16, "years").calendar();

    this.minDate = new Date(this.minDate);

    this.maxDate = new Date(this.maxDate);

    this.minDateHire = moment().subtract(60, "years").calendar();

    // this.minDatechild = new Date(this.minDateHire);
    // this.maxDatechild = new Date();

    this.dependentTypeForm = this.formBuilder.group({
      dependentType: ['', [Validators.required]],
      marriageType: ['', [Validators.required]],
      marriageDate: ['', [Validators.required]],
      childrenCountData: [{ value: 0, disabled: true }],
      effectiveDate: ['', [Validators.required]]
    })

    this.minDatechild = new Date();
    const today = new Date();
    this.minDatechild.setFullYear(today.getFullYear() - 21);
    this.minDatechild.setMonth(0); // January
    this.minDatechild.setDate(1); // 1st

    // Set maxDate to December 31st, 2030
    // const today = new Date();
    // let today1 = new Date(today.getFullYear(), today.getMonth(), today.getDate())
    this.maxDatechild = new Date();
    this.maxDatechild.setFullYear(today.getFullYear());
    this.maxDatechild.setMonth(new Date().getMonth()); // December
    this.maxDatechild.setDate(new Date().getDate()); // 31st
    this.getFormConfiguration('en');
    this.dependentBackgroundColor = ["#E6D1FF",
      "#FFE2FB",
      "#E2F1FF",
      "#E6D1FF",]
    // this.customerid = sessionStorage.getItem('customerId');
    this.accessToken = sessionStorage.getItem('accessToken');
    this.getCustomerData();

    // this.getServiceWorkerDetails();


    // this.getInvoices();
    // this.getDraftInvoice();
    // this.getHealthBooklets();
    // this.getPlanes();
    // this.getbenefits();
    // this.route.queryParams.subscribe(params => {
    //     console.log({ params });
    // })


    this.logoimage = sessionStorage.getItem("logo")
    this.unlistener = this.renderer2.listen("document", "click", event => {
      console.log(event)
      let element = event.target
      var attribute = element.getAttribute("href");
      var heading = element.innerText;
      // this.videoPopup = 'block';
      if (event.target.className == 'video') {
        event.preventDefault();
        this.videoLink = attribute;
        this.videoTitle = heading;
        console.log(this.videoLink)
        console.log(this.videoTitle)
        var video = document.getElementsByTagName('video')[0];
        console.log(video)

        this.openVideoPopup();
        video.load();
        video.play();
      }
      if (event.target.className == 'shortlink') {
        this.openSupportPopup();
        // this.support_link = this.sanitizer.bypassSecurityTrustResourceUrl(attribute);
        event.preventDefault();
      }
      if (event.target.className == 'booklet') {
        this.openequitablePopup();
        event.preventDefault();
        this.booklet_link = element.getAttribute("href");
      }
      if (event.target.className == 'healthcard') {
        this.downloadCard();
        event.preventDefault();
        this.health_card = element.getAttribute("href");
      }
      if (event.target.classList.contains('closevideo')) {
        var video = document.getElementsByTagName('video')[0];
        video.pause();
      }
      if (event.target.className == 'closevideo') {
        var video = document.getElementsByTagName('video')[0];
        video.pause();
      }
      if (event.target.className == 'drugsmart') {
        event.preventDefault();
        window.open("https://drugsmart-pharmacy.myshopify.com/account/register",
          "Register Direct2U pharma", "menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
      }
      if (event.target.className == 'bedrugsmart') {
        event.preventDefault();
        window.open("https://bedrugsmart.ca/pages/direct2u",
          "Direct2U pharma", "menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
      }
      if (event.target.classList.contains('site')) {
        console.log('attribute', attribute)
        console.log(typeof attribute)
        console.log(attribute == 'unsafe: https://www.myfriendlylawyer.com/subscriptions')
        console.log(attribute == 'https://www.myfriendlylawyer.com/subscriptions')
        if (attribute == 'unsafe: https://www.myfriendlylawyer.com/subscriptions') {
          attribute = 'https://www.myfriendlylawyer.com/subscriptions';
        }
        console.log('afterattribute', attribute)
        // this.iframeLink = this.sanitizer.bypassSecurityTrustResourceUrl(attribute)
        this.iframeTitle = heading;
        // console.log(this.iframeLink.changingThisBreaksApplicationSecurity)
        // if(this.iframeLink.changingThisBreaksApplicationSecurity != 'https://secure.kiihealth.ca/register?eac=BNFZ1222&locale=en' && this.iframeLink.changingThisBreaksApplicationSecurity != 'https://groupbenefitz.lifespeak.com' && this.iframeLink.changingThisBreaksApplicationSecurity != 'http://my.norton.com/') {
        //   console.log(this.iframeLink.changingThisBreaksApplicationSecurity != 'https://secure.kiihealth.ca/register?eac=BNFZ1222&locale=en')
        //   this.openiframePopup();
        // }
        // if(this.iframeLink.changingThisBreaksApplicationSecurity == 'https://secure.kiihealth.ca/register?eac=BNFZ1222&locale=en') {
        //   window.open ("https://secure.kiihealth.ca/register?eac=BNFZ1222&locale=en","CloudMDKii","menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
        // }
        // if(this.iframeLink.changingThisBreaksApplicationSecurity == 'https://groupbenefitz.lifespeak.com') {
        //   window.open ("https://groupbenefitz.lifespeak.com","LifeSpeak","menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
        // }
        // if(this.iframeLink.changingThisBreaksApplicationSecurity == 'http://my.norton.com/') {
        //   window.open ("http://my.norton.com/","Norton","menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
        // }
        event.preventDefault();
      }
      // alert(attribute);

      // alert(heading);
      // document.getElementsByClassName("vid-title")[0].innerText=heading;
      // document.getElementsByTagName("source")[0].src=attribute;



      // var video = document.getElementsByTagName('video')[0];



      // video.load();
      // video.play();
    });

    this.fusbillinfocaptchavalue = '6LfVtGwUAAAAALHn9Ycaig9801f6lrPmouzuKF11';
    // this.fusbillinfocaptchavalue = '6Lfj88QgAAAAAAJ8bY1NW0Bgmm9V8PV2onC4RCNx';
    this.url = window.origin + "/";
    this.paymentUri = this.url + "manageMembers/employee/5334/details";;

    this.paymentsuccessuri = this.url + "manageMembers/employee/5334/details";



    // this.customerid = sessionStorage.getItem("customerId");


    this.phoneform = this.formBuilder.group({
      primaryPhone: ['', [Validators.required, Validators.minLength(14), Validators.maxLength(14)]],
      secondaryPhone: ['', [Validators.minLength(14), Validators.maxLength(14)]],
    });

    this.uploadService = this.formBuilder.group({
      uploadhealthCard: [null, Validators.compose([Validators.required])],
      uploadhealthCardProvider: [null],
      uploadhealthCardFile: ['', Validators.required]
    })

    this.uploadApplication = this.formBuilder.group({
      uploadApplicationType: [null, Validators.compose([Validators.required])],

      uploadApplicationFile: ['', Validators.required]
    })

    this.emailForm = this.formBuilder.group({
      newEmail: [
        '',
        [
          Validators.pattern(this.commonPatternsService.emailPattern)  // Email pattern from service
        ]
      ]
    });


    this.addressform = this.formBuilder.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      line1: ['', [Validators.required]],
      line2: [''],
      city: ['', [Validators.required]],
      country: ['', [Validators.required]],
      gender: ['', [Validators.required]],
      dob: ['', [Validators.required]],
      province: ['', [Validators.required]],
      postalCode: ['', [Validators.required, postalcodeValidator]],
      primaryPhone: ['', [Validators.required, Validators.minLength(17), Validators.maxLength(17)]],
      secondaryPhone: ['', [Validators.minLength(17), Validators.maxLength(17)]],
      email: ['', [Validators.required, Validators.pattern(this.commonPatternsService.emailPattern)],
      ],

    });

    this.spouseform = this.formBuilder.group({
      firstName: ['', [Validators.required, Validators.minLength(1)]],
      lastName: ['', [Validators.required, Validators.minLength(1)]],
      dob: ['', [Validators.required]],
      email: ['', [Validators.pattern(this.commonPatternsService.emailPattern)]],

      coveredByAnotherPlan: ['', [Validators.required]],
      healthPlan: ['', [Validators.required]],
      insurer: ['', [Validators.required]],
      martialStatus: ['', [Validators.required]],
      effectiveDate: ['', [Validators.required]],
      gender: ['', [Validators.required]],
    });

    this.dependentform = this.formBuilder.group({
      firstName: ['', [Validators.required, Validators.minLength(1)]],
      lastName: ['', [Validators.required, Validators.minLength(1)]],
      gender: ['', [Validators.required]],
      dob: ['', [Validators.required,childrenminimumAgeValidator]],
      age: [''],
      phoneNum: [''],
      coveredByAnotherPlan: ['', [Validators.required]],
      graduationDate: [''],
      carrierName: ['', [Validators.required]],
      specialNeeds: [''],
      postSecondaryStudent: [''],
      // martialStatus: ['', [Validators.required]],
      effectiveDate: ['', [Validators.required]],
    });

    this.paymentform = this.formBuilder.group({
      cutomerId: [""],
      // Id: [""],
      PublicApiKey: [""],
      SuccessUri: [""],
      FailUri: [""],
      FirstName: ["", [Validators.required]],
      LastName: ["", [Validators.required]],
      email: ["", [Validators.required]],
      CardNumber: ["", [Validators.required, Validators.minLength(17), Validators.maxLength(17)]],
      ExpirationMonth: ["", Validators.required],
      ExpirationYear: ["", Validators.required],
      Cvv: ["", Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(4)])],
      recaptchaReactive: ["", Validators.required],
    })

    this.ccform = this.formBuilder.group({
      cutomerId: [""],
      Id: [""],
      PublicApiKey: [""],
      SuccessUri: [""],
      FailUri: [""],
      FirstName: ["", [Validators.required]],
      LastName: ["", [Validators.required]],
      email: [""],
      CardNumber: ["", [Validators.required, Validators.minLength(17), Validators.maxLength(17)]],
      ExpirationMonth: ["", Validators.required],
      ExpirationYear: ["", Validators.required],
      Cvv: ["", Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(4)])],
      nameonthecard: [""],
      aptcheck: [""],
      streetaddress: [""],
      streetaddressline2: [""],
      city: [""],
      countryId: [""],
      stateId: [""],
      postalcode: [""],
      recaptchaReactive: ["", Validators.required],
    });

    this.padform = this.formBuilder.group({
      bankcode: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(3)]],
      transitNumber: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]],
      accountNo: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(12)]],
      bankdetails: [''],
      file: [''],
    })

    this.paymentMethodForm = this.formBuilder.group({
      bankCode: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(3)]],
      branchCode: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]],
      accountNumber: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(12)]],
      files: [''],
      paymentmethod: [''],
    })

    this.valisignform = this.formBuilder.group({
      code: ['', [Validators.required, Validators.minLength(6)]],
    })

    this.addPlanForm = this.formBuilder.group({

      planEnrollmentDate: [
        '',
        [Validators.required],
      ],

    });
    this.cancelPlanForm = this.formBuilder.group({

      terminationDate: [
        '',
        [Validators.required],
      ],

    });

    this.cancelplanFormDetails = this.formBuilder.group({
      reason: [''],
      memberstatus: [''],
      terminationDate: [''],
      proceedWithEquitable: [true],
      proceedWithGreenshield: [true],
      proceedWithPHR: [true],
      proceedWithRefund: [''],
      proceedWithSmartchoice: [true],
      proceedWithSubscriptionExpiry: [''],
      proceedWithCancelCustomer: [''],
    });
    this.addplanFormDetails = this.formBuilder.group({
      reason: [''],
      memberstatus: [''],
      terminationDate: [''],
      proceedWithEquitableTermination: [true],
      proceedWithEquitableRegistration: [true],
      proceedWithGreenshieldTermination: [true],
      proceedWithGreenshieldRegistration: [true],
      proceedWithRefund: [''],
      proceedWithSmartchoice: [false],
      proceedWithSubscriptionExpiry: [''],
      proceedWithCancelCustomer: [''],
    });


    this.route.queryParams.subscribe((params) => {
      if (params["success"]) {
        if (params["success"] == "False") {

          setTimeout(() => {
          }, 10);
          Swal.fire({
            allowOutsideClick: false,
            title: this.lang?.An_error_occurred_while_processing_the_transaction_possible_failure_reasons_are,
            text: this.lang?.The_payment_information_could_not_be_verified,
            icon: "warning",
            width: "50%",
            showCancelButton: false,
            confirmButtonText: "Ok",
            cancelButtonText: "No",
          }).then((result) => {
            if (result.value) {
              this.router.navigate(["home"]);
            } else {
            }
          });
        }
        else {
          let Endpoint = '/' + this.customerid + '/paymentType/CREDIT_CARD/change';
          this.http.post(environment.apiUrl + '/api/ap' + Endpoint, { "paymentId": parseInt(params["paymentMethodId"]) }, {
            headers: {
              Authorization: 'Bearer ' + this.accessToken,
            }
          }).subscribe((response: any) => {
            if (response.status == 200) {
              this.getCustomerData();
              Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
            }
            else {
              Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
            }
          }, (error) => {
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
          });


        }
      }
    });
  }

  getBrokerProfiles(brokerId: any) {
    var brokerId = brokerId
    this.updatedBrokerId = brokerId;
    var endPoint = '/api/ap/broker/' + brokerId + '/profiles';
    var accessToken = sessionStorage.getItem('accessToken');

    this.http
      .get(environment.apiUrl + endPoint, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe((response: any) => {
        if (response['status'] == 200) {

          this.brokerProfileslistSearch = this.parseAllValuesInArray(response.data.profiles);
          // console.log(this.brokerProfileslist)

          this.profileid = this.brokerProfileslist1?.originalBrokerId
        }
      });
  }

  getDefaultEmails() {
    var brokerId = brokerId
    this.updatedBrokerId = brokerId;
    var endPoint =' /member/{memberId}/email-configurations/{type}'
    var accessToken = sessionStorage.getItem('accessToken');

    this.http
      .get(environment.apiUrl + endPoint, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe((response: any) => {
        if (response['status'] == 200) {

          this.brokerProfileslistSearch = this.parseAllValuesInArray(response.data.profiles);
          // console.log(this.brokerProfileslist)

          this.profileid = this.brokerProfileslist1?.originalBrokerId
        }
      });
  }



  
  get dependenttypeForm() {
    return this.dependentTypeForm.controls;
  }

  parseAllValuesInArray(arr: any[]): any[] {
    return arr.map(obj => {
      const parsedObj: any = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          try {
            parsedObj[key] = JSON.parse(obj[key]);
          } catch (e) {
            parsedObj[key] = obj[key]; // If parsing fails, retain original value
          }
        }
      }
      return parsedObj;
    });
  }
  terminationformDetailsValidations() {
    this.terminationformDetails = this.formBuilder.group({
      reason: ['', [Validators.required],],
      memberstatus: ['', [Validators.required],],
      terminationDate: ['', [Validators.required],],
      proceedWithEquitable: [''],
      proceedWithGreenshield: [''],
      proceedWithPHR: [''],
      proceedWithRefund: [''],
      refundAmount: [''],
      proceedWithSmartchoice: [''],
      proceedWithSubscriptionExpiry: [''],
      proceedWithCancelCustomer: [''],


    });
  }
  get client() {
    return this.brokerregform.controls;
  }
  public note: string = ""
  public enroll: any


  setMinDateBasedOnRoleAndStatus(client: any) {
    const today = new Date();
    if (this.role === 'BROKER') {
      this.minDate = today;
      this.note = "Required backdated selection contact Administrator"
      return
    } else if (this.role === 'ADMINISTRATOR') {
      const threeMonthsFromNow = new Date(today.setMonth(today.getMonth() - 3));
      this.minDate = new Date(threeMonthsFromNow.getFullYear(), threeMonthsFromNow.getMonth(), 1);

      if (client.status === "Active" && client.enrollmentDate) {
        this.enroll = new Date(client.enrollmentDate)
        this.logger.log(this.minDate <= this.enroll)

        if (this.minDate <= this.enroll && this.enroll < new Date()) {
          this.minDate = this.enroll
          this.note = 'enrollment date is the earliest selection'
          this.logger.log("mindate", this.minDate)
          return
        }

        if (this.minDate < this.enroll && this.enroll >= new Date()) {
          this.minDate = new Date()
          this.note = 'Today is the earliest selection'
          this.logger.log("mindate", this.minDate)
          return
        }
        this.note = "Can select from 3 months from the past"
      }
      if (client.status === "Draft") {
        this.minDate = null
        this.note = ""
        return
        // this.logger.log("mindate draft", this.minDate)
      }
      this.logger.log("mindate", this.minDate)
    }

  }

  terminatemember() {
    this.terminationform.reset();
    this.setMinDateBasedOnRoleAndStatus(this.customerData);
    this.emplomentFirstName = this.customerData?.firstName;//this.customerData?.name;
    this.emplomentLastName = this.customerData?.lastName;//this.customerData?.name;
    this.planenrollmentdate = this.customerData?.customerSignup?.enrollmentDate
    this.memberid = this.customerData?.id;
    $("#showmemberlist").modal('show');

  }

  closeModelPopup(id: any) {
    $('#' + id).modal('hide');
  }


  submitterminationEnd() {
    this.terminateMemberDetails.proceedWithGreenshield = this.terminationformDetails.get('proceedWithGreenshield').value
    this.terminateMemberDetails.proceedWithRefund = this.terminationformDetails.get('proceedWithRefund').value
    this.terminateMemberDetails.refundAmount = this.terminationformDetails.get('refundAmount').value
    this.terminateMemberDetails.proceedWithSmartchoice = this.terminationformDetails.get('proceedWithSmartchoice').value
    this.terminateMemberDetails.proceedWithSubscriptionExpiry = this.terminationformDetails.get('proceedWithSubscriptionExpiry').value
    this.terminateMemberDetails.proceedWithCancelCustomer = this.terminationformDetails.get('proceedWithCancelCustomer').value
    this.terminateMemberDetails.proceedWithEquitable = this.terminationformDetails.get('proceedWithEquitable').value
    this.terminateMemberDetails.proceedWithPHR = this.terminationformDetails.get('proceedWithPHR').value

    let data = {
      'data': this.terminateMemberDetails,
      'reason': this.terminationformDetails.get('reason').value ?? " ",
    };
    // console.log({ data })
    // this.logger.log(this.terminationform.value)
    // return
    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    var terminate = '/api/ap/member/' + this.memberid + '/confirmMemberTermination';
    var headers = {
      Authorization: 'Bearer ' + accessToken,
      'Content-Type': 'application/json',
    };

    this.http.post(environment.apiUrl + terminate, data, { headers: headers })
      .subscribe(async (responce: any) => {
        this.logger.log("entering")
        console.log({ responce })

        if (responce.status == '200') {
          this.http.get(environment.apiUrl + '/api/ap/global/set-adminMembers').subscribe((newResponse) => {
          // this.http.post(environment.apiUrl + '/api/ap/v3/global/set-adminMembers',{id:this.customerid}).subscribe((newResponse) => {
            this.http.post(environment.reportApiUrl + '/websocket/member/notification-to-others', {
              "message": "Members information has been updated. Please refresh screen."
            }, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              }
            }).subscribe((res) => {
              console.log({ res })
            })
          })
          var details = '/api/ap/admin/customers/list';

          // await postServiceWorkerMessage(WorkerMessageType.Delete, [
          //   environment.apiUrl + details
          // ]);

          // this.getclientList();
          this.getCustomerData()
          // this.getServiceWorkerDetails()
          $("#DataTables_Table_0").dataTable().fnDestroy();
          Swal.fire({ title: this.lang?.Info, html: responce.message }).then(async (res) => {
            if (res.isConfirmed) {



              // this.dtTrigger.next(null);
            }
          });
          $('#showTerminateMemberDetails').modal('hide');

        } else {
          Swal.fire({ title: this.lang?.Info, text: responce.message });
        }

      }, (error) => {
        Swal.fire({ title: this.lang?.Error, text: error.message || error.data.message });
      })
  }
  closeTerminatePopup(id: any) {
    $(`#${id}`).modal("hide");
    this.terminationform.reset();
  }


  isDisabled() {
    const checkVal = this.staxbillDetails ? this.staxbillDetails.refundApplicable == false ? true : false : true
    return checkVal;
  }


  submittermination() {

    if (this.terminationform.invalid) {
      this.terminationform.markAllAsTouched()
      this.toastrService.error(`${this.lang?.Minimium_Date} : ${moment(this.minDate).format('MM-DD-YYYY')} \n Note: ${this.note}`);
      this.logger.log(this.terminationform.controls)
      return
    }
    this.logger.log(this.terminationform.value)
    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    var terminate = '/api/ap/member/' + this.memberid + '/configureMemberTermination';

    let data = {
      "reason": this.terminationform.value.reason,
      "memberStatus": this.terminationform.value.memberstatus,
      "terminationDate": this.datePipe.transform(
        this.terminationform.value.terminationDate,
        'yyyy-MM-dd'
      ) || ''
    }
    let terminateDate = this.datePipe.transform(this.terminationform.value.terminationDate, 'yyyy-MM-dd') || ''


    let queryParams = new HttpParams();
    queryParams = queryParams.append("terminationDate", terminateDate);
    this.http
      .get(environment.apiUrl + terminate, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
        params: queryParams
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminMembers').subscribe((newResponse) => {
            // this.http.post(environment.apiUrl + '/api/ap/v3/global/set-adminMembers',{id:this.customerid}).subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/member/notification-to-others', {
                "message": "Members information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })
            $("#showmemberlist").modal('hide');
            $('#showTerminateMemberDetails').modal('show');

            this.terminateMemberDetails = response.data;

            // alert(this.terminateMemberDetails.serviceType)

            this.logger.log("asasasa", this.terminateMemberDetails);
            this.terminateReasonsApplicable = this.terminateMemberDetails.terminateReasonsApplicable;
            this.servicDetails = this.terminateMemberDetails.serviceDetails;
            this.terminateReasonsWithKeys = response.data.terminateReasonsWithKeys;
            this.logger.log('terminateReasonsWithKeys', this.terminateReasonsWithKeys);
            this.staxbillDetails = this.terminateMemberDetails.staxbillDetails;

            let proceedWithEquitable = this.terminateMemberDetails.proceedWithEquitable;
            let proceedWithGreenshield = this.terminateMemberDetails.proceedWithGreenshield;
            let proceedWithPHR = this.terminateMemberDetails.proceedWithPHR
            let proceedWithRefund = this.terminateMemberDetails.proceedWithRefund;
            let refundAmount = this.staxbillDetails.refundAmount == 'NA' ? "N/A" : this.staxbillDetails.refundAmount;
            let proceedWithSmartchoice = this.terminateMemberDetails.proceedWithSmartchoice;
            let proceedWithSubscriptionExpiry = this.terminateMemberDetails.proceedWithSubscriptionExpiry;
            let proceedWithCancelCustomer = this.terminateMemberDetails.proceedWithCancelCustomer;

            this.terminationsProvisioning = response.data.terminationsProvisioning

            this.terminationformDetails.get('proceedWithEquitable').setValue(proceedWithEquitable);
            this.terminationformDetails.get('proceedWithPHR').setValue(proceedWithPHR);
            this.terminationformDetails.get('proceedWithGreenshield').setValue(proceedWithGreenshield);
            this.terminationformDetails.get('proceedWithRefund').setValue(proceedWithRefund);
            this.terminationformDetails.get('refundAmount').setValue(refundAmount);
            this.terminationformDetails.get('proceedWithSmartchoice').setValue(proceedWithSmartchoice);
            this.terminationformDetails.get('proceedWithSubscriptionExpiry').setValue(proceedWithSubscriptionExpiry);
            this.terminationformDetails.get('proceedWithCancelCustomer').setValue(proceedWithCancelCustomer);

            for (let control of Object.keys(this.terminationformDetails.controls)) {
              this.terminationformDetails.get(control).updateValueAndValidity();
            }
            // Swal.fire({ title: this.lang?.Info, text: response.message })

          } else {
            Swal.fire({ title: this.lang?.Error, text: response.message })
          }
        }, (error) => {
          if (error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang?.Error,
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: true,
              confirmButtonText: this.lang?.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            Swal.fire({ title: this.lang?.Error, text: error.error.error.message });
          }
        }
      );
  }


  showplans() {
    $("#planDetails").show()

  }

  public getLanguageTokens() {
    // let body = {
    //   "project": "Admin Portal",
    //   "url": "manageMembers/employee"
    // }
    // this.http
    //   .post('https://languageengineapi.aitestpro.com/string/project-url-strings', body, {
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //   })
    //   .subscribe(
    //     (response: any) => {
    //       // console.log(response)
    //       this.lang = {};
    //       // this.selectedLanguage = "English"
    //       this.selectedLanguage = sessionStorage.getItem('language') || 'English'
    //       for (let token of response.strings) {
    //         this.lang[token.key] = token[this.selectedLanguage];
    //       }
    //       console.log(this.lang)
    //     }
    //   )

    // this.store.dispatch(loadLanguageData());

    this.languageData$ = this.store.select(state => state.languageData).pipe(
      startWith([]),
      takeUntil(this.destroy$)
    );

    this.languageData$.subscribe(data => {
      if(data){
        // console.log(data)
        if (data?.languageData == undefined || Object.keys(data.languageData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        // if(Object.keys(this.lang).length>0){
        //   return;
        // }
        setTimeout(()=>{
          this.lang = {};
          // this.languageData = data?.languageData
          this.selectedLanguage = sessionStorage.getItem("language")
          for (let token of data?.languageData) {
            this.lang[token.key] = token[this.selectedLanguage];
          }
          // console.log('this.lang',this.lang)
        },0)
      }
    })
  }

  pauseVideo(videoplayer: any) {

    videoplayer.nativeElement.play();

    // this.startedPlay = true;

    // if(this.startedPlay == true)

    // {

    setTimeout(() => {

      videoplayer.nativeElement.pause();

      if (videoplayer.nativeElement.paused) {

        this.show = !this.show;

      }

    }, 5000);

    // }

  }

  viewPlansLoading(e: any) {
    this.showViewPlansLoading = false;
  }
  showLoaderfith(e: any) {
    this.showFifh = false;
  }
  padLoader(e: any) {
    this.showPadLoader = false;
  }
  LoadrForDownloadBookLets($event) {
    this.showLoadrForDownloadBookLets = false
  }

  // ngAfterViewInit() {
  //   // no errors
  //   let elems = document.querySelectorAll('.carousel');
  //   let instances = M.Carousel.init(elems, this.options);
  // }

  get phoneForm() {
    return this.phoneform.controls;
  }

  pipeFunction = (
    a: KeyValue<string, [string]>,
    b: KeyValue<string, [string]>
  ): number => {
    return 0;
  };

  get addressForm() {
    return this.addressform.controls;
  }

  get spouseForm() {
    return this.spouseform.controls;
  }

  get dependentForm() {
    return this.dependentform.controls;
  }

  get paymentMethodControls() {
    return this.paymentMethodForm.controls;
  }

  get valisignControls() {
    return this.valisignform.controls;
  }

  get paymentForm() {
    return this.paymentform.controls;
  }

  get ccForm() {
    return this.ccform.controls;
  }

  get padForm() {
    return this.padform.controls;
  }

  loadFormConfig(formConfigData: any) {
    this.executivePlanOptionsValues = formConfigData?.executivePlanOptions
    this.formConfiguration = formConfigData;
    this.provianceList = this.formConfiguration.states.filter((list) => {
      if (list.countryId == 1)
        return list
    });

    this.logo = this.formConfiguration.customerTiles;
    this.planEnrollmentDates = this.formConfiguration.validations.customer.addPlanEnrollmentDatesFullMonth
    this.cancelPlanEnrollmentDates = [this.formConfiguration.validations.customer.addPlanEnrollmentDatesFullMonth[0]]
    // this.cancelPlanEnrollmentDates = delete this.cancelPlanEnrollmentDates[0];
    let tokens = this.formConfiguration.language_details.languageTokens;
    // this.servicesDetails = formConfigData.healthcard_services_with_providers
    let array = []
    // array.push(Object.keys(this.servicesDetails))
    console.log(array)
    this.serviceDetailsarray = array
    for (let token of tokens) {
      this.lang1[token.key] = token.value;
    }
    console.log(this.lang1)
    this.configprovinceres = [...formConfigData?.states].sort(
      (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
    );
  }

  // getFormConfiguration(lang: any) {
  //   // let lang: any = 'en';
  //   // if(this.route.snapshot.queryParamMap.get('lang') != null) {
  //   //  lang = this.route.snapshot.queryParamMap.get('lang');
  //   // }
  //   const formConfigData = this.globalStoreService.getCustomerFormConfig()
  //   console.log({ formConfigData })

  //   if (Object.keys(formConfigData).length != 0) {
  //     this.loadFormConfig(formConfigData)
  //   } else {
  //     this._LoaderService.ShowLoader()
  //     let accessToken = sessionStorage.getItem('accessToken');
  //     let customerDataEndpoint = '/customer/formConfig';
  //     this.http.get(environment.apiUrl + '/api/ap' + customerDataEndpoint, {
  //       headers: {
  //         Authorization: 'Bearer ' + accessToken,
  //         'Content-Type': 'application/json',
  //         'Lang': lang,
  //       }
  //     }).subscribe((response: any) => {

  //       if (response.status == 200) {
  //         this.executivePlanOptionsValues = response.data.executivePlanOptions
  //         this.formConfiguration = response.data;

  //         // this.allbrokerslist =this.formConfiguration.allBrokersUnique


  //         this.provianceList = this.formConfiguration.states.filter((list) => {
  //           if (list.countryId == 1)
  //             return list
  //         });

  //         this.logo = this.formConfiguration.customerTiles;
  //         this.planEnrollmentDates = this.formConfiguration.validations.customer.addPlanEnrollmentDatesFullMonth
  //         this.cancelPlanEnrollmentDates = [this.formConfiguration.validations.customer.addPlanEnrollmentDatesFullMonth[0]]
  //         // this.cancelPlanEnrollmentDates = delete this.cancelPlanEnrollmentDates[0];

  //         let tokens = this.formConfiguration.language_details.languageTokens;
  //         // this.servicesDetails = response.data.healthcard_services_with_providers
  //         let array = []
  //         // array.push(Object.keys(this.servicesDetails))
  //         console.log(array)
  //         this.serviceDetailsarray = array
  //         for (let token of tokens) {
  //           this.lang1[token.key] = token.value;
  //         }
  //         console.log(this.lang1)
  //         this.configprovinceres = response.data.states.sort(
  //           (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
  //         );
  //         this._LoaderService.HideLoader()
  //         this.globalStoreService.setFormConfig('customer', lang, response.data)
  //       }
  //       else {
  //         Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
  //       }
  //     }, (error) => {
  //       Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
  //     });
  //     this._LoaderService.HideLoader()
  //     // const formConfigData = this.globalStoreService.getCustomerFormConfig()
  //     // this.loadFormConfig(formConfigData)
  //   }

  // }
  getFormConfiguration(lang: any) {
    this.store.dispatch(memberFormConfigData());
    this.memberFormConfigData$ = this.store.select(state => state.memberFormConfigData).pipe(
      // startWith([]),
      // takeUntil(this.destroy$)
    );
    // this._LoaderService.ShowLoader();
    this.memberFormConfigData$.subscribe(data => {
      if (data) {
        console.log(data)
        if (data?.memberFormConfigData == undefined || Object.keys(data.memberFormConfigData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        if (Object.keys(this.formConfiguration).length > 0) {
          return;
        }
        console.log('memberFormConfigData', data.memberFormConfigData)
        this.formConfiguration = { ...data.memberFormConfigData }
        this.loadFormConfig(this.formConfiguration);

        this.executivePlanOptionsValues = this.formConfiguration.executivePlanOptions

        this.provianceList = [...this.formConfiguration.states].filter((list) => {
          if (list.countryId == 1)
            return list
        });

        this.logo = this.formConfiguration.customerTiles;
        this.planEnrollmentDates = this.formConfiguration.validations.customer.addPlanEnrollmentDatesFullMonth
        this.cancelPlanEnrollmentDates = [this.formConfiguration.validations.customer.addPlanEnrollmentDatesFullMonth[0]]
        // this.cancelPlanEnrollmentDates = delete this.cancelPlanEnrollmentDates[0];

        // this.servicesDetails = response.data.healthcard_services_with_providers
        let array = []
        // array.push(Object.keys(this.servicesDetails))
        console.log(array)
        this.serviceDetailsarray = array
        this.configprovinceres = [...this.formConfiguration.states].sort(
          (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
        );
        // this._LoaderService.HideLoader()
      } else {
        console.error('Observable returned undefined');
      }
    })
  }

  // getServiceWorkerDetails() {
  //     let customerDataEndpoint = '/customer/' + this.customerid + '/details';


  //     let prefetchurls = []

  //     let Data = [{
  //         url: environment.apiUrl + '/api/ap/admin' + customerDataEndpoint,
  //         // fetch options
  //         options: {

  //             mode: 'cors',
  //             headers: {

  //                 Authorization: 'Bearer ' + sessionStorage.getItem('accessToken'),
  //                 'Content-Type': 'application/json',
  //             }
  //         }
  //     }]
  //     prefetchurls = Data

  //     postServiceWorkerMessage(WorkerMessageType.Prefetch, prefetchurls).then((results: WorkerUrlPrefetchResult) => {



  //         this.customerData = results[0].response.data;
  //         this.gender = this.customerData?.gender;
  //         this.userName = this.customerData?.username;
  //         this.bookletList = this.customerData?.customerPlanBooklets;
  //         this.customerInvoices = this.customerData?.invoices
  //         this.displayCardsMessage = this.customerData?.displayCardsMessage;
  //         console.log({ c: this.customerInvoices })
  //         this.customerUpcomingInvoices = this.customerData?.customerInvoices.upcomingInvoice
  //         // this.headerComponent.headerDetails('member');
  //         this.customerPlans = results[0].response.data.customerPlans;
  //         this.showinvoiceMessage = results[0].response.data.showEmployeeNoInvoiceMessage

  //         if (results[0].response.data.secondaryPhone == null) {
  //             this.customerData?.secondaryPhone = ""
  //         }
  //         if (this.customerData?.gender == 'Male') {
  //             this.gender = 'Male'
  //         }
  //         else if (this.customerData?.gender == 'Female') {
  //             this.gender = 'Female'
  //         }
  //         else if (this.customerData?.gender == 'Non-Binary') {
  //             this.gender = 'Non-Binary'
  //         }
  //         else if (this.customerData?.gender == 'Undisclosed') {
  //             this.gender = 'Undisclosed'
  //         }
  //         this.fuseBillKey = this.customerData?.fuseBillKey;
  //         this.stateId = this.customerData?.stateFusebillId;
  //         this.countryId = this.customerData?.countryFusebillId;
  //         this.paymentMethod = this.customerData?.paymentMethod;
  //         this.paymentMethodId = this.customerData?.paymentMethodId;
  //         this.memberportalgreensShildCheck = results[0].response.data.customerType.greenShildCustomer;
  //         this.memberportalEquitabelCheck = results[0].response.data.customerType.equitableCustomer
  //         this.ccDetails = results[0].response.data.ccDetails[0];
  //         this.PADdetails = results[0].response.data.customerACHdetails.data;
  //         this.customerType = results[0].response.data.customerType

  //         if (this.ccDetails) {
  //             this.creditCardNo = this.ccDetails.maskedCardNumber;
  //             this.fullName = this.ccDetails.firstName + ' ' + this.ccDetails.lastName;
  //             this.expire = this.ccDetails.expirationMonth + '/' + this.ccDetails.expirationYear;
  //         }
  //         if (this.paymentMethod == 'ACH') {
  //             this.bankCode = this.PADdetails ? this.PADdetails.bankCode : 'NA';
  //             this.transitNumber = this.PADdetails ? this.PADdetails.transitNumber : 'NA';
  //             this.accountNumber = this.PADdetails ? this.PADdetails.accountNumber : "NA";
  //             this.bankinfo = true;
  //             this.existVoid = true;
  //             this.imagedisplay = this.PADdetails ? this.PADdetails.voidCheckImage : "";
  //             this.voidCheckFileType = this.PADdetails ? this.PADdetails.voidCheckFileType : "";
  //             this.padAgreement = this.PADdetails ? this.PADdetails.padAgreement : "";
  //             this.voidCheckImage = this.PADdetails ? this.PADdetails.voidCheckImage : "";
  //             if ((this.bankCode != 'NA' && this.transitNumber != 'NA' && this.accountNumber != 'NA') && (this.bankCode != '' && this.transitNumber != '' && this.accountNumber != '')) {
  //                 this.getBankDetails();
  //             }
  //         }


  //         this.bookletList = results[0].response.data.customerPlanBooklets
  //         this.advisortype = results[0].response.data.advisor.type
  //         if (results[0].response.data.advisor.type == "CORPORATE") {
  //             this.advisor = results[0].response.data.advisor.parent;
  //             this.corporateDetails = results[0].response.data.advisor

  //         } else {
  //             this.advisor = results[0].response.data.advisor;
  //             this.corporateDetails = null
  //         }
  //         console.log("advisor", this.advisor)

  //         sessionStorage.setItem("GreenShild", this.memberportalgreensShildCheck)
  //         sessionStorage.setItem("Equitable", this.memberportalEquitabelCheck)


  //         // alert(typeof this.paymentMethodId)
  //         // this.childrenInfo.push(this.spouseInfo)
  //         this.childrenInfo = this.customerData?.dependents.childrens;
  //         setTimeout(() => {
  //             this.getcoverflow()
  //         }, 1000);
  //         for (let children of this.childrenInfo) {
  //             children['relationType'] = 'child';
  //         }
  //         this.spouseInfo = this.customerData?.dependents.spouseInfo;
  //         // this.spouseInfo = {};
  //         if (Object.keys(this.spouseInfo).length != 0) {
  //             this.spouseInfo['relationType'] = 'spouse';
  //             this.childrenInfo.splice(0, 0, this.spouseInfo)
  //             // this.childrenInfo.push(this.spouseInfo)
  //             // if(this.spouseInfo.healthPlan) {
  //             //   this.spouseInfo.healthPlan = this.spouseInfo.healthPlan;
  //             // }
  //             // else {
  //             //   this.spouseInfo.healthPlan = 'No Coverage'
  //             // }
  //         }
  //         else {
  //             this.editSpouse = false;
  //             this.editChild = true;
  //         }
  //         // this.hicList = this.customerData?.healthCards;
  //         this.hicList = this.customerData?.HealthCards_New?.data?.apiFiles;
  //         // this.roeUrl = this.customerData?.ROE==''?this.customerData?.ROE_New:this.customerData?.ROE;
  //         this.roeUrl = this.customerData?.ROE_New.data.roe
  //         if (this.roeUrl == '') {
  //             this.viewRoe = false;
  //         }
  //         if (this.paymentMethod === 'ACH') {
  //             this.getPADdetails();
  //         }
  //         else if (this.paymentMethod === 'CREDIT_CARD') {
  //             this.getCreditcard();
  //         }
  //         if (this.roeUrl != "") {
  //             this.roe = this.roeUrl
  //         }

  //         this.fusebillId = parseInt(this.customerData?.fusebillId) ? parseInt(this.customerData?.fusebillId) : '-';
  //         // this.fusebillId
  //         this.fubsillstatus = this.customerData?.status
  //         this.customerID = this.fusebillId;
  //         // sessionStorage.setItem('fuseBillId',this.customerData?.fusebillId);
  //         this.spouseId = this.spouseInfo.id;
  //         this.secondaryPhone = this.customerData?.secondaryPhone == null ? "" : this.customerData?.secondaryPhone;
  //         if (JSON.stringify(this.spouseInfo) !== '{}') {
  //             this.spouseInfo.firstName = this.titleCase.transform(this.spouseInfo.firstName)
  //             this.spouseInfo.lastName = this.titleCase.transform(this.spouseInfo.lastName)
  //             this.spouseInfo.dob = this.datePipe.transform(this.spouseInfo.dob, 'MM-dd-yyyy')
  //             this.spouse = 1;
  //         }
  //         else {
  //             this.spouse = 0;
  //         }
  //         let children = this.customerData?.dependents.childrens.length;
  //         for (let i = 0; i < children; i++) {
  //             this.customerData?.dependents.childrens[i].firstName = this.titleCase.transform(this.customerData?.dependents.childrens[i].firstName)
  //             this.customerData?.dependents.childrens[i].lastName = this.titleCase.transform(this.customerData?.dependents.childrens[i].lastName)
  //         }
  //         this.customerData?.primaryPhone = this.customerData?.primaryPhone
  //         this.customerData?.secondaryPhone = this.customerData?.secondaryPhone == null ? '' : this.customerData?.secondaryPhone;
  //         // this.customerData?.primaryPhone = this.phoneNoFormat.transform(this.customerData?.primaryPhone)
  //         // this.customerData?.secondaryPhone = this.phoneNoFormat.transform(this.customerData?.secondaryPhone)
  //         this.customerData?.line1 = this.titleCase.transform(this.customerData?.line1)
  //         this.customerData?.line2 = this.titleCase.transform(this.customerData?.line2)
  //         this.customerData?.city = this.titleCase.transform(this.customerData?.city)
  //         for (let i = 0; i < this.childrenInfo.length; i++) {
  //             this.childrenInfo[i].dob = this.datePipe.transform(this.childrenInfo[i].dob, 'MM-dd-yyyy')
  //             this.childrenInfo[i].graduationDate = this.datePipe.transform(this.childrenInfo[i].graduationDate, 'MM-dd-yyyy')


  //         }


  //         this.cardNumber = this.childrenInfo.length + this.spouse;



  //     })
  // }

  getCustomerData() {
    this.customerData = []
    this.getCustomerDataFirst()
    this.getCustomerDataRest()
    return;

    this._LoaderService.ShowLoader()
    let customerDataEndpoint = '/customer/' + this.customerid + '/details';
    console.log({ cc1: customerDataEndpoint })
    this.http.get(environment.apiUrl + '/api/ap/admin' + customerDataEndpoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe(async (response: any) => {
      if (response.status == 200) {
        this.lifePlansData = []
        this.getCustomerDraftData()
        this.customerData = response.data;
        this.customerInvoices = await this.customerData?.invoices
        console.log(this.customerInvoices)
        await this.getCustomerInvoices()

        this.SharedService.setUserName(this.customerData?.firstName + " " + this.customerData?.lastName)
        sessionStorage.setItem('memberUserName', this.customerData?.firstName + " " + this.customerData?.lastName);
        this.gender = this.customerData?.gender;
        this.ischildAccount = this.customerData?.childAccount
        this.userName = this.customerData?.username;
        this.bookletList = this.customerData?.customerPlanBooklets;
        this.displayCardsMessage = this.customerData?.displayCardsMessage;
        console.log({ c: this.customerInvoices })
        this.customerUpcomingInvoices = this.customerData?.customerInvoices.upcomingInvoice
        // this.headerComponent.headerDetails('member');
        this.executivePlanOptions = response.data.executivePlanOptions
        this.customerPlans = response.data.customerPlans;
        this.customerPlans.forEach(element => {

          if (element.insuranceType == "LIFE") {
            this.lifePlansData.push(element)
          }
        })

        if (this.lifePlansData.length > 0) {
          this.showIAFG = true
        }
        else {
          this.showIAFG = false
        }

        this.additionalDetails = this.lifePlansData.map((plan: any) => {
          console.log(plan)
          const details = plan.additionalData;
          return {
            name: details.name,
            member: details.member,
            spouse: details.spouse
          };
        }).filter(item =>
          item.name.includes("Life Insurance") ||
          item.name.includes("Critical Illness Insurance")
        ).sort((a, b) => {
          if (a.name.includes("Life Insurance") && !b.name.includes("Life Insurance")) {
            return -1;
          }
          if (!a.name.includes("Life Insurance") && b.name.includes("Life Insurance")) {
            return 1;
          }
          return 0;
        });


        this.showinvoiceMessage = response.data.showEmployeeNoInvoiceMessage

        if (response.data.secondaryPhone == null) {
          this.customerData.secondaryPhone = ""
        }
        if (this.customerData?.gender == 'Male') {
          this.gender = 'Male'
        }
        else if (this.customerData?.gender == 'Female') {
          this.gender = 'Female'
        }
        else if (this.customerData?.gender == 'Non-Binary') {
          this.gender = 'Non-Binary'
        }
        else if (this.customerData?.gender == 'Undisclosed') {
          this.gender = 'Undisclosed'
        }
        this.fuseBillKey = this.customerData?.fuseBillKey;
        this.stateId = this.customerData?.stateFusebillId;
        this.countryId = this.customerData?.countryFusebillId;
        this.paymentMethod = this.customerData?.paymentMethod;
        this.paymentMethodId = this.customerData?.paymentMethodId;
        this.memberportalgreensShildCheck = response.data.customerType.greenShildCustomer;
        this.memberportalEquitabelCheck = response.data.customerType.equitableCustomer
        this.ccDetails = response.data.ccDetails[0];
        this.PADdetails = response.data.customerACHdetails.data;
        this.customerType = response.data.customerType

        if (this.ccDetails) {
          this.creditCardNo = this.ccDetails.maskedCardNumber;
          // this.fullName = this.ccDetails.firstName + ' ' + this.ccDetails.lastName;

          if (this.ccDetails.firstName == "Rakesh") {
            this.ccDetails.firstName = this.customerData.firstName
          } else {
            this.ccDetails.firstName = this.ccDetails.firstName

          }

          if (this.ccDetails.lastName == "test") {
            this.ccDetails.lastName = this.customerData.lastName
          } else {
            this.ccDetails.lastName = this.ccDetails.lastName

          }
          this.fullName = this.ccDetails.firstName + ' ' + this.ccDetails.lastName;

          // this.fullName = this.customerData.firstName + ' ' + this.customerData.lastName;

          this.expire = this.ccDetails.expirationMonth + '/' + this.ccDetails.expirationYear;
        }
        if (this.paymentMethod == 'ACH') {
          this.bankCode = this.PADdetails ? this.PADdetails.bankCode : 'NA';
          this.transitNumber = this.PADdetails ? this.PADdetails.transitNumber : 'NA';
          this.accountNumber = this.PADdetails ? this.PADdetails.accountNumber : "NA";
          this.bankinfo = true;
          this.existVoid = true;
          this.imagedisplay = this.PADdetails ? this.PADdetails.voidCheckImage : "";
          this.voidCheckFileType = this.PADdetails ? this.PADdetails.voidCheckFileType : "";
          this.padAgreement = this.PADdetails ? this.PADdetails.padAgreement : "";
          this.voidCheckImage = this.PADdetails ? this.PADdetails.voidCheckImage : "";
          if ((this.bankCode != 'NA' && this.transitNumber != 'NA' && this.accountNumber != 'NA') && (this.bankCode != '' && this.transitNumber != '' && this.accountNumber != '')) {
            this.getBankDetails();
          }
        }


        this.bookletList = response.data.customerPlanBooklets
        this.advisortype = response.data.advisor.type
        if (response.data.advisor.type == "CORPORATE") {
          this.advisor = response.data.advisor.parent;
          this.corporateDetails = response.data.advisor
          this.advisorName = this.advisor?.name

        } else {
          this.advisor = response.data.advisor;
          this.advisorName = this.advisor?.name
          this.corporateDetails = null
        }
        // this.allbrokerslist.forEach((element: any) => {

        //   if (element.name == this.advisorName) {
        //     console.log(element)
        //     // this.filteredallBrokers.push(element)
        //     this.ParentBrokerId = element.id

        //     // alert(this.ParentBrokerId)
        //   }
        // })
        console.log("advisor", this.advisor)
        console.log("advisor", this.advisorName)

        sessionStorage.setItem("GreenShild", this.memberportalgreensShildCheck)
        sessionStorage.setItem("Equitable", this.memberportalEquitabelCheck)


        // alert(typeof this.paymentMethodId)
        // this.childrenInfo.push(this.spouseInfo)
        this.childrenInfo = this.customerData?.dependents.childrens;

        setTimeout(() => {
          this.getcoverflow()
        }, 1000);
        for (let children of this.childrenInfo) {
          children['relationType'] = 'child';
        }
        this.spouseInfo = this.customerData?.dependents.spouseInfo;
        // this.spouseInfo = {};
        if (Object.keys(this.spouseInfo).length != 0) {
          this.spouseInfo['relationType'] = 'spouse';
          this.childrenInfo.splice(0, 0, this.spouseInfo)
          // this.childrenInfo.push(this.spouseInfo)
          // if(this.spouseInfo.healthPlan) {
          //   this.spouseInfo.healthPlan = this.spouseInfo.healthPlan;
          // }
          // else {
          //   this.spouseInfo.healthPlan = 'No Coverage'
          // }
        }
        else {
          this.editSpouse = false;
          this.editChild = true;
        }
        console.log(this.childrenInfo, "children")
        // this.hicList = this.customerData?.healthCards;
        // this.hicList = this.customerData?.HealthCards_New?.data?.apiFiles;
        this.hicList = this.customerData?.healthCards;

        // this.roeUrl = this.customerData?.ROE==''?this.customerData?.ROE_New:this.customerData?.ROE;
        this.roeUrl = this.customerData?.memberROEs || []
        if (this.roeUrl?.length <= 0) {
          this.viewRoe = false;
        }
        if (this.paymentMethod === 'ACH') {
          this.getPADdetails();
        }
        else if (this.paymentMethod === 'CREDIT_CARD') {
          this.getCreditcard();
        }
        if (this.roeUrl?.length > 0) {
          this.roe = this.roeUrl
        }

        this.fusebillId = parseInt(this.customerData?.fusebillId) ? parseInt(this.customerData?.fusebillId) : '-';
        // this.fusebillId
        this.fubsillstatus = this.customerData?.status
        this.customerID = this.fusebillId;
        // sessionStorage.setItem('fuseBillId',this.customerData?.fusebillId);
        this.spouseId = this.spouseInfo.id;


        this.secondaryPhone = this.customerData?.secondaryPhone == null ? "" : this.customerData?.secondaryPhone;
        if (JSON.stringify(this.spouseInfo) !== '{}') {
          this.spouseInfo.firstName = this.titleCase.transform(this.spouseInfo.firstName)
          this.spouseInfo.lastName = this.titleCase.transform(this.spouseInfo.lastName)
          this.spouseInfo.dob = this.datePipe.transform(this.spouseInfo.dob, 'MM-dd-yyyy')
          this.spouse = 1;
        }
        else {
          this.spouse = 0;
        }
        let children = this.customerData?.dependents.childrens.length;
        for (let i = 0; i < children; i++) {
          this.customerData.dependents.childrens[i].firstName = this.titleCase.transform(this.customerData?.dependents.childrens[i].firstName)
          this.customerData.dependents.childrens[i].lastName = this.titleCase.transform(this.customerData?.dependents.childrens[i].lastName)
        }
        this.customerData.primaryPhone = this.customerData?.primaryPhone
        this.customerData.secondaryPhone = this.customerData?.secondaryPhone == null ? '' : this.customerData?.secondaryPhone;
        // this.customerData?.primaryPhone = this.phoneNoFormat.transform(this.customerData?.primaryPhone)
        // this.customerData?.secondaryPhone = this.phoneNoFormat.transform(this.customerData?.secondaryPhone)
        this.customerData.line1 = this.titleCase.transform(this.customerData?.line1)
        this.customerData.line2 = this.titleCase.transform(this.customerData?.line2)
        this.customerData.city = this.titleCase.transform(this.customerData?.city)
        for (let i = 0; i < this.childrenInfo.length; i++) {
          this.childrenInfo[i].dob = this.datePipe.transform(this.childrenInfo[i].dob, 'MM-dd-yyyy')
          this.childrenInfo[i].graduationDate = this.datePipe.transform(this.childrenInfo[i].graduationDate, 'MM-dd-yyyy')
          // if(this.childrenInfo[i].carrierName) {
          //   this.childrenInfo[i].carrierName = this.childrenInfo[i].carrierName
          // }
          // else {
          //   this.childrenInfo[i].carrierName = 'Na';
          // }
          // if(this.childrenInfo[i].graduationDate) {
          //   this.childrenInfo[i].graduationDate = this.childrenInfo[i].graduationDate
          // }
          // else {
          //   this.childrenInfo[i].graduationDate = 'Na';
          // }
        }
        // if(this.spouseInfo.insurer) {
        //   this.spouseInsurer = this.spouseInfo.insurer
        // }
        // else {
        //   this.spouseInsurer = 'Na';
        // }
        // if(this.spouseInfo.email) {
        //   this.spouseInfo.email = this.spouseInfo.email
        // }
        // else {
        //   this.spouseInfo.email = 'Na';
        // }
        this.cardNumber = this.childrenInfo?.length + this.spouse;

        console.log(this.childrenInfo, "children")
        this.restLoader = false;
        this._LoaderService.HideLoader()
      }
      else {
        this._LoaderService.HideLoader()
        console.log("entered1")
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
        this.router.navigate(['/manageMembers']);

      }
    }, (error) => {
      console.log("entered2")
      this._LoaderService.HideLoader()
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
      this.router.navigate(['/manageMembers']);

    });
  }


  getCustomerDataFirst() {
    this._LoaderService.ShowLoader()
    let customerDataEndpoint = '/customer/' + this.customerid + '/details/first';
    console.log({ cc1_first: customerDataEndpoint })
        // console.log('customer data',this.members.filter((member:any)=>member.id==this.customerid))
    this.http.get(environment.apiUrl + '/api/ap/admin' + customerDataEndpoint, {
      // this.http.get('http://[::1]:3002' + '/api/ap/admin' + customerDataEndpoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe(async (response: any) => {
      if (response.status == 200) {
        this.lifePlansData = []
        // this.getCustomerDraftData()
        this.customerData = { ...response.data, ...this.customerData };
        // this.customerInvoices = await this.customerData?.invoices
        // console.log(this.customerInvoices)
        // await this.getCustomerInvoices()
        this.paymentPlatform = response.data?.paymentPlatform ?? 'Staxbill'
        this.authorizenetCustomerId = response.data?.authorizenetCustomerId ?? '0'
        this.igbmsId = response.data?.igbmsId;

        this.SharedService.setUserName(this.customerData?.firstName + " " + this.customerData?.lastName)
        sessionStorage.setItem('memberUserName', this.customerData?.firstName + " " + this.customerData?.lastName);
        this.gender = this.customerData?.gender;
        this.dob  = this.customerData?.dob;
        this.ischildAccount = this.customerData?.childAccount
        this.userName = this.customerData?.username;
        this.primaryEmail = this.customerData?.primaryEmail
        // this.bookletList = this.customerData?.customerPlanBooklets;
        // this.displayCardsMessage = this.customerData?.displayCardsMessage;
        // console.log({ c: this.customerInvoices })
        // this.customerUpcomingInvoices = this.customerData?.customerInvoices.upcomingInvoice
        // this.headerComponent.headerDetails('member');
        this.executivePlanOptions = response.data?.executivePlanOptions??[]
        if(response.data?.executivePlanOptionsApplicable==true && response.data?.executivePlanOptions?.length==0){
          this.addOptions = true
        }
        // this.customerPlans = response.data.customerPlans;
        this.customerPlans = [
          ...(response.data?.customerPlans || []),
          ...(response.data?.bulkPlans || [])
        ];
        this.beneficiaries = response.data.beneficiaries;
        this.customerPlans.forEach(element => {

          if (element.insuranceType == "LIFE") {
            this.lifePlansData.push(element)
          }
        })

        if (this.lifePlansData.length > 0) {
          this.showIAFG = true
        }
        else {
          this.showIAFG = false
        }

        this.additionalDetails = this.lifePlansData.map((plan: any) => {
          console.log(plan)
          const details = plan.additionalData;
          return {
            name: details.name,
            member: details.member,
            spouse: details.spouse
          };
        }).filter(item =>
          item.name.includes("Life Insurance") ||
          item.name.includes("Critical Illness Insurance")
        ).sort((a, b) => {
          if (a.name.includes("Life Insurance") && !b.name.includes("Life Insurance")) {
            return -1;
          }
          if (!a.name.includes("Life Insurance") && b.name.includes("Life Insurance")) {
            return 1;
          }
          return 0;
        });


        this.showinvoiceMessage = response.data.showEmployeeNoInvoiceMessage

        if (response.data.secondaryPhone == null) {
          this.customerData.secondaryPhone = ""
        }
        if (this.customerData?.gender == 'Male') {
          this.gender = 'Male'
        }
        else if (this.customerData?.gender == 'Female') {
          this.gender = 'Female'
        }
        else if (this.customerData?.gender == 'Non-Binary') {
          this.gender = 'Non-Binary'
        }
        else if (this.customerData?.gender == 'Undisclosed') {
          this.gender = 'Undisclosed'
        }
        this.fuseBillKey = this.customerData?.fuseBillKey;
        // this.stateId = this.customerData?.stateFusebillId;
        // this.countryId = this.customerData?.countryFusebillId;
        this.paymentMethod = this.customerData?.paymentMethod;
        this.paymentMethodId = this.customerData?.paymentMethodId;
        this.memberportalgreensShildCheck = response.data.customerType.greenShildCustomer;
        this.memberportalEquitabelCheck = response.data.customerType.equitableCustomer
        this.customerType = response.data.customerType

        // this.bookletList = response.data.customerPlanBooklets

        this.advisortype = response.data.advisor.type
        if (response.data.advisor.type == "CORPORATE") {
          this.advisor = response.data.advisor.parent;
          this.corporateDetails = response.data.advisor

        } else {
          this.advisor = response.data.advisor;
          this.corporateDetails = null
        }
        console.log("advisor", this.advisor)

        sessionStorage.setItem("GreenShild", this.memberportalgreensShildCheck)
        sessionStorage.setItem("Equitable", this.memberportalEquitabelCheck)


        // alert(typeof this.paymentMethodId)
        // this.childrenInfo.push(this.spouseInfo)
        this.childrenInfo = this.customerData?.dependents.childrens;

        setTimeout(() => {
          this.getcoverflow()
        }, 1000);
        for (let children of this.childrenInfo) {
          children['relationType'] = 'child';
        }
        this.spouseInfo = this.customerData?.dependents.spouseInfo;
        // this.spouseInfo = {};
        if (Object.keys(this.spouseInfo).length != 0) {
          this.spouseInfo['relationType'] = 'spouse';
          this.childrenInfo.splice(0, 0, this.spouseInfo)
          // this.childrenInfo.push(this.spouseInfo)
          // if(this.spouseInfo.healthPlan) {
          //   this.spouseInfo.healthPlan = this.spouseInfo.healthPlan;
          // }
          // else {
          //   this.spouseInfo.healthPlan = 'No Coverage'
          // }
        }
        else {
          this.editSpouse = false;
          this.editChild = true;
        }
        console.log(this.childrenInfo, "children")
        // this.hicList = this.customerData?.healthCards;
        // this.hicList = this.customerData?.HealthCards_New?.data?.apiFiles;
        this.hicList = this.customerData?.healthCards;

        // this.roeUrl = this.customerData?.ROE==''?this.customerData?.ROE_New:this.customerData?.ROE;
        this.roeUrl = this.customerData?.memberROEs || []
        if (this.roeUrl?.length <= 0) {
          this.viewRoe = false;
        }
        if (this.paymentMethod === 'ACH') {
          this.getPADdetails();
        }
        else if (this.paymentMethod === 'CREDIT_CARD') {
          this.getCreditcard();
        }
        if (this.roeUrl?.length > 0) {
          this.roe = this.roeUrl
        }

        this.fusebillId = parseInt(this.customerData?.fusebillId) ? parseInt(this.customerData?.fusebillId) : '-';
        // this.fusebillId
        this.fubsillstatus = this.customerData?.status
        this.customerID = this.fusebillId;

        this.MemberfusebillId = this.customerData?.fusebillId
        // alert(this.MemberfusebillId)
        // sessionStorage.setItem('fuseBillId',this.customerData?.fusebillId);
        this.spouseId = this.spouseInfo.id;


        this.secondaryPhone = this.customerData?.secondaryPhone == null ? "" : this.customerData?.secondaryPhone;
        if (JSON.stringify(this.spouseInfo) !== '{}') {
          this.spouseInfo.firstName = this.titleCase.transform(this.spouseInfo.firstName)
          this.spouseInfo.lastName = this.titleCase.transform(this.spouseInfo.lastName)
          this.spouseInfo.dob = this.datePipe.transform(this.spouseInfo.dob, 'MM-dd-yyyy')
          this.spouse = 1;
        }
        else {
          this.spouse = 0;
        }
        let children = this.customerData?.dependents.childrens.length;
        for (let i = 0; i < children; i++) {
          this.customerData.dependents.childrens[i].firstName = this.titleCase.transform(this.customerData?.dependents.childrens[i].firstName)
          this.customerData.dependents.childrens[i].lastName = this.titleCase.transform(this.customerData?.dependents.childrens[i].lastName)
        }
        this.customerData.primaryPhone = this.customerData?.primaryPhone
        this.customerData.secondaryPhone = this.customerData?.secondaryPhone == null ? '' : this.customerData?.secondaryPhone;
        // this.customerData?.primaryPhone = this.phoneNoFormat.transform(this.customerData?.primaryPhone)
        // this.customerData?.secondaryPhone = this.phoneNoFormat.transform(this.customerData?.secondaryPhone)
        this.customerData.line1 = this.titleCase.transform(this.customerData?.line1)
        this.customerData.line2 = this.titleCase.transform(this.customerData?.line2)
        this.customerData.city = this.titleCase.transform(this.customerData?.city)
        for (let i = 0; i < this.childrenInfo.length; i++) {
          this.childrenInfo[i].dob = this.datePipe.transform(this.childrenInfo[i].dob, 'MM-dd-yyyy')
          this.childrenInfo[i].graduationDate = this.datePipe.transform(this.childrenInfo[i].graduationDate, 'MM-dd-yyyy')
        }
        this.cardNumber = this.childrenInfo?.length + this.spouse;

        console.log(this.childrenInfo, "children")

        // this.restLoader = true;
        // this.getCustomerDataRest()

        console.log('this.customerData1', this.customerData)
        this._LoaderService.HideLoader()
      }
      else {
        this._LoaderService.HideLoader()
        console.log("entered1_1")
        Swal.fire({ allowOutsideClick: false, title: 'Error', text: response.message })
        this.router.navigate(['/manageMembers']);
      }
    }, (error) => {
      console.log("entered2_1")
      this._LoaderService.HideLoader()
      Swal.fire({ allowOutsideClick: false, title: 'Error', text: error.error.error.message })
      this.router.navigate(['/manageMembers']);

    });
  }

  getCustomerDataRest() {
    // this._LoaderService.ShowLoader()
    let customerDataEndpoint = '/customer/' + this.customerid + '/details/rest';
    console.log({ cc1_rest: customerDataEndpoint })
    this.http.get(environment.apiUrl + '/api/ap/admin' + customerDataEndpoint, {
      // this.http.get('http://[::1]:3002' + '/api/ap/admin' + customerDataEndpoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe(async (response: any) => {
      if (response.status == 200) {
        this.lifePlansData = this.lifePlansData
        // this.getCustomerDraftData()
        this.customerData = { ...response.data, ...this.customerData };
        this.customerInvoices = await this.customerData?.invoices
        console.log(this.customerInvoices)
        await this.getCustomerInvoices()

        this.bookletList = this.customerData?.customerPlanBooklets;
        this.displayCardsMessage = this.customerData?.displayCardsMessage;
        console.log({ c: this.customerInvoices })
        this.customerUpcomingInvoices = this.customerData?.customerInvoices.upcomingInvoice

        this.stateId = this.customerData?.stateFusebillId;
        this.countryId = this.customerData?.countryFusebillId;
        if(response.data?.ccDetails?.length > 1){
          this.ccDetails = response.data?.ccDetails?.filter((card)=>card.defaultCard)[0];
        }else{
          this.ccDetails = response.data?.ccDetails[0];
        }
        this.PADdetails = response.data.customerACHdetails.data;

        const today = new Date();
        this.latestPaymentStatus = this.customerData?.latestPaymentStatus;
        if(this.latestPaymentStatus === 'Failed'){
          if(this.customerData?.latestPaymentDetails?.captureDate < today){
            this.isReauth = true;
          }
          else{
            this.isRetryPayment = true;
          }
        }

        if (this.ccDetails) {
          this.creditCardNo = this.ccDetails.maskedCardNumber;
          // this.fullName = this.ccDetails.firstName + ' ' + this.ccDetails.lastName;

          if (this.ccDetails.firstName == "Rakesh") {
            this.ccDetails.firstName = this.customerData.firstName
          } else {
            this.ccDetails.firstName = this.ccDetails.firstName

          }

          if (this.ccDetails.lastName == "test") {
            this.ccDetails.lastName = this.customerData.lastName
          } else {
            this.ccDetails.lastName = this.ccDetails.lastName

          }
          this.fullName = this.ccDetails.firstName + ' ' + this.ccDetails.lastName;

          // this.fullName = this.customerData.firstName + ' ' + this.customerData.lastName;

          this.expire = this.ccDetails.expirationMonth + '/' + this.ccDetails.expirationYear;
          this.updateExpiryStatus(this.expire)
        }
        if (this.paymentMethod == 'ACH') {
          this.bankCode = this.PADdetails ? this.PADdetails.bankCode : 'NA';
          this.transitNumber = this.PADdetails ? this.PADdetails.transitNumber : 'NA';
          this.accountNumber = this.PADdetails ? this.PADdetails.accountNumber : "NA";
          this.bankinfo = true;
          this.existVoid = true;
          this.imagedisplay = this.PADdetails ? this.PADdetails.voidCheckImage : "";
          this.voidCheckFileType = this.PADdetails ? this.PADdetails.voidCheckFileType : "";
          this.padAgreement = this.PADdetails ? this.PADdetails.padAgreement : "";
          this.voidCheckImage = this.PADdetails ? this.PADdetails.voidCheckImage : "";
          if ((this.bankCode != 'NA' && this.transitNumber != 'NA' && this.accountNumber != 'NA') && (this.bankCode != '' && this.transitNumber != '' && this.accountNumber != '')) {
            this.getBankDetails();
          }
        }

        this.bookletList = response.data.customerPlanBooklets

        // this.advisortype = response.data.advisor.type
        // if (response.data.advisor.type == "CORPORATE") {
        //     this.advisor = response.data.advisor.parent;
        //     this.corporateDetails = response.data.advisor
        // } else {
        //     this.advisor = response.data.advisor;
        //     this.corporateDetails = null
        // }
        // console.log("advisor", this.advisor)

        sessionStorage.setItem("GreenShild", this.memberportalgreensShildCheck)
        sessionStorage.setItem("Equitable", this.memberportalEquitabelCheck)

        setTimeout(() => {
          this.getcoverflow()
        }, 1000);
        this.hicList = this.customerData?.healthCards;

        // this.roeUrl = this.customerData?.ROE==''?this.customerData?.ROE_New:this.customerData?.ROE;
        this.roeUrl = this.customerData?.memberROEs || []
        if (this.roeUrl?.length <= 0) {
          this.viewRoe = false;
        }
        if (this.paymentMethod === 'ACH') {
          this.getPADdetails();
        }
        else if (this.paymentMethod === 'CREDIT_CARD') {
          this.getCreditcard();
        }
        if (this.roeUrl?.length > 0) {
          this.roe = this.roeUrl
        }
        this.restLoader = false;
        console.log('this.customerData2', this.customerData)
        // this._LoaderService.HideLoader()
      }
      else {
        // this._LoaderService.HideLoader()
        console.log("entered1_2")
        Swal.fire({ allowOutsideClick: false, title: 'Error', text: response.message })
        this.router.navigate(['/manageMembers']);
      }
    }, (error) => {
      console.log("entered2_2")
      // this._LoaderService.HideLoader()
      Swal.fire({ allowOutsideClick: false, title: 'Error', text: error.error.error.message })
      this.router.navigate(['/manageMembers']);

    });
  }


  viewadvisorData() {
    this.getBrokerProfiles(this.ParentBrokerId)
  }

  hasMemberData(member: any): boolean {
    return member && Object.keys(member).length > 0;
  }

  hasSpouseData(spouse: any): boolean {
    return spouse && Object.keys(spouse).length > 0;
  }
  formatNumber(number) {
    // let num = number.toString();
    // return num.slice(0,2)+','+num.slice(2)
    return number.toLocaleString();
  }
  updateExecutiveoptions(plan) {
    this.selectedExecutiveOptions = plan.id
    const dom: HTMLElement = this.elementRef.nativeElement;

    let value = []
    value = this.executivePlanOptionsValues.filter((plans: any) => plans.id == plan.planOptionsId)
    this.executivePlanOptionsValuesArray = value


    console.log(this.executivePlanOptionsValuesArray)

    this.executivePlanOptionsValuesArray.forEach(options => {
      options.planOptionsValues.forEach(optionvalues => {
        console.log(optionvalues)
        if (optionvalues.value == plan.planOptionsValue) {
          this.executivePlanOptions.forEach(element => {
            console.log(element)
            setTimeout(() => {
              $("#planselectionvalue" + "-" + optionvalues.id + "-" + element.planOptionsId).click()

            }, 100)


          })
        }

      });

    })
  }

  getSelectedEmails() {
    return this.inviteEmails.filter(email => email.checked).map(email => email.label);
  }

  getInviteEmails(){
    this.inviteEmails = []
    // const endPoint = environment.apiUrl+'/api/ap/member/'+this.fusebillId+'/contacts/list'
    const endPoint = environment.apiUrl+'/api/ap/member/'+this.customerid+'/contacts/list'
    this.http.get(endPoint,{
      headers:{
        Authorization: 'Bearer ' + this.accessToken,
    }}).subscribe((response:any)=>{
      console.log({response})
      const emails = response?.data?.memberContacts || [];
      if (response?.data?.advisorEmail) {
        emails.push(response.data.advisorEmail);
      }

      if (response?.data?.email) {
        emails.push(response.data.email);
      }
      // Remove duplicates by converting the array to a Set and then back to an array
      const uniqueEmails = Array.from(new Set(emails));
      this.inviteEmails = uniqueEmails?.map(email => ({
        label: email,
        checked: false  // Default value for each checkbox is false
      }));
    })
  }

  addEmail() {
    if(this.emailForm.get('newEmail')?.value==''){
      return;
    }
    if (this.emailForm.valid) {
      const newEmail = this.emailForm.value.newEmail;
      // this.inviteEmails.push({ label: newEmail, checked: true });
      // this.emailForm.get('newEmail').setValue('')

      const emails = this.inviteEmails.
          map(email => email.label).
          map(email => {
            const match = email.match(/\{([^}]+)\}/); // returns which is present in curly brackets
            return match ? match[1] : email;
          });

          // Check if the email already exists in the inviteEmails array
          const emailExists = emails.some(email => email.replace(/[{}]/g, '').trim() == newEmail);

          if (!emailExists) {
            this.inviteEmails.push({ label: `${newEmail}`, checked: true });
            this.emailForm.get('newEmail').setValue('');
          } else {
            Swal.fire({title: 'Info', text: 'Email already present in the list above'});
          }
    } else {
      console.log('Form is invalid');
    }
    console.log(this.inviteEmails)
    }

  paymentUpdationInvitationMail() {
    const obj = {
      emails:this.getSelectedEmails(),
      // emails:this.primaryEmail,
      paymentMethod: this.paymentMethod == 'CREDIT_CARD' ? 'CC' : this.paymentMethod == 'ACH' ? 'PAD' : ''
    }
    console.log({obj})
    $('#emailConfirmationModal').modal('hide');
    let accessToken = sessionStorage.getItem('accessToken');
    // let inviteMail = `/api/ap/v2/member/${this.fusebillId}/updatePaymentInfoMail`;
    let inviteMail = `/api/ap/v2/member/${this.customerid}/updatePaymentInfoMail`;
    this.http.post(environment.apiUrl + inviteMail , obj, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {

      if (response['status'] == 200 || response['statusCode'] == 200) {
        // Swal.fire({ title: this.lang?.Info, text: response.message })
        Swal.fire({
          title: this.lang?.Info,
          // text: this.lang?.Invitation_successfully_sent_to + " " + this.getSelectedEmails().join(', ')
          html: "<b>"+ this.lang?.Invitation_successfully_sent_to + "</b> " + this.getSelectedEmails().join(', ')
          }).
          then((result)=>{
            this.emailForm.get('newEmail').setValue('');
            this.inviteEmails = []
        })
      } else {
        Swal.fire({ title: this.lang?.Error, text: response.message })
      }
    }), (error) => {
      Swal.fire({ title: this.lang?.Error, text: error.error.error.message });
    }
  }




  getCustomerDraftData() {
    let customerDataEndpoint = '/' + this.customerid + '/invoices';
    this.http.post(environment.apiUrl + '/api/ap' + customerDataEndpoint, {}, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.getCustomerDraftDetails = response.data.invoice
        this.getCustomerDraftDate = response.data.date
        this.getCustomerDraftDate1 = this.getCustomerDraftDate
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
      }
    }, (error) => {
      // Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
    });
  }


  // viewInvoiceDetails(invoice: any) {
  //   // return false
  //   // this.getInvoiceDetails = invoice
  //  this.getSpecificInvoiceData(invoice)
  //   $('#viewInvoice-modal').modal('show');

  //   this.getInvoiceDetailsModel(invoice)
  //   // setTimeout(() => {
  //   //   this.invoiceLink = "https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/server/MemberInvoices/Invoice_13429894_2024-10-01_24-10-4205_DRAFT.pdf"

  //   // }, 1000);
  // }

  actionButtonsList = [
  {
    condition: true,
    backgroundColor: '#28a745',
    icon: 'bi bi-check-circle',
    label: 'Approve',
    onClick: () => {
      console.log('Approved!');
      // Any custom logic
    }
  },
  {
    condition: true,
    backgroundColor: '#dc3545',
    icon: 'bi bi-x-circle',
    label: 'Reject',
    onClick: () => {
      console.log('Rejected!');
      // Any custom logic
    }
  }
];

//   viewInvoiceDetails(invoice: any) {
//   this.selectedInvoice = invoice; // used in <app-view-invoice-modal>
//   this.selectedInvoiceLink = invoice.link; // or set manually like you did
//   this.actionButtonsList = [ // optional, if using buttons in modal
//     {
//       condition: true,
//       backgroundColor: '#007bff',
//       icon: 'bi bi-download',
//       label: 'Download',
//       onClick: () => {
//         this.DownloadInvoice(invoice.link);
//       }
//     }
//   ];
//   this.showInvoiceModal = true; // <-- this triggers modal via *ngIf
// }
// viewInvoiceDetails(invoice: any='') {
//   console.log('Clicked invoice:', invoice); // 🔍 Check what invoice was clicked

//   this.selectedInvoice = invoice;
//   this.selectedInvoiceLink = invoice.link;

//   this.actionButtonsList = [
//     {
//       condition: true,
//       backgroundColor: '#007bff',
//       icon: 'bi bi-download',
//       label: 'Download',
//       onClick: () => {
//         console.log('Download clicked for:', invoice.link); // ✅ Log download click
//         this.DownloadInvoice(invoice.link);
//       }
//     }
//   ];

//   this.showInvoiceModal = true;
//   console.log('Modal should now be visible. showInvoiceModal =', this.showInvoiceModal);
//   console.log('Invoice link set to:', this.selectedInvoiceLink);
//   console.log('Selected invoice object:', this.selectedInvoice);
//   console.log('Action buttons:', this.actionButtonsList);
// }
viewInvoiceDetails(invoice: any) {
  console.log('Invoice Clicked:', invoice); 
    this.getSpecificInvoiceData(invoice)
    $('#viewInvoice-modal').modal('show');
     this.getInvoiceDetailsModel(invoice)

  console.log('Clicked invoice:', invoice);
  this.selectedInvoice = invoice;
  this.selectedInvoiceLink = invoice.link;

  this.actionButtonsList = [
    {
      condition: true,
      backgroundColor: '#007bff',
      icon: 'bi bi-download',
      label: 'Download',
      onClick: () => {
        console.log('Download clicked for:', invoice.link);
        this.DownloadInvoice(invoice.link);
      }
    }
  ];

  this.showInvoiceModal = true;
  console.log('Modal should now be visible. showInvoiceModal =', this.showInvoiceModal);
  console.log('Invoice link set to:', this.selectedInvoiceLink);
  console.log('Selected invoice object:', this.selectedInvoice);
  console.log('Action buttons:', this.actionButtonsList);
}



  getSpecificInvoiceData(invoice) {
    var accessToken = sessionStorage.getItem('accessToken');
    var GetInvoiceData = `/api/ap/invoices/no/${invoice.invoiceNumber}`;



    this.http.get(environment.apiUrl + GetInvoiceData, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe({
      next: (res: any) => {


      },
      error: (error) => {
        console.log(error);
      },
    });
  }
  getInvoiceDetailsModel(invoice) {
    var accessToken = sessionStorage.getItem('accessToken');
    var GetInvoiceData = `/api/ap/invoices/no/${invoice.invoiceNumber}/view/doc/false`;

    this.http.get(environment.apiUrl + GetInvoiceData, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe({
      next: (res: any) => {

        console.log(res)


        setTimeout(() => {

          this.invoiceslink = res.link
        }, 1000);

      },
      error: (error) => {
        console.log(error);
      },
    });

  }
  async getCustomerInvoices() {
    // let customerDataEndpoint = '/customer/' + this.MemberfusebillId + '/invoices/list';
    let customerDataEndpoint = '/customer/' + this.customerid + '/invoices/list';


    this.http.get(environment.apiUrl + '/api/ap' + customerDataEndpoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {

        this.customerFinalInvoices = response.data;
        // this.customerFinalInvoices.sort((a, b) => {
        //   const dateA: any = new Date(a.dueDate || a.invoiceDate);
        //   const dateB: any = new Date(b.dueDate || b.invoiceDate);
          
        //   return dateB - dateA; // Descending order
        // });

        this.customerFinalInvoices.sort((a, b) => {
          const dateA = new Date(a.dueDate || a.invoiceDate).getTime();
          const dateB = new Date(b.dueDate || b.invoiceDate).getTime();

          if (dateA !== dateB) {
            return dateB - dateA; // Descending by date
          }

          // If dates are equal, sort by invoiceNumber descending
          if (a.invoiceNumber > b.invoiceNumber) return -1;
          if (a.invoiceNumber < b.invoiceNumber) return 1;
          return 0;
        });

        // this.allCustomerFinalInvoices1 = response.data
        this.allCustomerFinalInvoices1 = this.customerFinalInvoices;
        this.invoiceMonthsList =  response.invoiceMonthsList
        




      }
      else {
        // Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
      }
    }, (error) => {
      // Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
    });
    // let customerDataEndpoint = '/customer/' + this.customerid + '/get-invoices';
    // console.log(this.customerFinalInvoices, this.customerInvoices)

    // this.http.get(environment.apiUrl + '/api/ap' + customerDataEndpoint, {
    //   headers: {
    //     Authorization: 'Bearer ' + this.accessToken,
    //     'Content-Type': 'application/json',
    //   }
    // }).subscribe((response: any) => {
    //   if (response.status == 200) {

    //     let invoices = response.data

    //     const filteredInvoices = invoiceFilter(this.customerInvoices, invoices)
    //     const filteredInvoices1 = filteredInvoices.filter((inv: any) => inv.status == 'DRAFT')
    //     this.customerFinalInvoices1 = [...filteredInvoices1]
    //     this.allCustomerFinalInvoices1 = [...filteredInvoices1]

    //     this.customerFinalInvoices = [...filteredInvoices]
    //     console.log(this.customerFinalInvoices)
    //     this.customerFinalInvoicesIGBMS = this.customerFinalInvoices.filter((inv: any) => inv.status != 'DRAFT')
    //     this.allCustomerFinalInvoicesIGBMS = this.customerFinalInvoicesIGBMS
    //     console.log(this.customerFinalInvoices)


    //   }
    //   else {
    //     Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
    //   }
    // }, (error) => {
    //   // Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
    // });
  }

  // public isGroupsNotEmpty(groups: any): boolean {
  //     return groups && Object.keys(groups).length > 0;
  // }
  public displayPackage: boolean;
  public colors = { 0: "#FF3131", 1: "#37FBB3", 2: "black" }
  public text = { 0: "Unpublished", 1: "Published", 2: "Published but Restricted" }
  // unpublished(red -0 ), restricted / reserved(black 2 or 3), published(1 - green)
  getStatus(published, restricted) {
    let data = -1;
    if (published) {
      if (restricted) {
        data = 2
      }
      else {
        data = 1
      }

    }
    else {
      data = 0
    }
    return data
  }

  getColorForPlans(published, restricted, name, plan) {
    // console.log(published, restricted, name, plan)
    const pubStatus = { 0: false, 1: true }
    // console.log(pubStatus[published], restricted)
    let data = this.getStatus(pubStatus[published], restricted)
    return this.colors[data]
  }

  getTextForTooltip(published, restricted, name) {
    const pubStatus = { 0: false, 1: true }
    let data = this.getStatus(pubStatus[published], restricted)
    return this.text[data]
  }

  getColorForPlans1(published, restricted) {

    let data: any = this.getStatus(published, restricted)
    const color = this.colors[data];
    return color;
  }

  getTextForTooltip1(published, restricted) {
    let data: any = this.getStatus(published, restricted)
    const text = this.text[data]
    return text
  }





  addPlan(title) {
    this.addPlanForm.reset()


    // const today = new Date();
    // const currentMonth = today.getMonth();
    // const nextMonth = new Date(today.getFullYear(), currentMonth + 1, 1);
    // this.minAddPlanDate = nextMonth;

  }
  cancelPlanDate(plan, i) {
    this.cancelPlan = plan
    this.cancelPlanForm.reset()
  }

  deletePlan() {
    if (this.cancelPlanForm.invalid) {
      this.cancelPlanForm.markAllAsTouched()
      return;
    }


    this.terminationDate = moment(this.cancelPlanForm.value.terminationDate).format('DD-MM-YYYY') || ""
    const payload = {
      terminationDate: this.terminationDate,
      planId: this.cancelPlan.id,
      others: {}
    }


    console.log(this.cancelPlan)
    console.log({ payload })

    let deleteplan = '/member/' + this.customerid + '/cancelPlan/configure';

    this.http.post(environment.apiUrl + '/api/ap' + deleteplan, payload, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.cancelPlanDetails = response.data;
        this.planName = this.cancelPlan?.productName;
        this.planprice = this.cancelPlanDetails?.plan?.price;
        this.planCoverage = this.cancelPlanDetails?.plan?.customerPlanProducts[0]?.product?.name
        this.planSubscriptionId = this.cancelPlanDetails?.plan?.subscriptionId;

        console.log(this.cancelPlanDetails?.plan?.customerPlanProducts[0], this.cancelPlanDetails?.plan?.customerPlanProducts?.product,)
        this.getTaxEntries(this.cancelPlanDetails?.taxDataChanges)


        console.log(this.cancelPlanDetails)
        $('#cancelPlanFormModal').modal('hide')
        $('#showCancelPlanDetails').modal('show')
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
    });
  }

  getTaxEntries(taxData: any) {
    if (taxData) {
      this.taxEntries = Object.entries(taxData).map(([key, value]: any) => ({
        name: key,
        plan: value.name,
        price: value.price
      }));
      console.log(this.taxEntries)
    }

  }
  submitDeletePlan() {
    Swal.fire({
      title: this.lang?.Info,
      text: this.lang?.Are_you_sure_you_want_to_Cancel_plan,
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: this.lang?.Proceed,
    }).then((result) => {
      if (result.isConfirmed) {

        this.cancelPlanDetails.proceedWithGreenshield = this.cancelPlanDetails.proceedWithGreenshield ? this.cancelplanFormDetails.get('proceedWithGreenshield').value : this.cancelPlanDetails.proceedWithGreenshield;
        this.cancelPlanDetails.proceedWithRefund = this.cancelPlanDetails.proceedWithRefund ? this.cancelplanFormDetails.get('proceedWithRefund').value : this.cancelPlanDetails.proceedWithRefund;
        this.cancelPlanDetails.proceedWithSmartchoice = this.cancelPlanDetails.proceedWithSmartchoice ? this.cancelplanFormDetails.get('proceedWithSmartchoice').value : this.cancelPlanDetails.proceedWithSmartchoice;
        this.cancelPlanDetails.proceedWithSubscriptionExpiry = this.cancelPlanDetails.proceedWithSubscriptionExpiry ? this.cancelplanFormDetails.get('proceedWithSubscriptionExpiry').value : this.cancelPlanDetails.proceedWithSubscriptionExpiry;
        this.cancelPlanDetails.proceedWithCancelCustomer = this.cancelPlanDetails.proceedWithCancelCustomer ? this.cancelplanFormDetails.get('proceedWithCancelCustomer').value : this.cancelPlanDetails.proceedWithCancelCustomer;
        this.cancelPlanDetails.proceedWithEquitable = this.cancelPlanDetails.proceedWithEquitable ? this.cancelplanFormDetails.get('proceedWithEquitable').value : this.cancelPlanDetails.proceedWithEquitable;
        // this.cancelPlanDetails.proceedWithPHR = this.cancelPlanDetails.proceedWithPHR ? this.cancelplanFormDetails.get('proceedWithPHR').value : this.cancelPlanDetails.proceedWithPHR;

        const payload = {
          planId: this.cancelPlan.id,
          data: this.cancelPlanDetails,
          others: {}
        }

        console.log(this.cancelPlan)
        console.log({ payload })


        let deleteplan = '/member/' + this.customerid + '/cancelPlan';

        this.http.post(environment.apiUrl + '/api/ap' + deleteplan, payload, {
          headers: {
            Authorization: 'Bearer ' + this.accessToken,
            'Content-Type': 'application/json',
          }
        }).subscribe((response: any) => {
          if (response.status == 200) {
            // this.cancelPlanDetails = response.data

            // console.log(this.cancelPlanDetails)
            // $('#cancelPlanFormModal').modal('hide')
            $('#showCancelPlanDetails').modal('hide')

            Swal.fire({ title: this.lang?.Info, html: response.message })
            this.getCustomerData()
            this.cancelplanFormDetails.reset()
            // Swal.fire({})
          }
          else {
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
          }
        }, (error) => {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
        });
      }
    })
  }

  getplansData() {
    if (this.addPlanForm.invalid) {
      this.addPlanForm.markAllAsTouched()
      return;
    }
    this.addPlanEnrollmentDate = moment(this.addPlanForm.value.planEnrollmentDate).format('DD-MM-YYYY') || ""
    const payload = {
      enrollmentDate: this.addPlanEnrollmentDate,
      removeRoleBasedPlans: false,
    }
    $("#addPlanFormModal").modal('hide')
    this.addPlanForm.reset();

    $("#planDetails").modal('show')
    let plans = '/member/' + this.customerid + '/customerPlans';
    this.http.post(environment.apiUrl + '/api/ap' + plans, payload, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      // console.log(response)
      if (response.status == 200) {
        this.specialpackages = response.data.packages
        // this.customerPlans
        // $("#plancheck" + plandetailsobj[19]).click()

        let filteredPackages_ = [];
        //filter the repeated packages for medcan care
        for (let package_ of this.specialpackages) {
          if (package_.id == 5) {
            let groupKeys_ = Object.keys(package_.groups);
            for (let groups of groupKeys_) {
              for (let group of package_.groups[groups]) {
                for (let plan of group.plans) {
                  let pan = plan.productAddonssNames
                  for (let product of plan.productAddonssNames) {
                    // plan.productAddonss[product][0]?.planlevel.id, plan.productAddonss[product][0].product_id
                    if (filteredPackages_[product]) {
                      if (filteredPackages_[product]['planProductIds'].includes(plan.productAddonss[product][0]?.planlevel.id) && filteredPackages_[product]['planProductIds'].includes(plan.productAddonss[product][0].product_id)) {
                        let index = pan.indexOf(product);
                        if (index !== -1) {
                          pan.splice(index, 1);
                        }
                      }
                    } else {
                      filteredPackages_[product] = { 'planProductIds': [] }
                      filteredPackages_[product]['planProductIds'] = [plan.productAddonss[product][0]?.planlevel.id, plan.productAddonss[product][0].product_id]
                    }
                  }

                  plan.productAddonssNames = pan;
                }
              }
            }
          }

        }
        setTimeout(() => {
          this.customerPlans.forEach(element => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            const plan: any = dom.querySelector("#plancheck" + element.planId);


            if (element.isBundle) {
              // if(element.name.includes('Life Insurance' || 'Critical')){

              // }else{

              // }
              $("#plancheck" + element.planId + ".coverage" + element.coverage1.toUpperCase()).click()

            }
            else {
              if (element.coverage) {
                const plan: any = dom.querySelector("#plancheck" + element.planSelectionId2 + ".coverage" + element.coverage1.toUpperCase());

                // $("#plancheck" + element.planSelectionId2 + ".coverage"+element.coverage).click()
                console.log($("#plancheck" + element.planSelectionId2))
                $("#plancheck" + element.planSelectionId2).click()
              }
              else {
                console.log($("#plancheck" + element.planSelectionId2))
                $("#plancheck" + element.planSelectionId2).click()

              }
            }

          });

        }, 1000);

        // console.log(this.specialpackages)
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
    });
  }


  public getSliderBackground(
    rangeValue: any,
    maxRange: any,
    stepCount: any,
    defaultRange: any
  ): any {
    const percentage = (rangeValue / maxRange) * 100;
    let gradientColor = "white";


    // if (percentage >= 8 && stepCount === 25000) {
    //   gradientColor = "green";
    // }
    // return `linear-gradient(to right, ${gradientColor} ${percentage}%, white ${percentage}%)`;



    if (rangeValue <= defaultRange) {
      this.greenValue = (defaultRange / maxRange) * 100;
      this.names = [
        { label: 'Guaranteed', position: this.greenValue },    // Display "Start" at 0%
        { label: 'Pending', position: 100 - this.greenValue }, // Display "Quarter" at 25%

      ];
      this.showyellowbar = false
      return `linear-gradient(to right, green ${(defaultRange / maxRange) * 100}%, lightgray 0%)`;
    } else if (rangeValue > defaultRange) {
      const greenPart = adjustWith2DecimalsForUI((defaultRange / maxRange) * 100);
      console.log(greenPart)
      this.yellowValue = adjustWith2DecimalsForUI((100 - greenPart) * 100);
      // const yellowPart = ((rangeValue - defaultRange) / 4.5) + greenPart;
      const yellowPart = adjustWith2DecimalsForUI((rangeValue / maxRange) * 100)

      console.log(yellowPart)
      this.names = [
        { label: 'Guaranteed', position: greenPart },    // Display "Start" at 0%
        { label: 'Pending', position: yellowPart }, // Display "Quarter" at 25%

      ];
      this.showyellowbar = true
      return `linear-gradient(to right,  green 0%,
        green ${greenPart}%,
        yellow ${greenPart}%,
        yellow ${yellowPart}%,
        lightgray  ${yellowPart}%,
        lightgray  100%)`;
      // return`linear-gradient(to right, green ${greenPart}%, yellow ${yellowPart}%)`;
      // return `linear-gradient(to right, red 30%, yellow 70%)`;
      //  return `linear-gradient(to right, green 0%, green 30%, yellow 30%, yellow 100%)`  working
      //  return `linear-gradient(to right, green 0%, green ${greenPart}%, yellow ${greenPart}%, yellow 100%)`
      //  return `linear-gradient(to right, red ${greenPart}%, yellow ${yellowPart}%)`
      // return`linear-gradient(to right, green 0%, green ${greenPart}%, yellow ${yellowPart}%, yellow 100%)`;

    }
  }

  public isDataAvailable(type: string, category: string, feild?: string): boolean {
    // console.log(this.allFormData)
    // console.log(type)
    // console.log(category)
    // console.log(feild)
    const bool = feild ? !(this.allFormData[type] && this.allFormData[type][category] && this.allFormData[type][category][feild]) : !(this.allFormData[type] && this.allFormData[type][category]);
    return bool
  }
  public isDataAvailableSpouseDataa(type: string, category: string, feild?: string): boolean {
    console.log(this.allFormData)
    console.log(type)
    console.log(category)
    console.log(feild)

    // const bool = feild?this.allFormData[type] && this.allFormData[type][category]:false;
    // return bool

    const bool = feild ? !(this.allFormData[type] && this.allFormData[type][category] && this.allFormData[type][category][feild]) : !(this.allFormData[type] && this.allFormData[type][category]);
    return bool
  }
  public isDataAvailableSpouse(type: string, category: string, feild?: string): boolean {

    if (this.allFormData[type]) {
      console.log(this.allFormData[type]['member'])
    }

    if (this.allFormData[type] && this.allFormData[type]['member']) {
      return false
    }
    else {
      return true
    }


  }
  public generateTicks(maxRange: any, stepCount: any): any[] {
    const ticks = [];
    const totalTicks = maxRange / stepCount;

    for (let i = 0; i <= totalTicks; i++) {
      ticks.push(i * stepCount);
    }

    return ticks;
  }

  public updateTotal(data: any) {
    const memberPremium =
      data.member && data.member.premium > 0 ? data.member.premium : 0;
    const spousePremium =
      data.spouse && data.spouse.premium > 0 ? data.spouse.premium : 0;
    const dependentPremium =
      data.dependent && data.dependent.premium > 0 ? data.dependent.premium : 0;
    const total = memberPremium + spousePremium + dependentPremium;

    return total;
  }
  public updateFormData(
    type: string,
    category: string,
    newData: any,
    remove: boolean = false
  ): void {


    if (this.lastUpdatedType !== type) {
      this.formData = this.allFormData[type]
        ? { ...this.allFormData[type] }
        : {};
    }

    let updatedFormData = { ...this.formData };
    let shouldUpdateTotal = false;
    console.log(updatedFormData)
    if (remove) {
      delete updatedFormData[category];
      delete updatedFormData.total;
    } else if (typeof newData === "object" && newData !== null) {
      updatedFormData[category] = { ...updatedFormData[category], ...newData };
      shouldUpdateTotal = "coverage" in newData || category === "dependent" || "isSmoker" in newData;
    } else {
      updatedFormData[category] = newData;
    }

    if (
      shouldUpdateTotal &&
      ["member", "spouse", "dependent"].includes(category)
    ) {
      updatedFormData.total = this.updateTotal(updatedFormData);
    }

    this.formData = updatedFormData;
    this.allFormData[type] = { ...this.formData };
    // this.allFormData = { ...this.allFormData, [type]: this.formData };
    this.lastUpdatedType = type;
    console.log("formData:", this.allFormData);


  }

  public calculateAge(dob: string) {
    const today = new Date();
    const birthDate = new Date(dob);

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  }

  public updatePremium(
    type: string,
    category: string,
    newIsSmokerValue: string
  ) {

    //  if (this.allFormData[type][category]) {
    //   const isSmokerValue = event.target.value=== "yes" ? "smoker" : "nonSmoker";

    //   console.log(isSmokerValue)
    //   let gender:any = this.userForm.value.gender?.toLowerCase()
    //   let value: any = 0;
    //   console.log(this.allFormData[type][category]["coverage"])
    //   value=this.allFormData[type][category]["coverage"][gender][isSmokerValue]
    //   console.log(value)
    //   const premium = (this.allFormData[type][category]["coverage"].maximumCoverageWithoutEvidence * value) / 1000;
    //   console.log(parseFloat(premium.toFixed(2)))
    //   this.updateFormData(type, category, {
    //     isSmoker: isSmokerValue,
    //     premium: parseFloat(premium.toFixed(2))
    //   });
    // }

    console.log(this.allFormData)
    // const coverage = this.allFormData[type][category].coverage.maximumCoverageWithoutEvidence;

    const coverage = this.allFormData[type][category].coverage.maximumCoverageWithoutEvidence / 25000;
    const isSmoker = newIsSmokerValue === "yes" ? "smoker" : "nonSmoker";
    let value: any = 0;
    let gender: any = this.customerData.gender?.toLowerCase()
    let spouseGender: any = this.customerData?.spousegender?.toLowerCase()

    console.log(spouseGender)

    if (category === "member") {
      value = this.allFormData[type][category]["coverage"]["price"][gender][isSmoker]
    }

    if (category === "spouse") {
      value = this.allFormData[type][category]["coverage"]["price"][spouseGender][isSmoker]
    }
    console.log({ value })

    this.updateFormData(type, category, { constant: value });

    if (coverage > 0) {
      // const premium = (coverage * value) / 1000;

      const premium = (coverage * value);
      return parseFloat(premium.toFixed(2));
    }
    console.log("formData:", this.allFormData);
    return 0;

  }

  public updateDependentPremium(type: string, category: string, coverage: number) {
    // const constant = coverage > 5000 ? 2.56 : 1.28;
    // this.updateFormData(type, category, { constant: constant });

    // const p =
    //   (constant * coverage) / 1000;
    // return parseFloat(p.toFixed(2));
  }
  public handleRadioChange(event: any, type: string, category: string, options: any, plan: any, product: any, pckage: any, group: any, value: any): void {
    let plansummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');
    let isSmokerValue = event.target.value;
    let plandetails = event.target.attributes.data.value;

    let plandetailsobj = plandetails.split('##');
    let smokerCheck: any = ''

    if (isSmokerValue == "no") {
      smokerCheck = false
    }
    else {
      smokerCheck = true
    }

    this.rangeValues = []


    this.allFormData[type][category].coverage = value

    if (this.allFormData[type][category]) {

      this.updateFormData(type, category, {
        isSmoker: isSmokerValue,
        premium: this.updatePremium(type, category, isSmokerValue),
      });
    }

    console.log(this.allFormData)
    let lifeCoverage = ''
    let memberObj: any = {}
    let spouseObj: any = {}

    if (category == "member") {
      lifeCoverage = "MEMBER"
    }
    else {
      lifeCoverage = "MEMBER & SPOUSE"
    }

    if (this.allFormData[type]['spouse']) {
      lifeCoverage = "MEMBER & SPOUSE"

    }







    plansummaryLife.forEach((element: any, index: any) => {

      if (element.planname == plandetailsobj[14]) {
        plansummaryLife.splice(index, 1)
      }
      sessionStorage.setItem('plansummaryLife', JSON.stringify(plansummaryLife));

    })
    let memberPrice = this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence > this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence - this.allFormData[type]["member"].coverage.defaultRange) / 25000) : 0
    let spousePrice: any;
    if (this.allFormData[type]['spouse']) {
      spousePrice = this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence > this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence - this.allFormData[type]["spouse"].coverage.defaultRange) / 25000) : 0
    }


    setTimeout(() => {
      // console.log(this.allFormData[type][category].premium)

      let obj: any = {
        isBundle: plan.isBundle,
        // enrollmentDate: moment(
        //   this.userForm.get("planenrollmentdate").value,
        //   "MM-DD-YYYY"
        // ).format("YYYY-MM-DD"),
        enrollmentDate: this.customerData.enrollmentDate
          ? this._CustomDatePipe.transform(
            this.customerData.enrollmentDate
          )
          : undefined,
        // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
        name: plandetailsobj[14],
        details: plandetailsobj[0],
        packagename: plandetailsobj[0],
        groupName: plandetailsobj[1],
        amount: this.allFormData[type].total,
        // amount: this.allFormData[type][category].premium,
        planCoverage: plandetailsobj[2],
        planPrice: adjustWith2DecimalsForUI(this.allFormData[type].total),
        amountUI:
          '$' +
          adjustWith2DecimalsForUI(this.allFormData[type].total),
        gst:
          plandetailsobj[4] == null ||
            plandetailsobj[4] == '' ||
            plandetailsobj[4] == undefined ||
            plandetailsobj[4] == 'null'
            ? 0
            : parseFloat(plandetailsobj[4]),
        hst:
          plandetailsobj[5] == null ||
            plandetailsobj[5] == '' ||
            plandetailsobj[5] == undefined ||
            plandetailsobj[5] == 'null'
            ? 0
            : parseFloat(plandetailsobj[5]),
        pst:
          plandetailsobj[6] == null ||
            plandetailsobj[6] == '' ||
            plandetailsobj[6] == undefined ||
            plandetailsobj[6] == 'null'
            ? 0
            : parseFloat(plandetailsobj[6]),
        qst:
          plandetailsobj[17] == null ||
            plandetailsobj[17] == '' ||
            plandetailsobj[17] == undefined ||
            plandetailsobj[17] == 'null'
            ? 0
            : parseFloat(plandetailsobj[17]),
        gstCheck:
          plandetailsobj[4] == null ||
            plandetailsobj[4] == '' ||
            plandetailsobj[4] == undefined ||
            plandetailsobj[4] == 'null'
            ? false
            : true,
        hstCheck:
          plandetailsobj[5] == null ||
            plandetailsobj[5] == '' ||
            plandetailsobj[5] == undefined ||
            plandetailsobj[5] == 'null'
            ? false
            : true,
        pstCheck:
          plandetailsobj[6] == null ||
            plandetailsobj[6] == '' ||
            plandetailsobj[6] == undefined ||
            plandetailsobj[6] == 'null'
            ? false
            : true,
        qstCheck:
          plandetailsobj[17] == null ||
            plandetailsobj[17] == '' ||
            plandetailsobj[17] == undefined ||
            plandetailsobj[17] == 'null'
            ? false
            : true,
        id: parseFloat(plandetailsobj[7]),
        fusebillPlanID:
          plandetailsobj[8] == null ||
            plandetailsobj[8] == '' ||
            plandetailsobj[8] == undefined ||
            plandetailsobj[8] == 'null'
            ? 0
            : parseFloat(plandetailsobj[8]),
        planFrequencyID:
          plandetailsobj[9] == null ||
            plandetailsobj[9] == '' ||
            plandetailsobj[9] == undefined ||
            plandetailsobj[9] == 'null'
            ? 0
            : parseFloat(plandetailsobj[9]),
        optIn: plandetailsobj[10] == 'true' ? true : false,
        planname: plandetailsobj[14],
        planLevel: parseInt(plandetailsobj[15]),
        packageId: parseInt(plandetailsobj[16]),
        options: [],
        version: plan.version,
        description: plan.description,
        insuranceType: plan.insuranceType

        //  "disallowedPlanLevels":plandetailsobj[11]
      };

      if (this.customerType == 'CORP') {
        obj["categorization"] = {
          paidByCompany: 0,
          coveredByCompany: 0,
          paidByEmployee: 1,
        }
      }

      if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
        if (plandetailsobj[11].includes(plandetailsobj[12])) {
        }
      }
      ///this.consoleMessage(obj)
      this.productobj = {
        id: product.id,
        productId: product.productId,
        name: product.name,
        planProductId: product.planProductId,
        price: adjustWith2DecimalsForUI(this.allFormData[type].total),
        tax: this._decimalPipe
          .transform(
            product.calculatedTax ? product.calculatedTax.tax : 0,
            '1.2-2'
          )
          ?.replace(/,/g, ''),
        total: this._decimalPipe
          .transform(
            product.calculatedTax ? product.calculatedTax.total : 0,
            '1.2-2'
          )
          ?.replace(/,/g, ''),
        tax_details:
          product.bundledTaxes && product.bundledTaxes.length > 0
            ? product.bundledTaxes
            : product.taxesDataJSON,
        calculatedTax: this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []),
        bundledProducts: product.bundledProducts,
        planCoverage: lifeCoverage,
        planLevel: product.planlevel ? product.planlevel.id : '',
        planLevelParent: product.planlevel ? product.planlevel.parentId : '',
        description: product.description,
        coverage: lifeCoverage,
        version: product.version
      };

      this.productobj.total = this._decimalPipe
        .transform(
          this.productobj.calculatedTax ? this.productobj.calculatedTax.total : 0,
          '1.2-2'
        )
        ?.replace(/,/g, '')
      this.productobj.tax = this._decimalPipe
        .transform(
          this.productobj.calculatedTax ? this.productobj.calculatedTax.tax : 0,
          '1.2-2'
        )
        ?.replace(/,/g, '')


      if (category == "member") {

        memberObj = {
          "planStartDate": this.customerData.enrollmentDate
            ? this._CustomDatePipe.transform(
              this.customerData.enrollmentDate
            )
            : undefined,
          "units": (this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
          "standardUnits": this.allFormData[type]["member"].coverage.minimumCoverage,
          "coverage": "MEMBER",
          "guaranteedAcceptance": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=
            this.allFormData[type]["member"].coverage.defaultRange ? true : false, //defalutRange
          "pendingMedicalQuestionaire": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >
            this.allFormData[type]["member"].coverage.defaultRange ? true : false,
          // "guaranteedAcceptanceAmount":this.allFormData[type]["member"].coverageValue <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverageValue/25000)*this.allFormData[type][category].constant):this.allFormData[type]["member"].coverage.defaultRange,

          "guaranteedAcceptanceAmount": adjustWith2DecimalsForUI(this.allFormData[type]["member"].coverageValue <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverageValue / 25000) * this.allFormData[type][category].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type][category].constant)),
          "pendingApprovalAmount": adjustWith2DecimalsForUI(memberPrice * this.allFormData[type][category].constant) || 0,
          "smoker": this.allFormData[type]["member"].isSmoker == "yes" ? true : false,
          "age": this.allFormData[type]["member"].coverage.age,
          "gender": this.customerData.gender?.toLowerCase(),
          "province": "ON",
          "provinceId": 12,
          "amount": this.allFormData[type]["member"].premium,
          "tax": adjustWith2DecimalsForUI(this.productobj.tax),
          "taxRate": "", //not mandatory,
          "taxName": "",
          "coverageValue": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "premium": this.allFormData[type]["member"].constant,
          "total": adjustWith2DecimalsForUI(this.productobj.total),
          "coverageUnitPrice": this.allFormData[type]["member"].coverage.coverageUnitPrice,
          "defaultRange": this.allFormData[type]["member"].coverage.defaultRange,
          "maximumCoverageWithEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
          "maximumCoverageWithoutEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "minimumCoverage": this.allFormData[type]["member"].coverage.minimumCoverage,
        }

        memberObj["guaranteedAcceptanceTax"] = adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverageValue <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverageValue / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).tax)
        memberObj["guaranteedAcceptanceTotal"] = adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverageValue <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverageValue / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).total)

        memberObj["pendingApprovalTax"] = adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).tax)
        memberObj["pendingApprovalTotal"] = adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).total)

        obj["member"] = memberObj
        obj["spouse"] = {}
        if (this.allFormData[type]['spouse']) {
          spouseObj = {
            "planStartDate": this.customerData.enrollmentDate
              ? this._CustomDatePipe.transform(
                this.customerData.enrollmentDate
              )
              : undefined,
            "units": (this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
            "standardUnits": this.allFormData[type]["spouse"].coverage.minimumCoverage,
            "coverage": "MEMBER & SPOUSE",
            "guaranteedAcceptance": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=
              this.allFormData[type]["spouse"].coverage.defaultRange ? true : false, //defalutRange
            "pendingMedicalQuestionaire": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >
              this.allFormData[type]["spouse"].coverage.defaultRange ? true : false,
            "guaranteedAcceptanceAmount": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type][category].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type][category].constant),
            "pendingApprovalAmount": adjustWith2DecimalsForUI(spousePrice * this.allFormData[type][category].constant) || 0,
            "smoker": this.allFormData[type]["spouse"].isSmoker == "yes" ? true : false,
            "age": this.allFormData[type]["spouse"].coverage.age,
            "gender": this.customerData?.spousegender?.toLowerCase(),
            "province": "ON",
            "provinceId": 12,
            "amount": this.allFormData[type]["spouse"].premium,
            "tax": adjustWith2DecimalsForUI(this.productobj.tax),
            "taxRate": "", //not mandatory,
            "taxName": "",
            "coverageValue": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
            "premium": this.allFormData[type]["spouse"].constant,
            "total": adjustWith2DecimalsForUI(this.productobj.total),
            "coverageUnitPrice": this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
            "defaultRange": this.allFormData[type]["spouse"].coverage.defaultRange,
            "maximumCoverageWithEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
            "maximumCoverageWithoutEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
            "minimumCoverage": this.allFormData[type]["spouse"].coverage.minimumCoverage,
          }






          obj["member"] = memberObj
          obj["spouse"] = spouseObj

          spouseObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type][category].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type][category].constant), product.taxesDataJSON ?? []).tax
          spouseObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type][category].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type][category].constant), product.taxesDataJSON ?? []).total

          spouseObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type][category].constant, product.taxesDataJSON ?? []).tax
          spouseObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type][category].constant, product.taxesDataJSON ?? []).total
        }
      }
      else {

        memberObj = {
          "planStartDate": this.customerData.enrollmentDate
            ? this._CustomDatePipe.transform(
              this.customerData.enrollmentDate
            )
            : undefined,
          "units": (this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
          "standardUnits": this.allFormData[type]["member"].coverage.minimumCoverage,
          "coverage": "MEMBER",
          "guaranteedAcceptance": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=
            this.allFormData[type]["member"].coverage.defaultRange ? true : false, //defalutRange
          "pendingMedicalQuestionaire": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >
            this.allFormData[type]["member"].coverage.defaultRange ? true : false,
          "guaranteedAcceptanceAmount": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant),

          "pendingApprovalAmount": adjustWith2DecimalsForUI(memberPrice * this.allFormData[type][category].constant) || 0,
          "smoker": this.allFormData[type]["member"].isSmoker == "yes" ? true : false,
          "age": this.allFormData[type]["member"].coverage.age,
          "gender": this.customerData.gender?.toLowerCase(),
          "province": "ON",
          "provinceId": 12,
          "amount": this.allFormData[type]["member"].premium,
          "tax": adjustWith2DecimalsForUI(this.productobj.tax),
          "taxRate": "", //not mandatory,
          "taxName": "",
          "coverageValue": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "premium": this.allFormData[type]["member"].constant,
          "total": adjustWith2DecimalsForUI(this.productobj.total),
          "coverageUnitPrice": this.allFormData[type]["member"].coverage.coverageUnitPrice,
          "defaultRange": this.allFormData[type]["member"].coverage.defaultRange,
          "maximumCoverageWithEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
          "maximumCoverageWithoutEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "minimumCoverage": this.allFormData[type]["member"].coverage.minimumCoverage,
        }
        spouseObj = {
          "planStartDate": this.customerData.enrollmentDate
            ? this._CustomDatePipe.transform(
              this.customerData.enrollmentDate
            )
            : undefined,
          "units": (this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
          "standardUnits": this.allFormData[type]["spouse"].coverage.minimumCoverage,
          "coverage": "MEMBER & SPOUSE",
          "guaranteedAcceptance": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=
            this.allFormData[type]["spouse"].coverage.defaultRange ? true : false, //defalutRange
          "pendingMedicalQuestionaire": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >
            this.allFormData[type]["spouse"].coverage.defaultRange ? true : false,
          "guaranteedAcceptanceAmount": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type][category].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type][category].constant),
          "pendingApprovalAmount": adjustWith2DecimalsForUI(spousePrice * this.allFormData[type][category].constant) || 0,
          "smoker": this.allFormData[type]["spouse"].isSmoker == "yes" ? true : false,
          "age": this.allFormData[type]["spouse"].coverage.age,
          "gender": this.customerData?.spousegender?.toLowerCase(),
          "province": "ON",
          "provinceId": 12,
          "amount": this.allFormData[type]["spouse"].premium,
          "tax": adjustWith2DecimalsForUI(this.productobj.tax),
          "taxRate": "", //not mandatory,
          "taxName": "",
          "coverageValue": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
          "premium": this.allFormData[type]["spouse"].constant,
          "total": adjustWith2DecimalsForUI(this.productobj.total),
          "coverageUnitPrice": this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
          "defaultRange": this.allFormData[type]["spouse"].coverage.defaultRange,
          "maximumCoverageWithEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
          "maximumCoverageWithoutEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
          "minimumCoverage": this.allFormData[type]["spouse"].coverage.minimumCoverage,
        }

        obj["member"] = memberObj
        obj["spouse"] = spouseObj


        memberObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).tax
        memberObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).total

        spouseObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant), product.taxesDataJSON ?? []).tax
        spouseObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant), product.taxesDataJSON ?? []).total

        memberObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).tax
        memberObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).total

        spouseObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type]["spouse"].constant, product.taxesDataJSON ?? []).tax
        spouseObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type]["spouse"].constant, product.taxesDataJSON ?? []).total

      }

      let MSguranteeAcceptanceAmount = adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceAmount"] + (spouseObj["guaranteedAcceptanceAmount"] ?? 0))
      let MSguranteeAcceptancetTAX = adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceTax"] + (spouseObj["guaranteedAcceptanceTax"] ?? 0))
      let MSguranteeAcceptancetTotal = adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceTotal"] + (spouseObj["guaranteedAcceptanceTotal"] ?? 0))

      let MSpendingApprovalAmount = adjustWith2DecimalsForUI(memberObj["pendingApprovalAmount"] + (spouseObj["pendingApprovalAmount"] ?? 0))
      let MSpendingApprovalTAX = adjustWith2DecimalsForUI(memberObj["pendingApprovalTax"] + (spouseObj["pendingApprovalTax"] ?? 0))
      let MSpendingApprovalTotal = adjustWith2DecimalsForUI(memberObj["pendingApprovalTotal"] + (spouseObj["pendingApprovalTotal"] ?? 0))

      let obj1: any = {
        packageId: plan.packageId,
        packageName: pckage.name,

        planproductname: this.productobj.name,

        groupid: plan.planLevel,
        groupName: group.name,
        id: plan.id,
        name: plan.name,
        planLevel: plan.planLevel ? plan.planLevel : group.id,
        planLevelParent: group.parentId,
        fusebillPlanID: plan.fusebillId,
        planFrequencyID: plan.frqMonthly,
        isBundle: plan.isBundle,
        coverage: lifeCoverage,
        planCoverage: product.planCoverage,
        bundledProducts: [],
        products: [],
        version: plan.version,
        guaranteedAcceptanceDetails: {
          "amount": MSguranteeAcceptanceAmount,
          "tax": MSguranteeAcceptancetTAX,
          "total": MSguranteeAcceptancetTotal,
          "products": [{
            id: product.id,
            productId: product.productId,
            name: product.name,
            planProductId: product.planProductId,
            price: adjustWith2DecimalsForUI(this.allFormData[type].total),
            tax_details:
              product.bundledTaxes && product.bundledTaxes.length > 0
                ? product.bundledTaxes
                : product.taxesDataJSON,
            calculatedTax: this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []),
            bundledProducts: product.bundledProducts,
            planCoverage: lifeCoverage,
            planLevel: product.planlevel ? product.planlevel.id : '',
            planLevelParent: product.planlevel ? product.planlevel.parentId : '',
            description: product.description,
            coverage: lifeCoverage,
            version: product.version,
            total: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []).total : 0,
                '1.2-2'
              )
              ?.replace(/,/g, ''),
            tax: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []).tax : 0,
                '1.2-2'
              )
              ?.replace(/,/g, '')
          }]


        },
        pendingApprovalDetails: {
          "amount": MSpendingApprovalAmount,
          "tax": this._decimalPipe
            .transform(
              this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).tax : 0,
              '1.2-2'
            )
            ?.replace(/,/g, ''),
          "total": this._decimalPipe
            .transform(
              this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).total : 0,
              '1.2-2'
            )
            ?.replace(/,/g, ''),
          "products": [{
            id: product.id,
            productId: product.productId,
            name: product.name,
            planProductId: product.planProductId,
            price: adjustWith2DecimalsForUI(this.allFormData[type].total),
            tax_details:
              product.bundledTaxes && product.bundledTaxes.length > 0
                ? product.bundledTaxes
                : product.taxesDataJSON,
            calculatedTax: this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []),
            bundledProducts: product.bundledProducts,
            planCoverage: lifeCoverage,
            planLevel: product.planlevel ? product.planlevel.id : '',
            planLevelParent: product.planlevel ? product.planlevel.parentId : '',
            description: product.description,
            coverage: lifeCoverage,
            version: product.version,
            total: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).total : 0,
                '1.2-2'
              )
              ?.replace(/,/g, ''),
            tax: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).tax : 0,
                '1.2-2'
              )
              ?.replace(/,/g, '')
          }]
        },
        selectedDetails: {
          "amount": adjustWith2DecimalsForUI(this.allFormData[type].total),
          "total": adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []).total : 0),

          "tax": adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []).tax : 0),
          "products": [this.productobj]
        }


      };

      obj["guaranteedAcceptanceDetails"] = obj1.guaranteedAcceptanceDetails
      obj["pendingApprovalDetails"] = obj1.pendingApprovalDetails
      obj["selectedDetails"] = obj1.selectedDetails
      obj1.products.push(this.productobj);

      this.addtoplansummaryLife(obj, obj1);
    }, 100);
    for (let i = this.minValue; i <= this.allFormData[type][category]?.coverage?.maximumCoverageWithEvidence; i += 100000) {
      this.rangeValues.push(i);
    }


    /*
    Form Here the code works for auto slection of Smoker in Life and critical vice versa
     */

    plansummaryLife.forEach((element: any, index: any) => {


      if (category == "member") {

        if (element.member.smoker == isSmokerValue) {
        }
        else {


          const dom: HTMLElement = this.elementRef.nativeElement;

          const plan: any = dom.querySelector("." + "member" + "-" + element.planCoverage + "-" + isSmokerValue);
          console.log(plan)
          setTimeout(() => {
            plan.click()
          }, 1000);

        }
      }
      if (category == "spouse") {


        if (element.spouse.smoker == isSmokerValue) {
        }
        else {


          const dom: HTMLElement = this.elementRef.nativeElement;

          const plan: any = dom.querySelector("." + "spouse" + "-" + element.planCoverage + "-" + isSmokerValue);
          console.log(plan)
          setTimeout(() => {
            plan.click()
          }, 1000);

        }
      }




    })
  }

  public handleRangeChange(value: any, type: string, category: string, options: any, plan: any, product: any, pckage: any, group: any, event: any, data: any): void {
    // console.log(value)
    // console.log(type)
    // console.log(event)
    // console.log(data)


    if (data.maximumCoverageWithoutEvidence == 0) {
      data.maximumCoverageWithoutEvidence = 25000
    }
    this.allFormData[type][category].coverage = data

    // this.sliderValue = this.allFormData[type][category].coverage.maximumCoverageWithoutEvidence


    this.rangeValues = [];




    if (this.allFormData[type][category]) {
      this.updateFormData(type, category, {
        // coverage: value,
        isSmoker: this.allFormData[type][category].isSmoker,
        premium: this.updatePremium(type, category, this.allFormData[type][category].isSmoker),
      });
    }
    let lifeCoverage = ''
    let memberObj: any = {}
    let spouseObj: any = {}
    if (category == "member") {
      lifeCoverage = "MEMBER"
    } else {
      lifeCoverage = "MEMBER & SPOUSE"
    }

    if (this.allFormData[type]['spouse']) {
      lifeCoverage = "MEMBER & SPOUSE"

    }

    let plansummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');


    let plandetails = event.target.attributes.data.value;

    let plandetailsobj = plandetails.split('##');


    plansummaryLife.forEach((element: any, index: any) => {

      if (element.planname == plandetailsobj[14]) {
        plansummaryLife.splice(index, 1)
      }
      sessionStorage.setItem('plansummaryLife', JSON.stringify(plansummaryLife));

    })
    setTimeout(() => {
      // console.log(this.allFormData[type][category].premium)

      let obj: any = {
        isBundle: plan.isBundle,
        // enrollmentDate: moment(
        //   this.userForm.get("planenrollmentdate").value,
        //   "MM-DD-YYYY"
        // ).format("YYYY-MM-DD"),
        enrollmentDate: this.customerData.enrollmentDate
          ? this._CustomDatePipe.transform(
            this.customerData.enrollmentDate
          )
          : undefined,
        // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
        name: plandetailsobj[14],
        details: plandetailsobj[0],
        packagename: plandetailsobj[0],
        groupName: plandetailsobj[1],
        amount: this.allFormData[type].total,
        // amount: this.allFormData[type][category].premium,
        planCoverage: plandetailsobj[2],
        planPrice: adjustWith2DecimalsForUI(this.allFormData[type].total),
        amountUI:
          '$' +
          adjustWith2DecimalsForUI(this.allFormData[type].total),
        gst:
          plandetailsobj[4] == null ||
            plandetailsobj[4] == '' ||
            plandetailsobj[4] == undefined ||
            plandetailsobj[4] == 'null'
            ? 0
            : parseFloat(plandetailsobj[4]),
        hst:
          plandetailsobj[5] == null ||
            plandetailsobj[5] == '' ||
            plandetailsobj[5] == undefined ||
            plandetailsobj[5] == 'null'
            ? 0
            : parseFloat(plandetailsobj[5]),
        pst:
          plandetailsobj[6] == null ||
            plandetailsobj[6] == '' ||
            plandetailsobj[6] == undefined ||
            plandetailsobj[6] == 'null'
            ? 0
            : parseFloat(plandetailsobj[6]),
        qst:
          plandetailsobj[17] == null ||
            plandetailsobj[17] == '' ||
            plandetailsobj[17] == undefined ||
            plandetailsobj[17] == 'null'
            ? 0
            : parseFloat(plandetailsobj[17]),
        gstCheck:
          plandetailsobj[4] == null ||
            plandetailsobj[4] == '' ||
            plandetailsobj[4] == undefined ||
            plandetailsobj[4] == 'null'
            ? false
            : true,
        hstCheck:
          plandetailsobj[5] == null ||
            plandetailsobj[5] == '' ||
            plandetailsobj[5] == undefined ||
            plandetailsobj[5] == 'null'
            ? false
            : true,
        pstCheck:
          plandetailsobj[6] == null ||
            plandetailsobj[6] == '' ||
            plandetailsobj[6] == undefined ||
            plandetailsobj[6] == 'null'
            ? false
            : true,
        qstCheck:
          plandetailsobj[17] == null ||
            plandetailsobj[17] == '' ||
            plandetailsobj[17] == undefined ||
            plandetailsobj[17] == 'null'
            ? false
            : true,
        id: parseFloat(plandetailsobj[7]),
        fusebillPlanID:
          plandetailsobj[8] == null ||
            plandetailsobj[8] == '' ||
            plandetailsobj[8] == undefined ||
            plandetailsobj[8] == 'null'
            ? 0
            : parseFloat(plandetailsobj[8]),
        planFrequencyID:
          plandetailsobj[9] == null ||
            plandetailsobj[9] == '' ||
            plandetailsobj[9] == undefined ||
            plandetailsobj[9] == 'null'
            ? 0
            : parseFloat(plandetailsobj[9]),
        optIn: plandetailsobj[10] == 'true' ? true : false,
        planname: plandetailsobj[14],
        planLevel: parseInt(plandetailsobj[15]),
        packageId: parseInt(plandetailsobj[16]),
        options: [],
        version: plan.version,
        description: plan.description,
        insuranceType: plan.insuranceType

        //  "disallowedPlanLevels":plandetailsobj[11]
      };
      if (this.customerType == 'CORP') {
        obj["categorization"] = {
          paidByCompany: 0,
          coveredByCompany: 0,
          paidByEmployee: 1,
        }
      }
      if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
        if (plandetailsobj[11].includes(plandetailsobj[12])) {
        }
      }
      ///this.consoleMessage(obj)
      this.productobj = {
        id: product.id,
        productId: product.productId,
        name: product.name,
        planProductId: product.planProductId,
        price: adjustWith2DecimalsForUI(this.allFormData[type].total),
        tax: this._decimalPipe
          .transform(
            product.calculatedTax ? product.calculatedTax.tax : 0,
            '1.2-2'
          )
          ?.replace(/,/g, ''),
        total: this._decimalPipe
          .transform(
            product.calculatedTax ? product.calculatedTax.total : 0,
            '1.2-2'
          )
          ?.replace(/,/g, ''),
        tax_details:
          product.bundledTaxes && product.bundledTaxes.length > 0
            ? product.bundledTaxes
            : product.taxesDataJSON,
        calculatedTax: this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []),
        bundledProducts: product.bundledProducts,
        planCoverage: lifeCoverage,
        planLevel: product.planlevel ? product.planlevel.id : '',
        planLevelParent: product.planlevel ? product.planlevel.parentId : '',
        description: product.description,
        coverage: lifeCoverage,
        version: product.version
      };

      this.productobj.total = this._decimalPipe
        .transform(
          this.productobj.calculatedTax ? this.productobj.calculatedTax.total : 0,
          '1.2-2'
        )
        ?.replace(/,/g, '')
      this.productobj.tax = this._decimalPipe
        .transform(
          this.productobj.calculatedTax ? this.productobj.calculatedTax.tax : 0,
          '1.2-2'
        )
        ?.replace(/,/g, '')
      // console.log(this.allFormData)
      // console.log(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence )
      // console.log(this.allFormData[type]["member"].coverage.defaultRange)
      // console.log((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)

      // console.log(((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type][category].constant)

      let memberPrice = this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence > this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence - this.allFormData[type]["member"].coverage.defaultRange) / 25000) : 0
      let spousePrice: any;
      if (this.allFormData[type]['spouse']) {
        spousePrice = this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence > this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence - this.allFormData[type]["spouse"].coverage.defaultRange) / 25000) : 0
      }
      // console.log(price)
      // console.log(price*this.allFormData[type]["member"].constant)
      // console.log(product.taxesDataJSON)
      // console.log(this.calculateTaxForProductTaxesData(price*this.allFormData[type]["member"].constant,product.taxesDataJSON??[]))
      // console.log(this.calculateTaxForProductTaxesData(price*this.allFormData[type]["member"].constant,product.taxesDataJSON??[]).tax)
      // console.log(this.calculateTaxForProductTaxesData(price*this.allFormData[type]["member"].constant,product.taxesDataJSON??[]).total)
      if (category == "member") {

        memberObj = {
          "planStartDate": this.customerData.enrollmentDate
            ? this._CustomDatePipe.transform(
              this.customerData.enrollmentDate
            )
            : undefined,
          "units": (this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
          "standardUnits": this.allFormData[type]["member"].coverage.minimumCoverage,
          "coverage": "MEMBER",
          "guaranteedAcceptance": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=
            this.allFormData[type]["member"].coverage.defaultRange ? true : false, //defalutRange
          "pendingMedicalQuestionaire": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >
            this.allFormData[type]["member"].coverage.defaultRange ? true : false,


          "guaranteedAcceptanceAmount": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant),
          "pendingApprovalAmount": adjustWith2DecimalsForUI(memberPrice * this.allFormData[type][category].constant) || 0,
          "smoker": this.allFormData[type]["member"].isSmoker == "yes" ? true : false,
          "age": this.allFormData[type]["member"].coverage.age,
          "gender": this.customerData.gender?.toLowerCase(),
          "province": "ON",
          "provinceId": 12,
          "amount": this.allFormData[type]["member"].premium,
          "tax": adjustWith2DecimalsForUI(this.productobj.tax),
          "taxRate": "", //not mandatory,
          "taxName": "",
          "coverageValue": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "premium": this.allFormData[type]["member"].constant,
          "total": adjustWith2DecimalsForUI(this.productobj.total),
          "coverageUnitPrice": this.allFormData[type]["member"].coverage.coverageUnitPrice,
          "defaultRange": this.allFormData[type]["member"].coverage.defaultRange,
          "maximumCoverageWithEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
          "maximumCoverageWithoutEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "minimumCoverage": this.allFormData[type]["member"].coverage.minimumCoverage,
        }
        memberObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).tax
        memberObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).total

        memberObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).tax
        memberObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).total

        obj["member"] = memberObj
        obj["spouse"] = {}

        if (this.allFormData[type]['spouse']) {
          spouseObj = {
            "planStartDate": this.customerData.enrollmentDate
              ? this._CustomDatePipe.transform(
                this.customerData.enrollmentDate
              )
              : undefined,
            "units": (this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
            "standardUnits": this.allFormData[type]["spouse"].coverage.minimumCoverage,
            "coverage": "MEMBER & SPOUSE",
            "guaranteedAcceptance": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=
              this.allFormData[type]["spouse"].coverage.defaultRange ? true : false, //defalutRange
            "pendingMedicalQuestionaire": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >
              this.allFormData[type]["spouse"].coverage.defaultRange ? true : false,
            "guaranteedAcceptanceAmount": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant),
            "pendingApprovalAmount": adjustWith2DecimalsForUI(spousePrice * this.allFormData[type][category].constant) || 0,
            "smoker": this.allFormData[type]["spouse"].isSmoker == "yes" ? true : false,
            "age": this.allFormData[type]["spouse"].coverage.age,
            "gender": this.customerData?.spousegender?.toLowerCase(),
            "province": "ON",
            "provinceId": 12,
            "amount": this.allFormData[type]["spouse"].premium,
            "tax": adjustWith2DecimalsForUI(this.productobj.tax),
            "taxRate": "", //not mandatory,
            "taxName": "",
            "coverageValue": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
            "premium": this.allFormData[type]["spouse"].constant,
            "total": adjustWith2DecimalsForUI(this.productobj.total),
            "coverageUnitPrice": this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
            "defaultRange": this.allFormData[type]["spouse"].coverage.defaultRange,
            "maximumCoverageWithEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
            "maximumCoverageWithoutEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
            "minimumCoverage": this.allFormData[type]["spouse"].coverage.minimumCoverage,
          }






          obj["member"] = memberObj
          obj["spouse"] = spouseObj

          spouseObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant), product.taxesDataJSON ?? []).tax
          spouseObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant), product.taxesDataJSON ?? []).total

          spouseObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type]["spouse"].constant, product.taxesDataJSON ?? []).tax
          spouseObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type]["spouse"].constant, product.taxesDataJSON ?? []).total
        }




      }
      else {

        memberObj = {
          "planStartDate": this.customerData.enrollmentDate
            ? this._CustomDatePipe.transform(
              this.customerData.enrollmentDate
            )
            : undefined,
          "units": (this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
          "standardUnits": this.allFormData[type]["member"].coverage.minimumCoverage,
          "coverage": "MEMBER",
          "guaranteedAcceptance": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=
            this.allFormData[type]["member"].coverage.defaultRange ? true : false, //defalutRange
          "pendingMedicalQuestionaire": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >
            this.allFormData[type]["member"].coverage.defaultRange ? true : false,
          "guaranteedAcceptanceAmount": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant),
          "pendingApprovalAmount": adjustWith2DecimalsForUI(memberPrice * this.allFormData[type][category].constant) || 0,
          "smoker": this.allFormData[type]["member"].isSmoker == "yes" ? true : false,
          "age": this.allFormData[type]["member"].coverage.age,
          "gender": this.customerData.gender?.toLowerCase(),
          "province": "ON",
          "provinceId": 12,
          "amount": this.allFormData[type]["member"].premium,
          "tax": adjustWith2DecimalsForUI(this.productobj.tax),
          "taxRate": "", //not mandatory,
          "taxName": "",
          "coverageValue": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "premium": this.allFormData[type]["member"].constant,
          "total": adjustWith2DecimalsForUI(this.productobj.total),
          "coverageUnitPrice": this.allFormData[type]["member"].coverage.coverageUnitPrice,
          "defaultRange": this.allFormData[type]["member"].coverage.defaultRange,
          "maximumCoverageWithEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
          "maximumCoverageWithoutEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "minimumCoverage": this.allFormData[type]["member"].coverage.minimumCoverage,
        }
        spouseObj = {
          "planStartDate": this.customerData.enrollmentDate
            ? this._CustomDatePipe.transform(
              this.customerData.enrollmentDate
            )
            : undefined,
          "units": (this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
          "standardUnits": this.allFormData[type]["spouse"].coverage.minimumCoverage,
          "coverage": "MEMBER & SPOUSE",
          "guaranteedAcceptance": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=
            this.allFormData[type]["spouse"].coverage.defaultRange ? true : false, //defalutRange
          "pendingMedicalQuestionaire": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >
            this.allFormData[type]["spouse"].coverage.defaultRange ? true : false,
          "guaranteedAcceptanceAmount": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type][category].constant),
          "pendingApprovalAmount": adjustWith2DecimalsForUI(spousePrice * this.allFormData[type][category].constant) || 0,
          "smoker": this.allFormData[type]["spouse"].isSmoker == "yes" ? true : false,
          "age": this.allFormData[type]["spouse"].coverage.age,
          "gender": this.customerData?.spousegender?.toLowerCase(),
          "province": "ON",
          "provinceId": 12,
          "amount": this.allFormData[type]["spouse"].premium,
          "tax": adjustWith2DecimalsForUI(this.productobj.tax),
          "taxRate": "", //not mandatory,
          "taxName": "",
          "coverageValue": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
          "premium": this.allFormData[type]["spouse"].constant,
          "total": adjustWith2DecimalsForUI(this.productobj.total),
          "coverageUnitPrice": this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
          "defaultRange": this.allFormData[type]["spouse"].coverage.defaultRange,
          "maximumCoverageWithEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
          "maximumCoverageWithoutEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
          "minimumCoverage": this.allFormData[type]["spouse"].coverage.minimumCoverage,
        }

        obj["member"] = memberObj
        obj["spouse"] = spouseObj

        // let price = this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence > this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000):0*this.allFormData[type]["member"].constant

        //   console.log(price)
        //   console.log(this.calculateTaxForProductTaxesData(price,product.taxesDataJSON??[]))
        memberObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).tax
        memberObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).total
        spouseObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant), product.taxesDataJSON ?? []).tax
        spouseObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant), product.taxesDataJSON ?? []).total

        memberObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).tax
        memberObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).total

        spouseObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).tax
        spouseObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).total

      }


      console.log(memberObj["pendingApprovalTax"])
      let MSguranteeAcceptanceAmount = adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceAmount"] + (spouseObj["guaranteedAcceptanceAmount"] ?? 0))
      let MSguranteeAcceptancetTAX = adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceTax"] + (spouseObj["guaranteedAcceptanceTax"] ?? 0))
      let MSguranteeAcceptancetTotal = adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceTotal"] + (spouseObj["guaranteedAcceptanceTotal"] ?? 0))

      let MSpendingApprovalAmount = adjustWith2DecimalsForUI(memberObj["pendingApprovalAmount"] + (spouseObj["pendingApprovalAmount"] ?? 0))
      let MSpendingApprovalTAX = adjustWith2DecimalsForUI(memberObj["pendingApprovalTax"] + (spouseObj["pendingApprovalTax"] ?? 0))
      let MSpendingApprovalTotal = adjustWith2DecimalsForUI(memberObj["pendingApprovalTotal"] + (spouseObj["pendingApprovalTotal"] ?? 0))

      let obj1: any = {
        packageId: plan.packageId,
        packageName: pckage.name,

        planproductname: this.productobj.name,

        groupid: plan.planLevel,
        groupName: group.name,
        id: plan.id,
        name: plan.name,
        planLevel: plan.planLevel ? plan.planLevel : group.id,
        planLevelParent: group.parentId,
        fusebillPlanID: plan.fusebillId,
        planFrequencyID: plan.frqMonthly,
        isBundle: plan.isBundle,
        coverage: lifeCoverage,
        planCoverage: product.planCoverage,
        bundledProducts: [],
        products: [],
        version: plan.version,
        guaranteedAcceptanceDetails: {
          "amount": MSguranteeAcceptanceAmount,
          "tax": MSguranteeAcceptancetTAX,
          "total": MSguranteeAcceptancetTotal,
          "products": [{
            id: product.id,
            productId: product.productId,
            name: product.name,
            planProductId: product.planProductId,
            price: adjustWith2DecimalsForUI(MSguranteeAcceptanceAmount),
            tax_details:
              product.bundledTaxes && product.bundledTaxes.length > 0
                ? product.bundledTaxes
                : product.taxesDataJSON,
            calculatedTax: this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []),
            bundledProducts: product.bundledProducts,
            planCoverage: lifeCoverage,
            planLevel: product.planlevel ? product.planlevel.id : '',
            planLevelParent: product.planlevel ? product.planlevel.parentId : '',
            description: product.description,
            coverage: lifeCoverage,
            version: product.version,
            total: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []).total : 0,
                '1.2-2'
              )
              ?.replace(/,/g, ''),
            tax: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []).tax : 0,
                '1.2-2'
              )
              ?.replace(/,/g, '')
          }]


        },
        pendingApprovalDetails: {
          "amount": MSpendingApprovalAmount,
          "tax": this._decimalPipe
            .transform(
              this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).tax : 0,
              '1.2-2'
            )
            ?.replace(/,/g, ''),
          "total": this._decimalPipe
            .transform(
              this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).total : 0,
              '1.2-2'
            )
            ?.replace(/,/g, ''),
          "products": [{
            id: product.id,
            productId: product.productId,
            name: product.name,
            planProductId: product.planProductId,
            price: adjustWith2DecimalsForUI(MSpendingApprovalAmount),
            tax_details:
              product.bundledTaxes && product.bundledTaxes.length > 0
                ? product.bundledTaxes
                : product.taxesDataJSON,
            calculatedTax: this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []),
            bundledProducts: product.bundledProducts,
            planCoverage: lifeCoverage,
            planLevel: product.planlevel ? product.planlevel.id : '',
            planLevelParent: product.planlevel ? product.planlevel.parentId : '',
            description: product.description,
            coverage: lifeCoverage,
            version: product.version,
            total: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).total : 0,
                '1.2-2'
              )
              ?.replace(/,/g, ''),
            tax: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).tax : 0,
                '1.2-2'
              )
              ?.replace(/,/g, '')
          }]
        },
        selectedDetails: {
          "amount": adjustWith2DecimalsForUI(this.allFormData[type].total),
          "total": adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []).total : 0),

          "tax": adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []).tax : 0),
          "products": [this.productobj]
        }


      };

      obj["guaranteedAcceptanceDetails"] = obj1.guaranteedAcceptanceDetails
      obj["pendingApprovalDetails"] = obj1.pendingApprovalDetails
      obj["selectedDetails"] = obj1.selectedDetails


      obj1.products.push(this.productobj);
      this.addtoplansummaryLife(obj, obj1);
    }, 100);
    for (let i = this.minValue; i <= this.allFormData[type][category]?.coverage?.maximumCoverageWithEvidence; i += 100000) {
      this.rangeValues.push(i);
    }
  }
  public calculateTaxForProductTaxesData(price: number, taxesData: any) {
    // this.console.log(taxesData)
    // [{"tax_name":"PST","tax_code":"0002","plan_product_id":177927,"tax_description":"PST on Health Insurance","business_tax_number":"709505879TR0001","tax_rate":0.09,"tax_sku":"pstonhealthinsurance"}]
    let calculatedTax: any = {}
    let tax: any = 0;
    let planProductIds: any = []
    let planProductInfos: any = []
    if (taxesData && taxesData != undefined && taxesData != null && taxesData != "null") {
      for (const taxData of taxesData) {
        tax += adjustWith2DecimalsForUI(price * taxData.tax_rate);
        planProductIds.push(taxData.plan_product_id);
        let planProductInfo: any = {};
        // planProductInfo.name = taxData.tax_description + " " + (taxData.business_tax_number ?? "");
        planProductInfo.name = taxData.tax_name;
        planProductInfo.description = taxData.tax_description;
        planProductInfo.price = adjustWith2DecimalsForUI(price * taxData.tax_rate);
        planProductInfo.planProductUniqueId = taxData.plan_product_id;
        planProductInfo.isIncluded = true;
        planProductInfo.taxRate = taxData.tax_rate;
        planProductInfo.taxRatePercentage = adjustWith2DecimalsForUI((taxData.tax_rate) * 100) + "%";
        planProductInfos.push(planProductInfo);
      }
    }

    let total = adjustWith2DecimalsForUI(price + tax)
    calculatedTax.price = adjustWith2DecimalsForUI(price);
    calculatedTax.tax = adjustWith2DecimalsForUI(tax);
    calculatedTax.total = adjustWith2DecimalsForUI(total);

    calculatedTax.planProductIds = planProductIds;
    calculatedTax.planProductInfos = planProductInfos;

    return calculatedTax;

  }

  public transformData() {
    let transformedData: any = [];
    let id = 12;

    Object.keys(this.allFormData).forEach(key => {
      const plan = this.allFormData[key];
      if (plan.total > 0) {
        const hasMember: boolean = plan.hasOwnProperty('member');

        const hasSpouse = plan.hasOwnProperty('spouse');
        const hasChildren = plan.hasOwnProperty('dependent');

        const transformedObject: any = {
          name: key.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
          id: id++,
          havingSpouse: hasSpouse,
          havingChildren: hasChildren,
          total: plan.total,
        }

        transformedObject.member = {}

        if (hasMember && plan.member.premium > 0) {
          transformedObject.member = {
            isSmoker: plan.member.isSmoker,
            total: plan.member.premium,
            units: plan.member.coverage,
            // placeOfBirth: plan.member.PlaceOfBirth,
            premium: plan.member.constant
          }
        }

        transformedObject.spouse = {}

        if (hasSpouse && plan.spouse.premium > 0) {
          transformedObject.spouse = {
            isSmoker: plan.spouse.isSmoker,
            total: plan.spouse.premium,
            units: plan.spouse.coverage,
            // placeOfBirth: plan.spouse.PlaceOfBirth,
            premium: plan.spouse.constant

          };
        }

        transformedObject.dependent = []

        if (hasChildren && plan.dependent.premium > 0) {
          const dep = this.signUpData.childrenDetails.map((d: any) => {
            return {
              childFirstName: d.childFirstName,
              childLastName: d.childLastName,
              //  total: plan.dependent.premium/this.signUpData.childrenDetails.length,
              total: plan.dependent.premium,
              units: plan.dependent.coverage,
              premium: plan.dependent.constant,
              // placeOfBirth:
              //   plan.dependent[`${d.childFirstName}-${d.childLastName}`],
            };
          });

          transformedObject.dependent = dep;
          transformedObject.dependent.allDependentPremium = {
            total: plan.dependent.premium,
            units: plan.dependent.coverage,
            premium: plan.dependent.constant
          }

        }

        transformedData.push(transformedObject);
      }
    });

    return transformedData;
  }
  public onCheckboxChangeP(
    event: any,
    type: string,
    category: string,
    key1: string,
    value1: any,
    key2?: string,
    value2?: any
  ): void {

    console.log(this.allFormData)


    console.log(value1)
    console.log(value1?.member)
    // console.log(value1?.spouse)
    if (category == 'member') {
      this.updateFormData(type, 'member', { coverage: value1.member })
    }
    if (category == 'spouse') {
      if (this.customerData.dependents?.spouseInfo) {
        this.updateFormData(type, 'spouse', { coverage: value1.spouse });
      }
    }



    let planSummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');
    if (event.target.checked) {
      this.updateFormData(type, category, { [key1]: value1 });
      const dom: HTMLElement = this.elementRef.nativeElement;
      const plan: any = dom.querySelector("." + category + "-" + type + "-no");
      console.log(plan)
      setTimeout(() => {
        // plan.click()
      }, 100);


    } else {

      console.log(type)
      console.log(category)
      this.updateFormData(type, category, {}, true);

      if (category == 'spouse') {
        this.updateFormData(type, 'member', {}, true);


        const planCheck = this.renderer.selectRootElement("#planCheckLife" + type + "-" + 'MEMBER', true);
        this.renderer.setProperty(planCheck, 'checked', false);
      }
      if (category == 'member') {
        this.updateFormData(type, 'spouse', {}, true);

        planSummaryLife.forEach((element: any, index: any) => {

          if (element.coverage == 'MEMBER & SPOUSE') {
            const planCheck = this.renderer.selectRootElement("#planCheckLife" + type + "-" + 'SPOUSE', true);
            this.renderer.setProperty(planCheck, 'checked', false);
          }

        })

      }
      this.unselectplanLife(event)
    }


  }

  public onInputChangeP(e: Event, type: string, category: string): void {
    const inputElement = e.target as HTMLInputElement;
    if (inputElement && this.allFormData[type][category]) {
      const obj = { [inputElement.name]: inputElement.value };
      this.updateFormData(type, category, obj);
    }
  }

  public unselectplanLife(elementcv: any) {

    // this.planCoverageName = ''
    // this.insuranceplanid =''
    console.log(elementcv)

    let plandetails = elementcv.target.attributes.data.value;

    let plandetailsobj = plandetails.split('##');
    let obj = {
      // enrollmentDate: moment(
      //   this.userForm.get("planenrollmentdate").value,
      //   "MM-DD-YYYY"
      // ).format("YYYY-MM-DD"),
      enrollmentDate: this.customerData.enrollmentDate
        ? this._CustomDatePipe.transform(this.customerData.enrollmentDate)
        : undefined,
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(plandetailsobj[3]),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(plandetailsobj[3]),
      amountUI: '$' + this._decimalPipe.transform(plandetailsobj[3], '1.2-2'),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == '' ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == 'null'
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == '' ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == 'null'
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == 'true' ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    this.removeplansummaryLife(obj);
  }
  public addtoplansummaryLife(obj: any, obj1: any) {
    let plansummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');

    // console.log(obj1);
    // console.log(planSummary);
    // console.log('addroplansummaryplans');
    // console.log(planSummary.length);
    // console.log(obj.id);
    // console.log(obj);

    this.addtoslectplansLife(obj.id, plansummaryLife.length);
    plansummaryLife.push(obj);

    let gstprice = 0;
    let hstprice = 0;
    let pstprice = 0;
    let qstprice = 0;

    if (obj.gst > 0) {
      gstprice = obj.planPrice * obj.gst;
      obj['gstPrice'] = gstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['gstPrice'] = parseFloat(obj['gstPrice']);
    } else {
      obj['gstPrice'] = 0;
    }

    if (obj.hst > 0) {
      hstprice = obj.planPrice * obj.hst;

      obj['hstPrice'] = hstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['hstPrice'] = parseFloat(obj['hstPrice']);
    } else {
      obj['hstPrice'] = 0;
    }

    if (obj.pst > 0) {
      pstprice = obj.planPrice * obj.pst;
      obj['pstPrice'] = pstprice
        ? this._decimalPipe.transform(pstprice, '1.2-2')
        : 0;
      obj['pstPrice'] = parseFloat(obj['pstPrice']);
    } else {
      obj['pstPrice'] = 0;
    }

    if (obj.qst > 0) {
      qstprice = obj.planPrice * obj.qst;

      obj['qstPrice'] = qstprice
        ? this._decimalPipe.transform(qstprice, '1.2-2')
        : 0;
      obj['qstPrice'] = parseFloat(obj['qstPrice']);
    } else {
      obj['qstPrice'] = 0;
    }

    obj['taxUI'] = '';
    if (obj['gstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['gstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
          '&nbsp;(GST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['pstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['pstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
          '&nbsp;(PST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['qstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['qstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
          '&nbsp;(QST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['hstCheck']) {
      obj['taxUI'] += '<span> ';
      if (obj['hstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
          '&nbsp;(HST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (
      !obj['hstCheck'] &&
      !obj['gstCheck'] &&
      !obj['pstCheck'] &&
      !obj['qstCheck']
    ) {
      obj['taxUI'] += '<span>-';

      obj['taxUI'] += '</span>';
    }

    // ////this.consoleMessage(object["taxUI"])

    obj['tax'] = obj1.products
      ? this._decimalPipe.transform(
        obj1.products?.reduce((acc: any, calculatedTax: any) => {
          return acc + calculatedTax.tax;
        }, 0),
        '1.2-2'
      )
      : 0;
    obj['tax'] = parseFloat(obj['tax']);

    // obj["products"] =obj1
    obj['coverage'] = obj1.coverage;
    obj['planCoverage'] = obj1.planCoverage;
    obj['planLevelParent'] = obj1.planLevelParent;
    obj['planproductname'] = obj1.planproductname;

    obj['products'] = obj1.products;

    //this.consoleMessage(obj.planPrice)
    //this.consoleMessage(gstprice)
    //this.consoleMessage(hstprice)
    //this.consoleMessage(pstprice)

    //this.consoleMessage(qstprice)
    let pricecal = obj1.products.reduce((acc: any, calculatedTax: any) => {
      return acc + calculatedTax.total;
    }, 0);
    obj['totalPrice'] = parseFloat(pricecal);

    obj['totalUI'] = '$' + this._decimalPipe.transform(pricecal, '1.2-2');

    obj['total'] = this._decimalPipe.transform(pricecal, '1.2-2');

    //this.consoleMessage(obj1)

    obj['skuTotalPrice'] = parseFloat(obj1.products.reduce(
      (acc: any, calculatedTax: any) => {
        return acc + calculatedTax.total;
      },
      0
    ))

    let updatedSum = this.addtosum(obj.totalPrice);
    this.planssummarymainLife = [];
    this.planssummaryopt = [];

    plansummaryLife.forEach((element: any) => {
      if (element.packagename != 'Opt-in') {
        this.planssummarymainLife.push(element);
      } else {
        this.planssummaryopt.push(element);
      }
    });

    this.plansskumain.push(obj1);

    sessionStorage.setItem('plansskumain', JSON.stringify(this.plansskumain));
    sessionStorage.setItem(
      'planssummarymainLife',
      JSON.stringify(this.planssummarymainLife)
    );
    sessionStorage.setItem(
      'plansummaryopt',
      JSON.stringify(this.planssummaryopt)
    );

    sessionStorage.setItem('plansummaryLife', JSON.stringify(plansummaryLife));
    let planSummaryData = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    // if (plansummaryLife.length > 0 || planSummaryData.length>0) {
    //   this.plansnexttab = false;
    // } else {
    //   this.plansnexttab = true;
    // }
    if (updatedSum > 0) {
      this.cartcheckvalue = false;
    } else {
      this.cartcheckvalue = true;
    }

    setTimeout(() => {
      this.planssummarymainLife = JSON.parse(
        sessionStorage.getItem('planssummarymainLife') || '[]'
      );

      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      var total = 0;
      for (let i = 0; i < this.planssummarymainLife.length; i++) {
        total += parseFloat(this.planssummarymainLife[i].skuTotalPrice);
      }
      for (let i = 0; i < this.planssummarymain.length; i++) {
        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }
      //this.consoleMessage(total);

      this.planAmount = this._decimalPipe
        .transform(total, '1.2-2')
        ?.replace(/,/g, '');
      sessionStorage.setItem('totalAmount', this.planAmount);

      if (this.planAmount > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }
    }, 100);
  }
  public removeplansummaryLife(obj: any) {

    console.log(obj)
    let planSummary = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');

    // console.log(planSummary);

    if (planSummary) {
      ////this.consoleMessage("removeinplanid"+obj.id)
      let index: any = this.getslectedplansLife(obj.id);
      ////this.consoleMessage(index)

      if (index > -1) {

        planSummary.splice(index, 1);
        ////this.consoleMessage("afterremove")
        ////this.consoleMessage(planSummary)
      } else {
        return;
      }

      // ////this.consoleMessage(planSummary)
      // ////this.consoleMessage(planSummary.length)
      ////this.consoleMessage("beforeremoveplans")
      let selectedPlans = JSON.parse(
        sessionStorage.getItem('selectedPlans') || '[]'
      );
      var newselectedplans: any = {};
      for (var i = 0; i < planSummary.length; i++) {
        newselectedplans[planSummary[i].id] = i;
      }

      ////this.consoleMessage("newselectedPlans")
      ////this.consoleMessage(newselectedplans)

      sessionStorage.setItem('selectedPlansLife', JSON.stringify(newselectedplans));
      // this.removeslectplans(obj.id,planSummary.length)

      let gstprice = 0;
      let hstprice = 0;
      let pstprice = 0;
      let qstprice = 0;

      if (obj.gst > 0) {
        gstprice = obj.planPrice * obj.gst;
        obj['gstPrice'] = gstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['gstPrice'] = parseFloat(obj['gstPrice']);
      } else {
        obj['gstPrice'] = 0;
      }

      if (obj.hst > 0) {
        hstprice = obj.planPrice * obj.hst;

        obj['hstPrice'] = hstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['hstPrice'] = parseFloat(obj['hstPrice']);
      } else {
        obj['hstPrice'] = 0;
      }

      if (obj.pst > 0) {
        pstprice = obj.planPrice * obj.pst;
        obj['pstPrice'] = pstprice
          ? this._decimalPipe.transform(pstprice, '1.2-2')
          : 0;
        obj['pstPrice'] = parseFloat(obj['pstPrice']);
      } else {
        obj['pstPrice'] = 0;
      }

      if (obj.qst > 0) {
        qstprice = obj.planPrice * obj.qst;

        obj['qstPrice'] = qstprice
          ? this._decimalPipe.transform(qstprice, '1.2-2')
          : 0;
        obj['qstPrice'] = parseFloat(obj['qstPrice']);
      } else {
        obj['qstPrice'] = 0;
      }
      obj['taxUI'] = '';
      if (obj['gstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['gstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
            '&nbsp;(GST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['pstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['pstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
            '&nbsp;(PST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['qstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['qstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
            '&nbsp;(QST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['hstCheck']) {
        obj['taxUI'] += '<span> ';
        if (obj['hstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
            '&nbsp;(HST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (
        !obj['hstCheck'] &&
        !obj['gstCheck'] &&
        !obj['pstCheck'] &&
        !obj['qstCheck']
      ) {
        obj['taxUI'] += '<span>-';

        obj['taxUI'] += '</span>';
      }

      // ////this.consoleMessage(object["taxUI"])

      obj['tax'] = parseFloat(
        this._decimalPipe.transform(
          gstprice + hstprice + pstprice + qstprice,
          '1.2-2'
        ) ?? ''
      );

      (obj['totalPrice'] =
        obj.planPrice + gstprice + hstprice + pstprice + qstprice),
        (obj['totalUI'] =
          '$' +
          this._decimalPipe.transform(
            obj.planPrice + gstprice + hstprice + pstprice + qstprice,
            '1.2-2'
          ));

      obj['total'] = parseFloat(
        this._decimalPipe.transform(
          obj.planPrice + gstprice + hstprice + pstprice + qstprice,
          '1.2-2'
        ) ?? ''
      );

      let updatedSum = this.removetosum(obj.totalPrice);
      this.planssummarymainLife = [];
      this.planssummaryopt = [];

      planSummary.forEach((element: any) => {
        if (element.packagename != 'Opt-in') {
          this.planssummarymainLife.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });

      sessionStorage.setItem(
        'planssummarymainLife',
        JSON.stringify(this.planssummarymainLife)
      );
      sessionStorage.setItem(
        'plansummaryopt',
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem('plansummaryLife', JSON.stringify(planSummary));
      let planSummaryData = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

      // if (planSummary.length > 0 || planSummaryData.length>0) {
      //   this.plansnexttab = false;
      // } else {
      //   this.plansnexttab = true;
      // }
      if (updatedSum > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }
    }

    setTimeout(() => {
      // this.planssummarymain = JSON.parse(
      //   sessionStorage.getItem('plansummarymain') || '[]'
      // );

      // var total = 0;
      // for (let i = 0; i < this.planssummarymain.length; i++) {
      //   total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      // }

      this.planssummarymainLife = JSON.parse(
        sessionStorage.getItem('planssummarymainLife') || '[]'
      );

      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      var total = 0;
      for (let i = 0; i < this.planssummarymainLife.length; i++) {
        total += parseFloat(this.planssummarymainLife[i].skuTotalPrice);
      }
      for (let i = 0; i < this.planssummarymain.length; i++) {
        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }
      //this.consoleMessage(total);

      this.planAmount = this._decimalPipe
        .transform(total, '1.2-2')
        ?.replace(/,/g, '');
      sessionStorage.setItem('totalAmount', this.planAmount);
    }, 100);
  }
  public addtoslectplansLife(planid: number, plansumamryindex: number) {
    ////this.consoleMessage("beforeaddtoplans")
    ////this.consoleMessage(planid)
    ////this.consoleMessage(plansumamryindex)
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlansLife') || '{}'
    );
    ////this.consoleMessage(selectedPlans)
    selectedPlans[planid] = plansumamryindex;
    ////this.consoleMessage("afteraddtoplans")
    ////this.consoleMessage(selectedPlans)
    sessionStorage.setItem('selectedPlansLife', JSON.stringify(selectedPlans));
  }
  public getslectedplansLife(planid: number) {
    ////this.consoleMessage(planid)
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlansLife') || '{}'
    );
    ////this.consoleMessage(selectedPlans)
    return selectedPlans[planid];
  }


  public handleRangeChangeForDependent(
    value: any,
    type: string,
    category: string
  ): void {
    // if (this.allFormData[type][category]) {
    //   this.updateFormData(type, category, {
    //     // coverage: value,
    //     premium: this.updateDependentPremium(type, category, value),
    //   });
    // }
  }
  public isGroupsNotEmpty(groups: any): boolean {
    this.displayPackage = false;
    if (Object.keys(groups).length > 0) {
      Object.keys(groups).forEach(element => {

        if (groups[element].length > 0) {
          groups[element].map(ele => {

            if (ele.plans?.length > 0) {
              this.displayPackage = true;
              return this.displayPackage
            }
          });
        }
      })
    }

    return this.displayPackage
  }

  public onCheckboxChange(
    e,
    allowMultiple,
    disallowedPlanLevels,
    options,
    pname,
    groupname,
    plancoverage,
    planprice,
    gst,
    hst,
    pst,
    event,
    event1,
    packageindex,
    groupindex,
    planindex,
    plan,
    product, pckage, group
  ) {

    console.log({ product, pckage, group, e: e.target.checked })
    if (e.target.checked == false && product.selected == true) {
      this.unselected.push({ planId: product.planId, packId: pckage.id })
    }
    else {
      this.unselected = this.unselected.filter((ele) => (
        ele.planId != product.planId

      ))
    }
    console.log(this.unselected)
    // let multiple = allowMultiple ? Boolean(allowMultiple.data[0]) : false;
    let multiple = allowMultiple == true ? true : false;
    console.log(disallowedPlanLevels)

    if (disallowedPlanLevels != null) {
      console.log(disallowedPlanLevels)
      let disallowed_plans = disallowedPlanLevels.split(",");
      const dom1: HTMLElement = this.elementRef.nativeElement;
      const disallowed_elements = dom1.querySelectorAll(
        ".plansscreen input[type='checkbox']"
      );
      console.log(disallowed_elements)

      // disallowed_elements.forEach((elem: any) => {

      for (let i = 0; i < disallowed_elements.length; i++) {

        let elem: any = disallowed_elements[i]
        console.log(elem)
        // elementcv.checked=false

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split("##");

        console.log("main", plandetailsobj)

        if (e.target.checked) {
          if (!elem.disabled) {
            if (plandetailsobj[12] == null || plandetailsobj[12] == "") {
              if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                //  elem.checked=false
                elem.disabled = true;

                this.disabledelement =
                  "Already included in GroupBenefitz All-In";
              }
            } else {
              if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                //  elem.checked=false
                elem.disabled = true;
                this.disabledelement =
                  "Already included in GroupBenefitz All-In";
              }
            }
          }
          if (elem.checked) {
            //console.log(disallowed_plans)
            //console.log(plandetailsobj)

            if (plandetailsobj[12] == null || plandetailsobj[12] == "") {
              if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                elem.checked = false;
                this.unselectplan(elem)
              }
            } else {
              //console.log(disallowed_plans)
              //console.log(plandetailsobj)
              if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                elem.checked = false;
                this.unselectplan(elem)
                // elem.disabled =true
              }
            }
          }
        }
        else {
          if (elem.disabled) {
            if (plandetailsobj[12] == null || plandetailsobj[12] == "") {
              if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                //  elem.checked=false
                elem.disabled = false;
              }
            } else {
              if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                //  elem.checked=false
                elem.disabled = false;
              }
            }
          }
          if (elem.checked) {
            if (plandetailsobj[12] == null || plandetailsobj[12] == "") {
              if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                elem.checked = false;
                // elem.disabled =true
              }
            } else {
              if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                elem.checked = false;
                // elem.disabled =true
              }
            }
          }
        }
      };
    }

    // ////console.log(e)
    let classname = e.target.className;
    classname = classname.split(" ").join(".");

    // ////console.log(classname)
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements = dom.querySelectorAll("." + classname);

    // ////console.log(elements);

    let element: any;
    let elementcv: any;

    if (!multiple) {
      if (e.target.checked) {


        for (let i = 0; i < elements.length; i++) {
          let elem = elements[i]
          element = elem;

          if (element.checked) {
            this.unselectplan(elem)
            element.checked = false;
          }


        }



        e.checked = true;
        e.target.checked = true;

      } else {

      }
    } else {
      //no checking for other checkboxes you can selet multiple
    }
    setTimeout(() => {


      if (e.target.checked) {


        this.selectplan(e.target, options, plan, product, pckage, group)
      }
      else {
        this.unselectplan(e.target)
      }

    }, 10);
  }

  public selectplan(elementcv: any, options: any, plan: any, product: any, pckage: any, group: any) {
    console.log(plan)
    console.log(product)
    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split("##");
    if (options && options.length > 0) {

      let coverage = product.planCoverage

      coverage = ["SINGLE", "COUPLE", "FAMILY"].includes(coverage) ? coverage : null
      //console.log(obj)
      let productobj = {

        id: product.id,
        productId: product.productId,
        name: product.name,
        planProductId: product.planProductId,
        price: this._decimalPipe.transform(product.price1 || product.price, "1.2-2").replace(/,/g, ""),
        tax: this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.tax : 0, "1.2-2").replace(/,/g, ""),
        total: this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.total : 0, "1.2-2").replace(/,/g, ""),
        tax_details: product.bundledTaxes && product.bundledTaxes.length > 0 ? product.bundledTaxes : product.taxesDataJSON,
        calculatedTax: product.calculatedTax,
        bundledProducts: product.bundledProducts,
        planCoverage: product.planCoverage,
        planLevel: product.planlevel ? product.planlevel.id : '',
        planLevelParent: product.planlevel ? product.planlevel.parentId : "",
        description: product.description,
        coverage: coverage
      };


      let obj1 = {

        packageId: plan.packageId,
        packageName: pckage.name,

        planproductname: productobj.name,

        groupid: plan.planLevel,
        groupName: group.name,
        id: plan.id,
        name: plan.name,
        planLevel: plan.planLevel ? plan.planLevel : group.id,
        planLevelParent: group.parentId,
        fusebillPlanID: plan.fusebillId,
        planFrequencyID: plan.frqMonthly,
        isBundle: plan.isBundle,
        coverage: coverage,
        planCoverage: product.planCoverage,
        bundledProducts: [],
        products: [],

      };
      obj1.products.push(productobj);
      this.planobjdata = obj1

      this.openplanoptions(elementcv, options, plan, product);
    }
    else {
      let obj = {
        isBundle: plan.isBundle,
        enrollmentDate: "",
        // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
        name: plandetailsobj[14],
        details: plandetailsobj[0],
        packagename: plandetailsobj[0],
        groupName: plandetailsobj[1],
        amount: parseFloat(product.calculatedTax.price),
        planCoverage: plandetailsobj[2],
        planPrice: parseFloat(product.calculatedTax.price),
        amountUI:
          "$" + this._decimalPipe.transform(product.calculatedTax.price, "1.2-2"),
        gst:
          plandetailsobj[4] == null ||
            plandetailsobj[4] == "" ||
            plandetailsobj[4] == undefined ||
            plandetailsobj[4] == "null"
            ? 0
            : parseFloat(plandetailsobj[4]),
        hst:
          plandetailsobj[5] == null ||
            plandetailsobj[5] == "" ||
            plandetailsobj[5] == undefined ||
            plandetailsobj[5] == "null"
            ? 0
            : parseFloat(plandetailsobj[5]),
        pst:
          plandetailsobj[6] == null ||
            plandetailsobj[6] == "" ||
            plandetailsobj[6] == undefined ||
            plandetailsobj[6] == "null"
            ? 0
            : parseFloat(plandetailsobj[6]),
        qst:
          plandetailsobj[17] == null ||
            plandetailsobj[17] == "" ||
            plandetailsobj[17] == undefined ||
            plandetailsobj[17] == "null"
            ? 0
            : parseFloat(plandetailsobj[17]),
        gstCheck:
          plandetailsobj[4] == null ||
            plandetailsobj[4] == "" ||
            plandetailsobj[4] == undefined ||
            plandetailsobj[4] == "null"
            ? false
            : true,
        hstCheck:
          plandetailsobj[5] == null ||
            plandetailsobj[5] == "" ||
            plandetailsobj[5] == undefined ||
            plandetailsobj[5] == "null"
            ? false
            : true,
        pstCheck:
          plandetailsobj[6] == null ||
            plandetailsobj[6] == "" ||
            plandetailsobj[6] == undefined ||
            plandetailsobj[6] == "null"
            ? false
            : true,
        qstCheck:
          plandetailsobj[17] == null ||
            plandetailsobj[17] == "" ||
            plandetailsobj[17] == undefined ||
            plandetailsobj[17] == "null"
            ? false
            : true,
        id: parseFloat(plandetailsobj[7]),
        fusebillPlanID:
          plandetailsobj[8] == null ||
            plandetailsobj[8] == "" ||
            plandetailsobj[8] == undefined ||
            plandetailsobj[8] == "null"
            ? 0
            : parseFloat(plandetailsobj[8]),
        planFrequencyID:
          plandetailsobj[9] == null ||
            plandetailsobj[9] == "" ||
            plandetailsobj[9] == undefined ||
            plandetailsobj[9] == "null"
            ? 0
            : parseFloat(plandetailsobj[9]),
        optIn: plandetailsobj[10] == "true" ? true : false,
        planname: plandetailsobj[14],
        planLevel: parseInt(plandetailsobj[15]),
        packageId: parseInt(plandetailsobj[16]),
        options: [],
        //  "disallowedPlanLevels":plandetailsobj[11]
      };
      if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
        if (plandetailsobj[11].includes(plandetailsobj[12])) {

        }
      }

      let coverage = product.planCoverage

      coverage = ["SINGLE", "COUPLE", "FAMILY"].includes(coverage) ? coverage : null
      //console.log(obj)
      let productobj = {
        id: product.id,
        productId: product.productId,
        name: product.name,
        planProductId: product.planProductId,
        price: this._decimalPipe.transform(product.price1 || product.price, "1.2-2").replace(/,/g, ""),
        tax: this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.tax : 0, "1.2-2").replace(/,/g, ""),
        total: this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.total : 0, "1.2-2").replace(/,/g, ""),
        tax_details: product.bundledTaxes && product.bundledTaxes.length > 0 ? product.bundledTaxes : product.taxesDataJSON,
        calculatedTax: product.calculatedTax,
        bundledProducts: product.bundledProducts,
        planCoverage: product.planCoverage,
        planLevel: product.planlevel ? product.planlevel.id : '',
        planLevelParent: product.planlevel ? product.planlevel.parentId : "",
        description: product.description,
        coverage: coverage,
        selected: product.selected
      };


      let obj1 = {

        packageId: plan.packageId,
        packageName: pckage.name,

        planproductname: productobj.name,

        groupid: plan.planLevel,
        groupName: group.name,
        id: plan.id,
        name: plan.name,
        planLevel: plan.planLevel ? plan.planLevel : group.id,
        planLevelParent: group.parentId,
        fusebillPlanID: plan.fusebillId,
        planFrequencyID: plan.frqMonthly,
        isBundle: plan.isBundle,
        coverage: coverage,
        planCoverage: product.planCoverage,
        bundledProducts: [],
        products: [],
        // selected: plan.seelcted

      };
      obj1.products.push(productobj);
      console.log(obj1)

      this.addtoplansummary(obj, obj1)
    }
  }



  changeUploadService(event: any) {
    if (event.target.value.toString() != 'null') {
      this.selectServiceError = false;
    }
    else {
      this.selectServiceError = true;
    }
  }


  public unselectplan(elementcv: any) {



    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split("##");
    let obj = {
      enrollmentDate: "",
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(plandetailsobj[3]),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(plandetailsobj[3]),
      amountUI:
        "$" + this._decimalPipe.transform(plandetailsobj[3], "1.2-2"),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == "" ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == "null"
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == "" ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == "null"
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == "true" ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {

      }
    }

    this.removeplansummary(obj)


  }

  public addtoplansummary(obj: any, obj1: any) {
    let planSummary = JSON.parse(sessionStorage.getItem("plansummary") || "[]")

    console.log(obj1)
    //console.log(planSummary)
    //console.log("addroplansummaryplans")
    //console.log(planSummary.length)
    //console.log(obj.id)
    console.log("obj", obj)

    this.addtoslectplans(obj.id, planSummary.length)
    planSummary.push(obj)


    let gstprice = 0;
    let hstprice = 0;
    let pstprice = 0;
    let qstprice = 0;

    if (obj.gst > 0) {
      gstprice = obj.planPrice * obj.gst;
      obj["gstPrice"] = parseFloat(
        this._decimalPipe.transform(gstprice, "1.2-2")
      );
    }
    else {
      obj["gstPrice"] = 0;
    }

    if (obj.hst > 0) {
      hstprice = obj.planPrice * obj.hst;

      obj["hstPrice"] = parseFloat(
        this._decimalPipe.transform(hstprice, "1.2-2")
      );
    }
    else {
      obj["hstPrice"] = 0;
    }

    if (obj.pst > 0) {
      pstprice = obj.planPrice * obj.pst;
      obj["pstPrice"] = parseFloat(
        this._decimalPipe.transform(pstprice, "1.2-2")
      );
    }
    else {
      obj["pstPrice"] = 0;
    }

    if (obj.qst > 0) {
      qstprice = obj.planPrice * obj.qst;
      obj["qstPrice"] = parseFloat(
        this._decimalPipe.transform(qstprice, "1.2-2")
      );
    }
    else {
      obj["qstPrice"] = 0;
    }

    obj["taxUI"] = "";
    if (obj["gstCheck"]) {
      obj["taxUI"] += "<span>";
      if (obj["gstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["gstPrice"], "1.2-2") +
          "&nbsp;(GST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (obj["pstCheck"]) {
      obj["taxUI"] += "<span>";
      if (obj["pstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["pstPrice"], "1.2-2") +
          "&nbsp;(PST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (obj["qstCheck"]) {
      obj["taxUI"] += "<span>";
      if (obj["qstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["qstPrice"], "1.2-2") +
          "&nbsp;(QST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (obj["hstCheck"]) {
      obj["taxUI"] += "<span> ";
      if (obj["hstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["hstPrice"], "1.2-2") +
          "&nbsp;(HST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (
      !obj["hstCheck"] &&
      !obj["gstCheck"] &&
      !obj["pstCheck"] &&
      !obj["qstCheck"]
    ) {
      obj["taxUI"] += "<span>-";

      obj["taxUI"] += "</span>";
    }

    // //console.log(object["taxUI"])

    obj["tax"] = parseFloat(
      this._decimalPipe.transform(
        obj1.products.reduce((acc, calculatedTax) => { return acc + calculatedTax.tax; }, 0),
        "1.2-2"
      )
    );

    // obj["products"] =obj1
    obj["coverage"] = obj1.coverage
    obj["planCoverage"] = obj1.planCoverage
    obj["planLevelParent"] = obj1.planLevelParent
    obj["planproductname"] = obj1.planproductname

    obj["products"] = obj1.products

    console.log(obj.planPrice)
    console.log(gstprice)
    console.log(hstprice)
    console.log(pstprice)

    console.log(qstprice)
    let pricecal = obj1.products.reduce((acc, calculatedTax) => { return acc + calculatedTax.total; }, 0)
    obj["totalPrice"] = pricecal


    obj["totalUI"] = "$" + this._decimalPipe.transform(pricecal, "1.2-2");

    obj["total"] =
      this._decimalPipe.transform(
        pricecal,
        "1.2-2"
      );

    console.log(obj1)

    obj["skuTotalPrice"] = obj1.products.reduce((acc, calculatedTax) => { return acc + calculatedTax.total; }, 0);

    let updatedSum = this.addtosum(obj.totalPrice)
    this.planssummarymain = [];
    this.planssummaryopt = [];

    planSummary.forEach((element: any) => {
      if (element.packagename != "Opt-in") {
        this.planssummarymain.push(element);
      } else {

        this.planssummaryopt.push(element);
      }
    });

    console.log(obj1)

    this.plansskumain.push(obj1)

    sessionStorage.setItem(
      "plansskumain",
      JSON.stringify(this.plansskumain)
    );
    sessionStorage.setItem(
      "plansummarymain",
      JSON.stringify(this.planssummarymain)
    );
    sessionStorage.setItem(
      "plansummaryopt",
      JSON.stringify(this.planssummaryopt)
    );

    sessionStorage.setItem("plansummary",
      JSON.stringify(planSummary)
    );

    if (planSummary.length > 0) {
      this.plansError = false
    } else {
      this.plansError = true
    }
    if (updatedSum > 0) {
      this.cartcheckvalue = false;
    } else {
      this.cartcheckvalue = true;
    }

    setTimeout(() => {



      this.planssummarymain =
        JSON.parse(sessionStorage.getItem("plansummarymain")) || "";

      var total = 0;
      for (let i = 0; i < this.planssummarymain.length; i++) {
        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }

      console.log(total);

      this.planAmount = this._decimalPipe
        .transform(total, "1.2-2")
        .replace(/,/g, "");
      sessionStorage.setItem("totalAmount", this.planAmount);


      if (this.planAmount > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }

    }, 100);

  }

  public removeplansummary(obj: any) {

    let planSummary = JSON.parse(sessionStorage.getItem("plansummary"))


    //  //console.log("Beforeremoving")
    //console.log(planSummary)
    //console.log("removeingobject")
    //console.log(obj)


    // //console.log(obj.name)


    if (planSummary) {
      //console.log("removeinplanid"+obj.id)
      let index = this.getslectedplans(obj.id)
      //console.log(index)

      if (index > -1) {
        planSummary.splice(index, 1)
        //console.log("afterremove")
        //console.log(planSummary)
      }
      else {
        return
      }

      // //console.log(planSummary)
      // //console.log(planSummary.length)
      //console.log("beforeremoveplans")
      let selectedPlans = JSON.parse(sessionStorage.getItem("selectedPlans"))
      var newselectedplans = {}
      for (var i = 0; i < planSummary.length; i++) {
        newselectedplans[planSummary[i].id] = i

      }

      //console.log("newselectedPlans")
      //console.log(newselectedplans)
      sessionStorage.setItem("selectedPlans", JSON.stringify(newselectedplans))
      // this.removeslectplans(obj.id,planSummary.length)

      let gstprice = 0;
      let hstprice = 0;
      let pstprice = 0;
      let qstprice = 0;

      if (obj.gst > 0) {
        gstprice = obj.planPrice * obj.gst;
        obj["gstPrice"] = parseFloat(
          this._decimalPipe.transform(gstprice, "1.2-2")
        );
      } else {
        obj["gstPrice"] = 0;
      }

      if (obj.hst > 0) {
        hstprice = obj.planPrice * obj.hst;

        obj["hstPrice"] = parseFloat(
          this._decimalPipe.transform(hstprice, "1.2-2")
        );
      } else {
        obj["hstPrice"] = 0;
      }

      if (obj.pst > 0) {
        pstprice = obj.planPrice * obj.pst;
        obj["pstPrice"] = parseFloat(
          this._decimalPipe.transform(pstprice, "1.2-2")
        );
      } else {
        obj["pstPrice"] = 0;
      }
      if (obj.qst > 0) {
        qstprice = obj.planPrice * obj.qst;
        obj["qstPrice"] = parseFloat(
          this._decimalPipe.transform(qstprice, "1.2-2")
        );
      } else {
        obj["qstPrice"] = 0;
      }

      obj["taxUI"] = "";
      if (obj["gstCheck"]) {
        obj["taxUI"] += "<span>";
        if (obj["gstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["gstPrice"], "1.2-2") +
            "&nbsp;(GST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (obj["pstCheck"]) {
        obj["taxUI"] += "<span>";
        if (obj["pstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["pstPrice"], "1.2-2") +
            "&nbsp;(PST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (obj["qstCheck"]) {
        obj["taxUI"] += "<span>";
        if (obj["qstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["qstPrice"], "1.2-2") +
            "&nbsp;(QST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (obj["hstCheck"]) {
        obj["taxUI"] += "<span> ";
        if (obj["hstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["hstPrice"], "1.2-2") +
            "&nbsp;(HST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (
        !obj["hstCheck"] &&
        !obj["gstCheck"] &&
        !obj["pstCheck"] &&
        !obj["qstCheck"]
      ) {
        obj["taxUI"] += "<span>-";

        obj["taxUI"] += "</span>";
      }

      // //console.log(object["taxUI"])

      obj["tax"] = parseFloat(
        this._decimalPipe.transform(
          gstprice + hstprice + pstprice + qstprice,
          "1.2-2"
        )
      );
      obj["totalPrice"] =
        obj.planPrice + gstprice + hstprice + pstprice + qstprice,


        obj["totalUI"] =
        "$" +
        this._decimalPipe.transform(
          obj.planPrice + gstprice + hstprice + pstprice + qstprice,
          "1.2-2"
        );

      obj["total"] = parseFloat(
        this._decimalPipe.transform(
          obj.planPrice + gstprice + hstprice + pstprice + qstprice,
          "1.2-2"
        )
      );


      let updatedSum = this.removetosum(obj.totalPrice)
      this.planssummarymain = [];
      this.planssummaryopt = [];

      planSummary.forEach((element: any) => {
        if (element.packagename != "Opt-in") {
          this.planssummarymain.push(element);
        } else {

          this.planssummaryopt.push(element);
        }
      });



      sessionStorage.setItem(
        "plansummarymain",
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        "plansummaryopt",
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem(
        "plansummary",
        JSON.stringify(planSummary)
      );

      if (planSummary.length > 0) {
        // this.plansnexttab = false;
      } else {
        // this.plansnexttab = true;
      }
      if (updatedSum > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }
    }

    setTimeout(() => {



      this.planssummarymain =
        JSON.parse(sessionStorage.getItem("plansummarymain")) || "";

      var total = 0;
      for (let i = 0; i < this.planssummarymain.length; i++) {
        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }

      console.log(total);

      this.planAmount = this._decimalPipe
        .transform(total, "1.2-2")
        .replace(/,/g, "");
      sessionStorage.setItem("totalAmount", this.planAmount);




    }, 100);
  }

  public covergages = ['SINGLE', 'COUPLE', 'FAMILY']

  public addPlansConfig() {



    let selectedPlans = JSON.parse(sessionStorage.getItem("plansummarymain"))

    // if(this.customerPlans && this.customerPlans.length>0){
    //   this.plansError = false
    // }
    // else{
    if (!selectedPlans || selectedPlans?.length <= 0) {
      this.plansError = true

      return;
    }
    else {
      this.plansError = false
    }




    this.plansObj = []
    let phrPlanSelected = false;
    let isPhr = false;
    let oldPlans = []
    for (let pack of this.specialpackages) {

      let obj: any = {

      }
      let selected: any = {}
      if (pack.id == 10) isPhr = true;

      if (pack.selected) {


        if (pack.id == 10) phrPlanSelected = true;
        Object.keys(pack.groups).forEach((group: any) => {
          for (let plan of pack.groups[group]) {
            for (let plans of plan.plans) {
              if (plans.selected) {
                Object.keys(plans.productAddonss).forEach((addon: any) => {
                  for (let c of plans.productAddonss[addon]) {
                    if (c.selected) {
                      selected = { ...c }
                      for (let sc of selectedPlans) {

                        if (c.planId == sc.id && !sc?.products[0]?.selected) {
                          obj = {
                            ...(c.selected ? { oldPlan: { ...c } } : { oldPlan: {} }),
                            newPlan: { ...sc },
                            ...(c.planCoverage != sc.coverage && c.selected && this.covergages.includes(c.planCoverage) && { coverageChange: true })
                          }
                          // console.log(obj)
                        }

                        else {
                          this.unselected.forEach((ele) => {

                            if (ele.planId == c.planId) {
                              console.log(this.unselected)
                              let obj1 = {
                                ...(c.selected ? { oldPlan: { ...c } } : { oldPlan: {} }),
                                newPlan: {},

                              }
                              oldPlans.push(obj1)

                            }

                          })
                        }




                      }
                    }
                  }
                })
              }


            }

          }


        })
        if (obj && Object.keys(obj).length > 0 && ((obj.oldPlan && Object.keys(obj?.oldPlan).length > 0) || (obj.newPlan && Object.keys(obj?.newPlan).length > 0))) {

          // console.log({ obj })
          this.plansObj.push(obj)
          obj = {}


        }
      }

      // when package selected but completely different plan with in same package
      if (pack.selected && selected) {
        console.log("entered")
        Object.keys(pack.groups).forEach((group: any) => {
          for (let plan of pack.groups[group]) {
            for (let plans of plan.plans) {
              if (!plans.selected) {
                Object.keys(plans.productAddonss).forEach((addon: any) => {
                  for (let c of plans.productAddonss[addon]) {
                    for (let sc of selectedPlans) {
                      // console.log(plans.planLevel)
                      // console.log(plans.planLevel, c.name, c.planId, sc.planId, sc.planLevel, c.planCoverage)
                      if (plans.planLevel == sc.planLevel && c.planId == sc.id) {
                        obj = {
                          oldPlan: { ...selected },
                          newPlan: { ...sc },
                        }
                      }

                    }
                  }
                })

                if (Object.keys(obj).length > 0) {


                  this.unselected = this.unselected.filter((ele) => (
                    ele.planId != obj.oldPlan.planId

                  ))
                  oldPlans = oldPlans.filter(e => e.oldPlan.planId != obj.oldPlan.planId);
                  console.log(this.unselected, oldPlans, obj.oldPlan.planId, obj)
                  this.plansObj.push(obj)
                  obj = {}

                }
              }

            }
          }
        })
      }

      //when package in not selected but completely diffrenet package selected
      if (!pack.selected) {
        console.log(pack.id)
        for (let sc of selectedPlans) {
          console.log(sc.packageId == pack.id)
          if (sc.packageId == pack.id) {
            obj = {
              newPlan: { ...sc },
              oldPlan: {}
            }
          }
        }
        if (Object.keys(obj).length > 0) {
          this.plansObj.push(obj)
          obj = {}
        }
      }


    }
    //when plan selected and diselected
    if (oldPlans.length > 0) {
      const uniquePlanIds = new Set<number>();

      const filteredOldPlans = oldPlans.filter((plan) => {
        if (!uniquePlanIds.has(plan.oldPlan.planId)) {
          uniquePlanIds.add(plan.oldPlan.planId);
          return true;
        }
        return false;
      });

      if (filteredOldPlans.length > 0) {
        this.plansObj = [...this.plansObj, ...filteredOldPlans];
      }
    }

    //high cost drugs selected and all in selected
    let allinSelected = this.plansObj.some((plan) => { return plan.newPlan.planLevelParent == 6 })
    console.log(allinSelected)
    const allIndisallowed = [1, 10, 14, 24]
    if (allinSelected) {
      for (let pack of this.specialpackages) {
        if (pack.selected) {
          Object.keys(pack.groups).forEach((group: any) => {
            for (let plan of pack.groups[group]) {
              for (let plans of plan.plans) {
                if (plans.selected && allIndisallowed.includes(plans.planLevel)) {
                  Object.keys(plans.productAddonss).forEach((addon: any) => {
                    for (let c of plans.productAddonss[addon]) {
                      if (c.selected) {
                        // console.log(c.planId)
                        this.plansObj.push({
                          oldPlan: { ...c },
                          newPlan: {}
                        })

                      }
                    }
                  })
                }


              }

            }


          })

        }





      }
    }

    //phr rules
    let healthAndDentalSelected = this.plansObj.some((plan) => { return plan.newPlan.packageId == 1 })
    let phrSelected = this.plansObj.some((plan) => { return plan.newPlan.packageId == 10 });
    if (healthAndDentalSelected && isPhr) {
      if (!phrSelected && !phrPlanSelected) {
        Swal.fire({
          title: this.lang?.Error, text: this.lang?.Please_select_a_Provincial_Health_Replacement_Plan_along_with_a_Health_Dental_Insurance_Plan
        })
        return
      }

    }




    let endPoint = `/api/ap/v2/member/${this.customerid}/customerPlansConfig`;

    let url = `${environment.apiUrl}${endPoint}`;
    var accessToken = sessionStorage.getItem('accessToken');

    let data = {
      "plans": this.plansObj,
      "enrollmentDate": this.addPlanEnrollmentDate
    }
    console.log({ data })

    this.http.post(url, data, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      },
    }).subscribe((response: any) => {
      console.log(response, response.status)

      if (response.status == '200' || response.data) {

        console.log("entered")
        this.addPlansConfigData = response.data
        this.warningsData = response?.warnings
        console.log(this.addPlansConfigData.newPlans)
        this.closePlans()
        $("#planDetails").modal('hide')
        $("#showAddPlanDetails").modal('show')

        // Swal.fire({ title: this.lang?.Info, text: "Plans Added Successfully" })
        // this.getCustomerData()




      }
      // else {
      //     Swal.fire({ title: this.lang?.Error, text: Response.error || Response.data.error })
      // }

    }, (error) => {
      if (error.value) {
        Swal.fire({ title: this.lang?.Error, text: error.error })
        // this.router.navigate([this.lang?.Error]);
      } else {
        Swal.fire({ title: this.lang?.Error, text: error.error });
      }
    })

  }

  public submitAddPlans() {

    let endPoint = `/api/ap/v2/member/${this.customerid}/customerPlanConfirmation`;

    let url = `${environment.apiUrl}${endPoint}`;
    var accessToken = sessionStorage.getItem('accessToken');
    console.log(this.addplanFormDetails.value)

    this.addPlansConfigData.terminateGreenshiled = this.addPlansConfigData.terminateGreenshiled ? this.addplanFormDetails.get('proceedWithGreenshieldTermination').value : this.addPlansConfigData.terminateGreenshiled
    this.addPlansConfigData.terminateEquitable = this.addPlansConfigData.terminateEquitable ? this.addplanFormDetails.get('proceedWithEquitableTermination').value : this.addPlansConfigData.terminateEquitable
    this.addPlansConfigData.equitableNewCustomer = this.addPlansConfigData.equitableNewCustomer ? this.addplanFormDetails.get('proceedWithEquitableRegistration').value : this.addPlansConfigData.equitableNewCustomer
    this.addPlansConfigData.greenshieldNewCustomer = this.addPlansConfigData.greenshieldNewCustomer ? this.addplanFormDetails.get('proceedWithGreenshieldRegistration').value : this.addPlansConfigData.greenshieldNewCustomer

    let data = {
      "data": this.addPlansConfigData,
      "enrollmentDate": this.addPlanEnrollmentDate
    }
    console.log({ data })

    this.http.post(url, data, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      },
    }).subscribe((Response: any) => {
      if (Response.status == '200') {

        $("#showAddPlanDetails").modal('hide')
        Swal.fire({ title: this.lang?.Info, html: Response.messagesUI })

        this.getCustomerData()

        this.closePlans()
        this.addplanFormDetails.reset()
        this.addPlanEnrollmentDate = ''

      }
      else {
        Swal.fire({ title: this.lang?.Error, text: Response.error || Response.data.error })
      }

    }, (error) => {
      if (error.value) {
        Swal.fire({ title: this.lang?.Error, text: error.error })
        // this.router.navigate([this.lang?.Error]);
      } else {
        Swal.fire({ title: this.lang?.Error, text: error.error });
      }
    })

  }

  public closePlans() {
    sessionStorage.removeItem("totalAmount")
    sessionStorage.removeItem("totalAmountUI")
    sessionStorage.removeItem("plansummarymain")
    sessionStorage.removeItem("plansummaryopt")
    sessionStorage.removeItem("plansummary")
    sessionStorage.removeItem("plansskumain")
    sessionStorage.removeItem("selectedPlans")

  }


  public addtoslectplans(planid: number, plansumamryindex: number) {

    //console.log("beforeaddtoplans")
    //console.log(planid)
    //console.log(plansumamryindex)
    let selectedPlans = JSON.parse(sessionStorage.getItem("selectedPlans") || "{}")
    //console.log(selectedPlans)
    selectedPlans[planid] = plansumamryindex
    //console.log("afteraddtoplans")
    //console.log(selectedPlans)
    sessionStorage.setItem("selectedPlans", JSON.stringify(selectedPlans))

  }
  public removeslectplans(planid: number, plansumamryindex: number) {


    //console.log("beforeremoveplans")
    let selectedPlans = JSON.parse(sessionStorage.getItem("selectedPlans"))

    //console.log(selectedPlans)
    delete selectedPlans[planid]




    for (const planid in selectedPlans) {

      //console.log(planid)
      //console.log(selectedPlans[planid])

      if (selectedPlans[planid] != 0) {
        selectedPlans[planid] = selectedPlans[planid] - 1
        if (selectedPlans[planid]) {

        }
      }
    }
    //console.log("adjustedselectedPlans")
    //console.log(selectedPlans)
    sessionStorage.setItem("selectedPlans", JSON.stringify(selectedPlans))


  }

  public getslectedplans(planid: number) {
    //console.log(planid)
    let selectedPlans = JSON.parse(sessionStorage.getItem("selectedPlans") || "{}")
    //console.log(selectedPlans)
    return selectedPlans[planid]


  }
  public addtosum(amount: any) {


    console.log("addtosum" + amount)

    // amount = Math.round((amount + Number.EPSILON) * 100) / 100;

    let selectedPlansAmount = parseFloat(sessionStorage.getItem("totalAmount") || "0.00")

    selectedPlansAmount = selectedPlansAmount + parseFloat(amount)

    console.log("selectedPlansAmount" + selectedPlansAmount)
    sessionStorage.setItem("totalAmount", this._decimalPipe.transform(selectedPlansAmount, "1.2-2").replace(/,/g, ""))

    sessionStorage.setItem(
      "totalAmountUI",
      "$" + this._decimalPipe.transform(selectedPlansAmount, "1.2-2").replace(/,/g, "")
    );



    this.planAmount = this._decimalPipe.transform(selectedPlansAmount, "1.2-2").replace(/,/g, "")


    return selectedPlansAmount


  }

  public removetosum(amount: number) {

    let selectedPlansAmount = parseFloat(sessionStorage.getItem("totalAmount").replace(/,/g, ""))


    selectedPlansAmount = selectedPlansAmount - amount
    sessionStorage.setItem("totalAmount", this._decimalPipe.transform(selectedPlansAmount, "1.2-2").replace(/,/g, ""))
    sessionStorage.setItem(
      "totalAmountUI",
      "$" + this._decimalPipe.transform(selectedPlansAmount, "1.2-2").replace(/,/g, "")
    );


    this.planAmount = this._decimalPipe.transform(selectedPlansAmount, "1.2-2").replace(/,/g, "")
    return selectedPlansAmount

  }

  public openplanoptions(elementcv, options, plan, product) {
    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split("##");


    let modifiedOptions = [];


    // this.plandetailsobjvalue = plandetailsobj;
    console.log(plandetails)
    console.log(product.id)

    this.plandetailsobjvalue = plandetails;


    options.forEach((element) => {
      element.planOptionsValues.forEach((options) => {
        options.planOptionName = element.name;
        options.json = JSON.stringify(options);
      });

      modifiedOptions.push(element);
    });

    this.optionstitle = modifiedOptions;
    this.showoptions = true;
    // alert("startrhetre")
    setTimeout(() => {
      $('#showplanoptions-modal').modal('show');

    }, 1000);


  }
  public planoptionselection(event, optionvalue, optionid, optionvalueid) {
    this.planoptionValues = {}
    this.planoptionValues = optionvalue

    // $(".optionselectionmethod-" + optionid)
    //   .not(this)
    //   .prop("checked", false);

    // $("#planselectionvalue-" + optionvalueid + "-" + optionid).prop(
    //   "checked",
    //   true
    // );

    this.optionmessage = "";
  }

  public confirmoptionsselection() {
    let optionumber = $("#optionumber").val();
    console.log("plandetailsobj", $("#plandetailsobj").val())

    let plandetailsobj = $("#plandetailsobj").val().split("##");

    let array = [];

    let optionarray = [];


    let checkvalue = true;

    for (let i = 1; i <= optionumber; i++) {
      checkvalue = checkvalue && $(".optionselectionmethod-" + i + ":checked").val();
    }

    if (!checkvalue) {
      this.optionmessage = this.lang?.Please_select_all_plan_options;
      return;
    } else {
      this.optionmessage = "";
    }

    $("#showplanoptions-modal").modal("hide");


    if (sessionStorage.getItem("maritalStatus") == plandetailsobj[2]) {
    } else {
      if (sessionStorage.getItem("brokerType") == "EXECUTIVE") {
        $("#insuranceconfirmation-modal").modal("show");
      }
    }

    for (let i = 1; i <= optionumber; i++) {
      let optionobj: any = {};

      let selectedOptionValues = JSON.parse(
        $(".optionselectionmethod-" + i + ":checked").val()
      );
      // //console.log(selectedOptionValues)
      optionobj = selectedOptionValues;

      optionobj.name = selectedOptionValues.planOptionName;
      optionobj.value = selectedOptionValues.value;
      optionobj.planOptionsValueId = selectedOptionValues.planOptionsValueId;

      optionarray.push(optionobj);
    }

    // let plandetailsobj = $("#plandetailsobj").val().split(",");

    let obj = {
      enrollmentDate: "",
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(plandetailsobj[3]),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(plandetailsobj[3]),
      amountUI: "$" + this._decimalPipe.transform(plandetailsobj[3], "1.2-2"),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == "" ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == "null"
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == "" ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == "null"
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == "true" ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: optionarray || [],
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
        // elementcv.checked =false
      }
    }

    let obj1 = {}
    console.log(obj)
    this.addtoplansummary(obj, this.planobjdata)




  }



  public closeoptionsselection() {
    $("#showplanoptions-modal").modal("hide");
    let plandetailsobj = $("#plandetailsobj").val().split("##");

    console.log(plandetailsobj[19])
    // console.log(plandetailsobj[20])

    $("#plancheck" + plandetailsobj[19]).prop("checked", false);



    let optionumber = $("#optionumber").val();

    $("#showplanoptions-modal").modal("hide");

    for (let i = 1; i <= optionumber; i++) {
      $(".optionselectionmethod-" + i + ":checked").prop("checked", false);
    }
  }
  getPADdetails() {
    return false
    let endPoint = '/customer/' + this.customerid + '/achDetails'
    // let endPoint = '/customer/'+3493+'/achDetails'
    this.http.get(environment.apiUrl + '/api/ap/admin' + endPoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.PADdetails = response.data.achDetails.data;
        if (this.PADdetails.padAgreement) {
          this.padAgreement = this.PADdetails.padAgreement;
        }
        this.voidCheckImage = this.PADdetails.voidCheckImage;
        console.log('voidCheckImage', this.voidCheckImage)
        const doc = new jsPDF();

        doc.addImage(this.voidCheckImage, 'JPEG', 10, 10, 190, 100);
        const pdfFile = doc.output('blob');
        this.voidCheckPdf = new File([pdfFile], 'voidCheque.pdf', { type: 'application/pdf' });
        console.log('voidCheckPdf', this.voidCheckPdf)
        this.voidCheckFileType = this.PADdetails.voidCheckFileType;
        if (this.padAgreement != null) {
          this.existVoid = true;
        }
        this.bankCode = this.PADdetails.bankCode;
        this.transitNumber = this.PADdetails?.transitNumber;
        // this.accountNumber = this.maskNumber.transform(this.PADdetails.accountNumber);
        this.accountNumber = this.PADdetails.accountNumber

        this.getBankDetails();
      }
      else {
        // Swal.fire({allowOutsideClick: false,title: this.lang?.Error, text:response.message})
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
    })
  }
    getInvoiceDetails: any = '';
  invoiceLink: any;
    actionButtons: { condition: any; backgroundColor: string; icon: string; label: string; onClick: () => void; }[];
  finalinvoiceres: any = [];
    InvoiceStatus: any[] = [];


//  getInvoiceStatus(value: any) {

//     if (value) {
//       let status = this.InvoiceStatus.filter(payment => payment.value == value)
//       return status[0].name
//     }

//   }

getInvoiceStatus(value: any): string {
    if (value) {
      let status = this.InvoiceStatus.filter(payment => payment.value == value)
      return status[0].name
    }
  }

   DownloadInvoice(invoice: any) {
      this.http.get(invoice, { responseType: "arraybuffer" }).subscribe(
        pdf => {
          const blob = new Blob([pdf], { type: "application/pdf" });
          const fileName = `${this.getInvoiceDetails.invoiceNumber}` + ".pdf";
          saveAs(blob, fileName);
        },
        (error) => {
          Swal.fire({ allowOutsideClick: false, title: "Error", text: error.error.error.message })
        }
      );
  
    }

  getBankDetails() {
    let data = this.customerData?.customerACHdetails.data
    console.log({ PAD: this.PADdetails })
    let bankCode = this.PADdetails.bankCode;
    // bankCode = bankCode.length > 3 ? bankCode.slice(1) : bankCode;


    const obj = {

      "branchCode": data.transitNumber || '',
      "bankCode": data.bankCode ? data.bankCode : '',
      "accountNumber": data.accountNumber || '',
      "enrollmentDate": data.enrollmentDate || '',
      "amount": 0

    }
    // let data = this.PADdetails ?? {};
    // data['padAgreement'] = ''
    // console.log("paddetails", obj)
    // data['branchCode'] = this.PADdetails?.transitNumber;
    let accessToken = sessionStorage.getItem('accessToken');
    const bankInfoUrl = 'https://testcustomersapi.groupbenefitz.aitestpro.com/api/ep/customer/bank/verify';
    this.http.post(bankInfoUrl, obj, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.bank = response.data;
        this.address = this.bank.address;
        this.bankinformation = response.data.bank.name + "\n" + response.data.address.split(",").join("\n");
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.message })
    })
  }

  updateAddressForm() {
    // this.UpdateAddressComponent = true;
    // console.log('this.customerData', this.customerData)

    // console.log(this.addressform.value)
    this.invalidpostalcodeprivince = false;
    this.provianceList.forEach((element: any) => {
      if (element.name == this.customerData.province) {
        this.customerData.province = element.shortName

      }
    });

    this.addressform.patchValue(this.customerData);
    console.log(this.addressform.value)
    // this.addressform.markAllAsTouched();
    
    if (!!this.addressform.get('primaryPhone')?.value) {
      const inputValue = this.addressform.get('primaryPhone')?.value;
      this.addressform.get('primaryPhone')?.setValue(this.phoneNoFormat.transform(inputValue), { emitEvent: false });
    }
    else if (!!this.addressform.get('secondaryPhone')?.value) {
      const inputValue = this.addressform.get('secondaryPhone')?.value;
      this.addressform.get('secondaryPhone')?.setValue(this.phoneNoFormat.transform(inputValue), { emitEvent: false });
    }

    console.log(this.addressform.value)
  }

  changeAdvisorData() {
    console.log(this.brokerregform.value)


    let endPoint = '/customer/' + this.customerid + '/changeAdvisor'

    console.log(this.planoptionValues)
    let data = {
      "brokerId": parseInt(this.brokerregform.value.profile),
      "effectiveDate": this._CustomDatePipe.transform(this.brokerregform.value.effectiveDate)
    }

    this.http.post(environment.apiUrl + '/api/ap' + endPoint, data, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe(async (response: any) => {
      if (response.status == 200) {
        $("#changeAdvisor").modal('hide');
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
        this.getCustomerData()
      } else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message });
      }
    },
      (error) => {
        if (
          error.status == 400 ||
          error.status == 401 ||
          error.status == 402 ||
          error.status == 403
        ) {
          Swal.fire({
            title: this.lang.Error??'Error',
            text: error.error.error.message,
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: this.lang.Proceed,
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
            else {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
          });
        } else {
          // Swal.fire(error.error.error.message)
          Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
        }
        // this.toastrService.error("Invalid Credentials", 'Error!');
      })
  }
  updateExecutiveOptionsValues() {
    let endPoint = '/customer/' + this.customerid + '/planOptionValue/' + this.selectedExecutiveOptions + ''

    console.log(this.planoptionValues)
    let data = { "planOptionsId": this.planoptionValues.planOptionsId, "planOptionsValue": this.planoptionValues.value }

    this.http.put(environment.apiUrl + '/api/ap' + endPoint, data, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe(async (response: any) => {
      if (response.status == 200) {
        this.http.get(environment.apiUrl + '/api/ap/global/set-adminMembers').subscribe((newResponse) => {
        // this.http.post(environment.apiUrl + '/api/ap/v3/global/set-adminMembers',{id:this.customerid}).subscribe((newResponse) => {
          this.http.post(environment.reportApiUrl + '/websocket/member/notification-to-others', {
            "message": "Members information has been updated. Please refresh screen."
          }, {
            headers: {
              Authorization: 'Bearer ' + this.accessToken,
              'Content-Type': 'application/json',
            }
          }).subscribe((res) => {
            console.log({ res })
          })
        })
        this.closeExecutivesmodal.nativeElement.click();
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
      }
      else {

        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
      }
    }, (error) => {
      this.closeExecutivesmodal.nativeElement.click();
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })

    });

  }

  updateAddress() {
    console.log(this.addressForm['postalCode'].valid)

    const field1 = this.addressform.value.primaryPhone;
    const field2 = this.addressform.value.secondaryPhone;



    // if (!field1 && !field2) {
    //   // return { mismatch: true }; // Either field is empty
    //   this.secondaryphonecheck = false
    // }

    // if (field1 && field2) {
    //   // return { mismatch: true }; // Values don't match

    //   if (field1 == field2) {
    //     this.secondaryphonecheck = true
    //   }
    // }





    //   else {
    if (this.addressform.invalid) {
      this.addressform.markAllAsTouched();
      return;
    }
    else {
      const endPoint = '/v3/customer/' + this.customerid + '/address';
      let data = this.addressform.value;
      data['firstName'] = this.addressform.value.firstName;
      data['lastName'] = this.addressform.value.lastName;
      data["street_address_line1"] = this.addressform.value.line1
      data["street_address_line2"] = this.addressform.value.line2
      data["primaryEmail"] = this.addressform.value.email;
      data["dob"] = this._CustomDatePipe.transform(this.addressform.value.dob);


      console.log(data["street_address_line2"])
      if (data["street_address_line2"] == null) {
        data["street_address_line2"] = '';
      }

      if (data["street_address_line2"] == '') {
        data["street_address_line2"] = '';
      }

                data["postal_code"] = this.addressform.value.postalCode
                data["code"] = this.valisignform.value.code
                if (this.addressForm['secondaryPhone'].value == null) {
                    data['secondaryPhone'] = '';
                }
                if (this.addressform.valid && this.invalidpostalcodeprivince == false) {
                    this.http.put(environment.apiUrl + '/api/ap' + endPoint, data, {
                        headers: {
                            Authorization: 'Bearer ' + this.accessToken,
                            'Content-Type': 'application/json',
                        }
                    }).subscribe(async (response: any) => {
                        if (response.status == 200) {
                          this.http.get(environment.apiUrl + '/api/ap/global/set-adminMembers').subscribe((newResponse) => {
                          // this.http.post(environment.apiUrl + '/api/ap/v3/global/set-adminMembers',{id:this.customerid}).subscribe((newResponse) => {
                                this.http.post(environment.reportApiUrl+'/websocket/member/notification-to-others',{
                                  "message": "Members information has been updated. Please refresh screen."
                                }, { headers: {
                                  Authorization: 'Bearer ' + this.accessToken,
                                  'Content-Type': 'application/json',
                                } }).subscribe((res)=>{
                                  console.log({res})
                                })
                              })
                              this.members = this.members?.map(member =>
                                member.id == this.customerid ? { ...member,
                                    firstName: this.addressform.value.firstName,
                                    lastName: this.addressform.value.lastName,
                                    username: this.addressform.value.email,
                                    primaryPhone: this.addressform.value.primaryPhone
                                } : member
                            );
                            console.log('this.members',this.members)
                            this.store.dispatch(loadMemberDataSuccess({memberData: this.members}))
                            this.store.dispatch(loadMemberData())

                            let customerDataEndpoint = '/customer/' + this.customerid + '/details';

            var MemeberDetails = '/api/ap/admin' + customerDataEndpoint;


            // await postServiceWorkerMessage(WorkerMessageType.Delete, [
            //     environment.apiUrl + MemeberDetails
            // ]);
            this.getCustomerData();
            this.closeAddressmodal.nativeElement.click();
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
          }
          else {
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
          }
        }, (error) => {

          Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })

        });
      }
    }
    // }
  }


  alphabatesOnly(event: any) {
    const charCode = event.which ? event.which : event.keyCode;

    if (event.currentTarget.value.length == 0) {
      if ((charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) || ((charCode >= 192 && charCode <= 255)) || charCode == 46 || charCode == 45 || charCode == 39 || charCode == 95)
        return true;
      else return false;
    }
    else {
      if (
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) || ((charCode >= 192 && charCode <= 255)) ||
        charCode === 32 || charCode == 46 || charCode == 45 || charCode == 39 || charCode == 95)
        return true;
      else return false;
    }
  }
  alphanumericOnly(event: any) {
    const charCode = event.which ? event.which : event.keyCode;

    if (event.currentTarget.value.length === 0) {
      if (
        (charCode >= 48 && charCode <= 57) || // Numbers
        (charCode >= 65 && charCode <= 90) || // Uppercase letters
        (charCode >= 97 && charCode <= 122) || // Lowercase letters
        ((charCode >= 192 && charCode <= 255)) ||
        charCode === 46 || charCode === 45 || charCode === 39 || charCode === 95
      )
        return true;
      else return false;
    } else {
      if (
        (charCode >= 48 && charCode <= 57) || // Numbers
        (charCode >= 65 && charCode <= 90) || // Uppercase letters
        (charCode >= 97 && charCode <= 122) || // Lowercase letters
        ((charCode >= 192 && charCode <= 255)) ||
        charCode === 32 || charCode === 46 || charCode === 45 || charCode === 39 || charCode === 95
      )
        return true;
      else return false;
    }
  }

  updatePhoneNoForm() {
    this.phoneform.patchValue(this.customerData);
  }

  updatePhoneNo(value: any) {
    if (this.phoneform.invalid) {
      this.phoneform.markAllAsTouched();
      return;
    }
    else {
      const endPoint = '/v3/customer/' + this.customerid + '/address';
      let data = this.phoneform.value;
      if (this.phoneForm['secondaryPhone'].value == null) {
        data['secondaryPhone'] = '';
      }
      this.http.put(environment.apiUrl + '/api/ap/admin' + endPoint, data, {
        headers: {
          Authorization: 'Bearer ' + this.accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200) {
          this.getCustomerData();
          this.closePhonemodal.nativeElement.click();
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
        }
      }, (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
      });

    }

  }

  closePhoneModal() {
    this.phoneform.reset();
  }

  updateSpousePlan() {
    // this.UpdateSpousePlanComponent = true;
    this.spouseUpdate = true;
    this.spouseStatus = true;
    this.spouseform.patchValue(this.spouseInfo);
    this.spouseCoverage = this.spouseInfo.coveredByAnotherPlan;
    this.spouseForm['martialStatus'].clearValidators();
    this.spouseForm['martialStatus'].updateValueAndValidity();
    this.spouseForm['effectiveDate'].clearValidators();
    this.spouseForm['effectiveDate'].updateValueAndValidity();
    if (this.spouseCoverage === false) {
      this.spouseForm['insurer'].clearValidators();
      this.spouseForm['insurer'].updateValueAndValidity();
      this.spouseForm['healthPlan'].clearValidators();
      this.spouseForm['healthPlan'].updateValueAndValidity();

    }
  }

  updateSpouseDetails() {



    let data = this.spouseform.value;
    let spouseData = this.childrenInfo;

    // if(this.spouseForm['effectiveDate'].invalid || this.spouseForm['martialStatus'].invalid) {
    //   this.spouseform.markAllAsTouched();
    //   return;
    // }
    if (this.spouseform.invalid) {
      this.spouseform.markAllAsTouched();
      return;
    }
    else {
      // const endPoint = '/customer/'+this.customerid+'/lifeChange/spouse/add/true';
      const endPoint = '/customer/' + this.customerid + '/customerRelative/' + this.spouseId + '/details';

      let data = this.spouseform.value;
      // console.log(this.spouseForm['dob'].value)
      data["carrierName"] = this.spouseform.value.insurer ?? '';
      data["coverage"] = this.spouseform.value.healthPlan ?? '';
      // for(let spouse of spouseData){
      //   console.log(spouse)
      //   if(spouse["relationType"]=="spouse"){
      //    data["firstName"]=spouse.firstName;
      //    data["lastName"]=spouse.lastName;
      //    data["dob"]=spouse.dob;
      //    data["gender"]=spouse.gender;
      //    data["email"]=spouse.email;
      //    data["coverage"]=spouse.healthPlan;
      //    data["carrierName"]=spouse.insurer;
      //    data["healthPlan"]=spouse.healthPlan;
      //    data["insurer"]=spouse.insurer;
      //   }

      // }
      data["relationType"] = "SPOUSE"
      if (this.spouseform.value.coveredByAnotherPlan === true) {
        data["coveredByAnotherPlan"] = true
      }
      else {
        data["coveredByAnotherPlan"] = false
      }

      data["dob"] = this.datePipe.transform(new Date(this.spouseform.value.dob).toLocaleString(), 'MM-dd-yyyy')
      console.log(data)
      this.http.put(environment.apiUrl + '/api/ap' + endPoint, data, {
        headers: {
          Authorization: 'Bearer ' + this.accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200) {
          this.http.get(environment.apiUrl + '/api/ap/global/set-adminMembers').subscribe((newResponse) => {
          // this.http.post(environment.apiUrl + '/api/ap/v3/global/set-adminMembers',{id:this.customerid}).subscribe((newResponse) => {
            this.http.post(environment.reportApiUrl + '/websocket/member/notification-to-others', {
              "message": "Members information has been updated. Please refresh screen."
            }, {
              headers: {
                Authorization: 'Bearer ' + this.accessToken,
                'Content-Type': 'application/json',
              }
            }).subscribe((res) => {
              console.log({ res })
            })
          })
          this.getCustomerData();
          // this.getServiceWorkerDetails();
          this.closeSpousemodal.nativeElement.click();
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
        }
      }, (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
      });
    }
  }

  openCoverage(value: any) {
    this.coverage = value;
    if (this.coverage === 'open') {
      this.spouseCoverage = true;
      this.spouseForm['insurer'].setValidators([Validators.required]);
      this.spouseForm['insurer'].updateValueAndValidity();
      this.spouseForm['healthPlan'].setValidators([Validators.required]);
      this.spouseForm['healthPlan'].updateValueAndValidity();
    }
    else {
      this.spouseForm['insurer'].reset();
      this.spouseForm['healthPlan'].reset();
      this.spouseForm['insurer'].clearValidators();
      this.spouseForm['insurer'].updateValueAndValidity();
      this.spouseForm['healthPlan'].clearValidators();
      this.spouseForm['healthPlan'].updateValueAndValidity();
    }
  }

  openDependentCoverage(value: any) {
    this.dependentCoverage = value;
    if (this.dependentCoverage === 'open') {
      this.childCoverage = true;
      this.dependentForm['carrierName'].setValidators([Validators.required]);
      this.dependentForm['carrierName'].updateValueAndValidity();
    }
    else {
      this.dependentForm['carrierName'].reset();
      this.dependentForm['carrierName'].clearValidators();
      this.dependentForm['carrierName'].updateValueAndValidity();

    }
  }

  updateDependentForm(i: any) {
    // let i=this.currentIndexOfSwipperDependents-1;
    let childId = this.childrenInfo[i].id;
    this.dependentUpdate = true;
    this.dependentStatus = true;
    this.childrenId = childId;
    this.dependentform.patchValue(this.customerData?.dependents.childrens[i]);
    this.childCoverage = this.customerData?.dependents.childrens[i].coveredByAnotherPlan;
    this.specialNeeds = this.customerData?.dependents.childrens[i].specialNeeds;
    this.postSecondaryStudent = this.customerData?.dependents.childrens[i].postSecondaryStudent;
    // this.dependentForm['martialStatus'].clearValidators();
    // this.dependentForm['martialStatus'].updateValueAndValidity();
    this.dependentForm['effectiveDate'].clearValidators();
    this.dependentForm['effectiveDate'].updateValueAndValidity();
    if (this.childCoverage === false) {
      this.dependentForm['carrierName'].clearValidators();
      this.dependentForm['carrierName'].updateValueAndValidity();
      this.dependentForm['graduationDate'].clearValidators();
      this.dependentForm['graduationDate'].updateValueAndValidity();
    }
    if (this.postSecondaryStudent === false) {
      this.dependentForm['graduationDate'].clearValidators();
      this.dependentForm['graduationDate'].updateValueAndValidity();
    }
  }

  updateDependent() {
    if (this.dependentform.invalid) {
      this.dependentform.markAllAsTouched();
      return;
    }
    else {

      let childId = this.childrenId;
      const endPoint = '/customer/' + this.customerid + '/customerRelative/' + childId + '/details';
      let accessToken = sessionStorage.getItem('accessToken');
      let data = this.dependentform.value;
      data["relationType"] = "CHILDREN";
      // data["carrierName"]=this.dependentform.value.insurer;
      data["coverage"] = this.dependentform.value.healthPlan;
      data["coveredByAnotherPlan"] = this.dependentform.value.coveredByAnotherPlan === true ? true : false;
      // if(this.dependentform.value.coveredByAnotherPlan===true) {
      //   data["coveredByAnotherPlan"] = true
      // }
      // else {
      //   data["coveredByAnotherPlan"] = false
      // }
      if (this.dependentform.value.coveredByAnotherPlan === false) {
        data["carrierName"] = ""
      }
      if (this.dependentform.value.postSecondaryStudent != true) {
        data["graduationDate"] = ""
      }
      if (data["graduationDate"]) {
        data['graduationDate'] = moment(data['graduationDate']).format("MM-DD-YYYY");
      }
      else {
        data["graduationDate"] = ""
      }
      // data["carrierName"] = this.dependentform.value.coveredByAnotherPlan
      data["dob"] = this.datePipe.transform(new Date(this.dependentform.value.dob).toLocaleString(), 'MM-dd-yyyy')
      this.http.put(environment.apiUrl + '/api/ap' + endPoint, data, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200) {
          this.http.get(environment.apiUrl + '/api/ap/global/set-adminMembers').subscribe((newResponse) => {
          // this.http.post(environment.apiUrl + '/api/ap/v3/global/set-adminMembers',{id:this.customerid}).subscribe((newResponse) => {
            this.http.post(environment.reportApiUrl + '/websocket/member/notification-to-others', {
              "message": "Members information has been updated. Please refresh screen."
            }, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              }
            }).subscribe((res) => {
              console.log({ res })
            })
          })
          this.getCustomerData();
          // this.getServiceWorkerDetails();
          this.closeDependentmodal.nativeElement.click();
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
        }
      }, (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
      });
    }
  }

  openGraduationDate(value: any) {
    this.graduationDate = value.currentTarget.checked;
    this.postSecondaryStudent = value.currentTarget.checked;
    if (this.postSecondaryStudent) {
      this.dependentForm['graduationDate'].setValidators([Validators.required]);
      this.dependentForm['graduationDate'].updateValueAndValidity();
    }
    else {
      this.dependentForm['graduationDate'].reset();
      this.dependentForm['graduationDate'].clearValidators();
      this.dependentForm['graduationDate'].updateValueAndValidity();
    }
  }

  closeDependentForm() {
    this.graduationDate = true;
    this.dependentCoverage = 'open';
    this.childCoverage = '';
  }

  closeSpouseForm() {
    this.spouseCoverage = '';
    this.coverage = 'open'
  }

  selectTab(tabName: string): void {
    this.selectedTab = tabName;
  }

  tabData() {
    this.selectedTab = 'tab1';
  }

  hicDetails() {
    // this.hicList = this.customerData?.healthCards;
    this.hicList = this.customerData?.healthCards;
  }

  viewHealthCard(link: any) {
    this.src = link.link;
    this.healthCard = true;
    if (this.src == '') {
      this.card = true;
    }
  }

  clearpadsignature() {
    this.clearSignature()

  }
  closeHealthCard() {
    this.healthCard = false;
    this.displayStyle = "none";
    this.card = false;
  }

  closeDownloadBooklet() {
    this.hidebooklet = false;
  }

  download() {
    // Swal.fire({allowOutsideClick: false,
    //   icon: this.lang?.Info,
    //   title: 'Are you sure you want to download helathcard?',
    //   showCancelButton: true,
    //   confirmButtonColor: '#3085d6',
    //   cancelButtonColor: '#d33',
    //   confirmButtonText: 'Yes',
    //   cancelButtonText: 'No',
    // })
  }

  downloadAllHic() {
    Swal.fire({
      allowOutsideClick: false,
      title: 'Alert',
      text: 'Download all healthcards?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Download',
    }).then((result) => {
      if (result.isConfirmed) {
        // this.hicList = this.customerData?.healthCards;
        this.hicList = this.customerData?.healthCards;
        if (this.hicList.length > 0) {
          for (let i = 0; i < this.hicList.length; i++) {
            this.http.get(this.hicList[i].filename, { responseType: "arraybuffer" }).subscribe(
              pdf => {
                const blob = new Blob([pdf], { type: "application/pdf" });
                const fileName = this.hicList[i].name + ".pdf";
                saveAs(blob, fileName);
              },
              (error) => {
                Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
              }
            );
          }
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: this.lang?.No_Health_Cards_Found })
        }
      }
      else {
        // document.getElementById("viewHicDetails").click();
        // $("#hicDetails").modal('show');

        // this.hicList = this.customerData?.healthCards;
        // this.displayStyle = "block";
        // this.viewHicDetails();
        // this.display='block';
        // this.content.open();
        // this.content.nativeElement.style.display = 'block';
      }
    });
  }

  downloadHic(value: any) {
    this.http.get(value.filename, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const fileName = value.name + ".pdf";
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
      }
    );
  }

  checkAllCheckBox(value: any) {
    this.hicList.forEach(hic => hic.checked = value.target.checked)
  }

  isAllCheckBoxChecked() {
    return this.hicList.every(hic => hic.checked);
  }

  checkAllBooklets(value: any) {
    this.bookletList.forEach(booklet => booklet.checked = value.target.checked)
  }

  isAllBookletsChecked() {
    return this.bookletList.every(booklet => booklet.checked);
  }

  // disabledDownload() {
  //   this.bookletList = this.bookletList.filter((selected:any)=>selected.checked).map((selected: any)=>selected);
  //   if(this.bookletList.length>0) {
  //     return false;
  //   }
  //   else {
  //     return true;
  //   }
  // }

  downloadSelected() {
    this.bookletList1 = this.bookletList.filter((selected: any) => selected.checked).map((selected: any) => selected);
    if (this.bookletList1.length > 0) {
      for (let i = 0; i < this.bookletList1.length; i++) {
        this.http.get(this.bookletList1[i].link, { responseType: "arraybuffer" }).subscribe(
          pdf => {
            const blob = new Blob([pdf], { type: "application/pdf" });
            const fileName = this.bookletList1[i].name + ".pdf";
            saveAs(blob, fileName);
          },
          (error) => {
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
          }
        );
      }
    }
    else {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: this.lang?.No_booklets_Selected })
    }
  }

  downloadAllHpBooklets() {
    // this.getHealthBooklets();
    Swal.fire({
      allowOutsideClick: false,
      title: 'Alert',
      text: 'Download all booklets?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Download',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        if (this.bookletList.length > 0) {
          for (let i = 0; i < this.bookletList.length; i++) {
            this.http.get(this.bookletList[i].link, { responseType: "arraybuffer" }).subscribe(
              pdf => {
                const blob = new Blob([pdf], { type: "application/pdf" });
                const fileName = this.bookletList[i].name + ".pdf";
                saveAs(blob, fileName);
              },
              (error) => {
                Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
              }
            );
          }
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: this.lang?.No_Booklets_Found })
        }
        // this.hicList = this.customerData?.healthCards;
        this.hicList = this.customerData?.healthCards;
        if (this.hicList.length > 0) {
          for (let i = 0; i < this.hicList.length; i++) {
            this.http.get(this.hicList[i].filename, { responseType: "arraybuffer" }).subscribe(
              pdf => {
                const blob = new Blob([pdf], { type: "application/pdf" });
                const fileName = this.hicList[i].name + ".pdf";
                saveAs(blob, fileName);
              },
              (error) => {
                Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
              }
            );
          }
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: this.lang?.No_Health_Cards_Found })
        }
        // this.downloadRoe();
      }
      else {
        // this.getHealthBooklets();
        // this.displayBooklet = "block";
      }
    });
  }

  downloadHpbooklet(value: any) {
    this.http.get(value.link, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const fileName = value.name + ".pdf";
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
      }
    );
  }
  downloadinvoices(invoice: any, index: any) {
    console.log({ invoice })
    this.http.get(invoice?.link ?? invoice?.invoice ?? invoice?.file, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        // const fileName = invoice?.customer?.firstName + "_" + this.customerid + "_" +this.invoiceMonthsList[index] + ".pdf";
        const fileName = (invoice?.customer?.firstName ?? this.customerData.firstName ?? "Invoice") + 
          (invoice?.customer?.lastName ?? this.customerData.lastName ?? "") + "_" + 
          this.customerid.toString() + "_" + moment(invoice.dueDate).format('MMM-YYYY') + ".pdf";
        console.log(fileName)
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
      }
    );
  }


  // public getRoeIndex=
  getRoe(index) {
    console.log('retghvcg');
    setTimeout(() => {
      if (this.roeUrl.length > 0) {
        // if(!hasWhiteSpace(this.roeUrl)) {
        this.roe = this.roeUrl[index].link;
        console.log("ROE", this.roe)
        this.viewRoe = true;
        // }

      }
      else {
        // alert("2")
        this.viewRoe = false;
      }
      // else {
      //   let customerDataEndpoint = '/customer/'+this.customerid+'/ROE';
      //   this.http.get(environment.apiUrl+'/api/ap/admin'+customerDataEndpoint, {
      //     headers:{
      //       Authorization: 'Bearer ' + this.accessToken,
      //       'Content-Type': 'application/json',
      //   }}).subscribe((response:any)=>{
      //     if(response.status==200) {
      //       this.roe = response.data.roe;
      //     }
      //     else {
      //       Swal.fire({allowOutsideClick: false,title: this.lang?.Error, text:response.message})
      //     }
      //   },(error) => {
      //     Swal.fire({allowOutsideClick: false,title: this.lang?.Error, text: error.error.error.message})
      //   });
      // }
    }, 1000);
  }

  closeRoe() {
    this.viewRoe = true;
  }

  downloadRoe(index) {
    console.log()
    this.getRoe(index);

    this.http.get(this.roeUrl[index].link, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const fileName = this.roeUrl[index].link.split("/").slice(-1)
        // -${this.roe.time.toISOString()}
        //       const fileName = this.roe+".pdf";
        // const fileName = this.roe
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
      });
    this.openRoe.nativeElement.click();
  }
  downloadPAD(data) {


    this.http.get(data, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const fileName = "PAD"
        // -${this.roe.time.toISOString()}
        //       const fileName = this.roe+".pdf";
        // const fileName = this.roe
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
      });

  }
  openPaymentDetails(value: any) {
    this.openUpdatePaymentForm = value;
    if (value == 'close') {
      Object.keys(this.paymentMethodControls).forEach(controlName => {
        if (controlName !== 'paymentmethod') {
          const control = this.paymentMethodControls[controlName];
          control.reset();
        }
      });
      this.bankDetails = false;
      this.resetButton = false;
      this.uploadCheque = false;
      setTimeout(() => {
        this.closePaymenttoPAD.nativeElement.click();
      }, 1000);
    }
  }

  public provincelist(event: any) {
    this.configprovinceres.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        this.provincialZipcodes = element.zipcodes.split(',');
        this.provincelistid = element.id;
        this.state_id = parseInt(element.fusebillId);
        this.statename = element.name;
      }
    });
    if (this.addressform.value.postalCode) {
      if (
        this.provincialZipcodes.indexOf(
          this.addressform.value.postalCode[0]
        ) == -1
      ) {
        this.invalidpostalcodeprivince = true;
        this.addressForm['postalCode'].markAsTouched();
        // this.addressForm['postalCode'].updateValueAndValidity();
      } else {
        this.invalidpostalcodeprivince = false;
      }
      if (this.addressform.value.postalCode.length == 0) {
        this.invalidpostalcodeprivince = false;
      }
    }
  }

  changeTextToUppercase(event: any) {
    const inputValue = this.addressform.get('postalCode')?.value;
    this.addressform.get('postalCode')?.setValue(inputValue.toUpperCase(), { emitEvent: false });
    this.postalvalue = event.target.value;
    if (this.provincialZipcodes.indexOf(this.postalvalue[0]) == -1) {
      this.invalidpostalcodeprivince = true;
      this.addressForm['postalCode'].markAsTouched();
    } else {
      this.invalidpostalcodeprivince = false;
    }
    if (this.postalvalue.length == 0) {
      this.invalidpostalcodeprivince = false;
    }
  }

  upperCase(event: any) {
    console.log(event.data)
    const inputValue = event.data;
    console.log(this.paymentform.get('postalcode')?.value)
    if (inputValue != null) {
      this.paymentform.get('postalcode')?.setValue(inputValue.toUpperCase(), { emitEvent: false });
    }
  }

  phoneFormat(event: any) {
    this.secondaryphonecheck = false

    if (event.target.id == 'primaryPhone') {
      const inputValue = this.addressform.get('primaryPhone')?.value;
      this.addressform.get('primaryPhone')?.setValue(this.phoneNoFormat.transform(inputValue), { emitEvent: false });
      // this.addressform.get('primaryPhone')?.setValue(inputValue, { emitEvent: false });

    }
    else if (event.target.id == 'secondaryPhone') {
      const inputValue = this.addressform.get('secondaryPhone')?.value;
      this.addressform.get('secondaryPhone')?.setValue(this.phoneNoFormat.transform(inputValue), { emitEvent: false });
      // this.addressform.get('secondaryPhone')?.setValue(inputValue, { emitEvent: false });

    }

  }

  getBankInfo() {
    if (this.paymentMethodForm.invalid) {
      this.paymentMethodForm.markAllAsTouched();
      return
    }
    else {
      let data = this.paymentMethodForm.value;
      let accessToken = sessionStorage.getItem('accessToken');
      const bankInfoUrl = 'https://testcustomersapi.groupbenefitz.aitestpro.com/api/ep/customer/bank/verify';
      this.http.post(bankInfoUrl, data, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200) {
          this.bankDetails = true;
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
        }
        this.bankInfo = response.data;
        this.address = this.bankInfo.address;
        this.bankAddress = this.bankInfo.address.split(', ');
        this.resetButton = true;
        this.uploadCheque = true;
      }, (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
      });
    }
  }

  openpad() {
    this.openUpdatePaymentForm = 'close';
  }

  closeChangeToPad() {
    this.paymentMethodForm.reset();
    this.paymentMethodForm.get('paymentmethod')?.setValue('');
    this.resetButton = false;
    this.uploadCheque = false;
    this.bankDetails = false;
    this.previewbutton = false;
    this.paymentMethodForm.get('files')?.setValue('');
  }

  closepadinfo() {
    this.bankinfo = true;
    this.resetbutton = true;
    this.cheque = false;
    this.paymentMethodForm.reset();
    this.paymentMethodForm.get('paymentmethod')?.setValue('');
    this.resetButton = false;
    this.uploadCheque = false;
    this.bankDetails = false;
    this.updatepreviewbutton = false;
    this.existVoid = true;
    this.padform.get('file')?.setValue('');
    this.paymentMethodForm.get('files')?.setValue('');
    this.voidCheckFileType = this.PADdetails.voidCheckFileType;
  }

  updateBankInfo() {
    if (this.padform.invalid) {
      this.padform.markAllAsTouched();
      return
    }
    else {
      let data = this.padform.value;
      data['branchCode'] = this.padform.value.transitNumber
      data['accountNumber'] = this.padform.value.accountNo
      data['bankCode'] = this.padform.value.bankcode
      let accessToken = sessionStorage.getItem('accessToken');
      const bankInfoUrl = 'https://testcustomersapi.groupbenefitz.aitestpro.com/api/ep/customer/bank/verify';
      this.http.post(bankInfoUrl, data, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200) {
          this.banknameres = response.data.bank.name + "\n" + response.data.address.split(",").join("\n");
          this.bankinfo = true;
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
        }
        this.bank = response.data;
        this.address = this.bank.address;
        this.bankAddress = this.bank.address.split(', ');
        this.resetbutton = true;
        this.cheque = true;
      }, (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
      });
    }
  }

  valisignModal() {
    this.showTimer = true;
    this.timer(1);
    const endPoint = '/customer/' + this.customerid + '/address/initialize';
    this.http.get(environment.apiUrl + '/api/ap/admin' + endPoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      // if(response.status==200) {
      //     Swal.fire({allowOutsideClick: false, title: this.lang?.Info, text: response.message });
      //   }
      // else {
      //   Swal.fire({allowOutsideClick: false,title: this.lang?.Error, text:response.message})
      // }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
    });
  }

  closeValisign() {
    clearInterval(this.startTimer);
  }

  timer(minute: any) {
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;
    const prefix = minute < 10 ? "0" : "";
    this.startTimer = setInterval(() => {
      seconds--;
      if (statSec != 0) {
        statSec--;
      }
      else {
        statSec = 59;
      }
      if (statSec < 10) {
        textSec = "0" + statSec;
      }
      else {
        textSec = statSec;
      }
      this.displayTimer = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
      if (seconds == 0) {
        clearInterval(this.startTimer);
        this.showTimer = false;
      }
    }, 1000);
  }

  getHealthBooklets() {
    let Endpoint = '/customer/' + this.customerid + '/booklets/false/false';
    this.http.get(environment.apiUrl + '/api/ap/admin' + Endpoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.bookletList = response.data;
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
    });
  }

  getInvoices() {

    this.invoiceResponse = this.customerInvoices;
    this.upcomingInvoice = this.customerUpcomingInvoices;
    return false;
    let Endpoint = '/v2/' + this.customerid + '/invoices';
    this.http.post(environment.apiUrl + '/api/ap' + Endpoint, {}, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.invoiceResponse = response.data.invoices;
        this.upcomingInvoice = response.data.upcomingInvoice;
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
    });
  }

  // getDraftInvoice() {
  //     let Endpoint = '/v2/' + this.customerid + '/invoices';
  //     this.http.post(environment.apiUrl + '/api/ap' + Endpoint, {}, {
  //         headers: {
  //             Authorization: 'Bearer ' + this.accessToken,
  //             'Content-Type': 'application/json',
  //         }
  //     }).subscribe((response: any) => {
  //         if (response.status == 200) {
  //             this.invoicedraftData = response.data.invoice;
  //         }
  //         else {
  //             Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
  //         }
  //     }, (error) => {
  //         Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
  //     });
  // }
  triggerFileInput(): void {
    // Use the native element here
    this.fileInput.nativeElement.click();
  }

  closeUploadHealthCard() {

    this.bankfileArray = []
    this.multiUploadArray = []
    this.types = []
    this.multiUpload = false;
    this.uploadService.reset()
    console.log("entered")
    console.log(this.types, this.multiUploadArray, this.bankfileArray)
    this.myFileInputService.nativeElement.value = null;
    this.uploadError = false;
    this.typesError = false;
  }

  handleFileUpload(){
    console.log('this.fileUpload',this.fileUpload)
  }

  uploadRoe(event: any) {
    // alert("uploadRoe");
    var fileExtension = '.' + event.target.files[0].name.split('.').pop();
    this.isFileUploaded = true
    this.imagedisplay = null;
    // alert(event.target.files[0].name.replace(event.target.files[0].name,"void.pdf"))
    this.bankfile = event.target.files[0];
    var allowedMimes = [
      "application/pdf",
    ];

    let error = false;
    let message = "";

    if (allowedMimes.includes(this.bankfile.type)) {
      const maxFileSize = 1024 * 1024 * (environment.fileSize ? +environment.fileSize : 5);

      if (this.bankfile.size <= maxFileSize) {
        //300KB
        error = false;

      } else {
        error = true;
        message = `File size is too large,maximum file size is 5 MB`
        // message = this.lang?.File_size_is_too_large_maximum_file_size_is_5MB;
      }
    }
    else {
      error = true;
      message = this.lang?.Invalid_file_type_Only_pdf_files_is_allowed;
    }

    if (error) {
      Swal.fire({
        title: this.lang?.Error,
        html: message,
        width: "50%",
        showCancelButton: false,
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.value) {
          this.myFileInput.nativeElement.value = null;
        } else {
        }
      });
    }

    else {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (_event) => {
        this.imagedisplay = reader.result;
        console.log("imgedisplay :", this.imagedisplay);
        this.applicationFile = this.fileUpload

        // let accessToken = sessionStorage.getItem('accessToken');
        // let endpoint = ""
        // var formData: any = new FormData();

        // if (this.fileUpload=='roe') {
        //   endpoint = environment.apiUrl + '/api/ap/customer' + `/${this.customerid}/uploadROE`;
        //   formData.append("firstName", this.customerData?.firstName);
        //   formData.append("roe", this.bankfile);
        // } else if(this.fileUpload=='roa') {
        //   endpoint = environment.apiUrl + '/api/ap/customer' + `/${this.customerid}/uploadROE`;
        //   formData.append("firstName", this.customerData?.firstName);
        //   formData.append("roe", this.bankfile);
        // } else {
        //   endpoint = environment.apiUrl + '/api/ap/customer' + `/${this.customerid}/uploadROE`;
        //   formData.append("firstName", this.customerData?.firstName);
        //   formData.append("roe", this.bankfile);
        // }

        // this.http.post(endpoint, formData,
        //   {
        //     headers: {
        //       'Authorization': 'Bearer ' + accessToken,
        //       // 'Content-Type': 'application/pdf',
        //       // 'Content-Type': 'multipart/form-data',
        //       'Accept': '*',

        //     }
        //   }).subscribe((response: any) => {

        //     if (response.status == 200) {
        //       console.log(response);
        //       this.myFileInput.nativeElement.value = null;
        //       Swal.fire({ title: this.lang?.Info, text: response.message }).then((result) => {
        //         if (result.value) {
        //           this.getCustomerData();
        //           // this.getServiceWorkerDetails();
        //         } else {
        //         }
        //       });
        //     }
        //     else {
        //       Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message });
        //       this.myFileInput.nativeElement.value = null;
        //     }
        //   }, (error) => {
        //     Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message });
        //     this.myFileInput.nativeElement.value = null;
        //   });
      };
    }

  }

  myApplicationsModal(){
    this.myFileInput.nativeElement.value = null;
    this.fileUpload = 'null'
    this.applicationFile = ''
  }

  UploadApplications(){
    // console.log(this.fileUpload,this.customerid,this.bankfile, this.customerData?.firstName);
    let accessToken = sessionStorage.getItem('accessToken');
    let endpoint = ""
    var formData: any = new FormData();

    if (this.applicationFile == 'roe') {
      endpoint = environment.apiUrl + '/api/ap/customer' + `/${this.customerid}/uploadROE`;
      formData.append("firstName", this.customerData?.firstName);
      formData.append("roe", this.bankfile);
    } else if(this.applicationFile == 'roa') {
      endpoint = environment.apiUrl + '/api/ap/customer' + `/${this.customerid}/uploadROE`;
      formData.append("firstName", this.customerData?.firstName);
      formData.append("roe", this.bankfile);
    } else {
      endpoint = environment.apiUrl + '/api/ap/customer' + `/${this.customerid}/uploadROE`;
      formData.append("firstName", this.customerData?.firstName);
      formData.append("roe", this.bankfile);
    }

    this.http.post(endpoint, formData,
      {
        headers: {
          'Authorization': 'Bearer ' + accessToken,
          // 'Content-Type': 'application/pdf',
          // 'Content-Type': 'multipart/form-data',
          'Accept': '*',
        }
      }).subscribe((response: any) => {

        if (response.status == 200) {
          console.log(response);
          this.myFileInput.nativeElement.value = null;
          Swal.fire({ title: this.lang?.Info, text: response.message }).then((result) => {
            if (result.value) {
              this.getCustomerData();
              // this.getServiceWorkerDetails();
            } else {
            }
          });
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message });
          this.myFileInput.nativeElement.value = null;
        }
      }, (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message });
        this.myFileInput.nativeElement.value = null;
      });
  }

  uploadServiceType(event: any, index?: any) {
    let error = false;

    let message = "";

    var fileExtension = '.' + event.target?.files[0]?.name?.split('.').pop();
    this.isFileUploaded = true
    this.imagedisplay = null;


    var allowedMimes = [
      "application/pdf",
    ];

    if (this.uploadService.invalid && this.noService) {
      error = true;
      message = this.lang?.Please_select_Service_And_Provider;
    }
    // this.bankfileArray = [];

    if (allowedMimes.includes(event.target.files[0].type)) {
      const maxFileSize = 1024 * 1024 * (environment.fileSize ? +environment.fileSize : 5);

      if (event.target.files[0].size > maxFileSize) {
        error = true;
        message = `File size is too large,maximum file size is 5 MB`
        // message = this.lang?.File_size_is_too_large_maximum_file_size_is_5MB;
      }
    } else {
      error = true;
      message = this.lang?.Invalid_file_type_Only_pdf_files_is_allowed;
    }

    if (error) {
      Swal.fire({
        title: this.lang?.Error,
        html: message,
        width: "50%",
        showCancelButton: false,
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.value) {
          this.myFileInputService.nativeElement.value = null;
          this.uploadService.get('uploadhealthCardFile').setValue(null);
          this.uploadService.get('uploadhealthCardFile').updateValueAndValidity();
        }
      });
      return
    }

    console.log("file", event.target.files[0])

    if (index >= 0) {
      this.bankfileArray[index] = (event.target.files[0]);
    }
    else {
      this.bankfileArray.push(event.target.files[0]);
    }

    if (this.types && this.types?.length > 0 && this.bankfileArray?.length == this.types?.length) {
      this.typesError = false
    }
    if (this.bankfileArray.length > 0) {
      this.uploadError = false

    }


  }


  uploadServiceType_(event: any, index?: any, type?: any) {
    let error = false;

    let message = "";

    var fileExtension = '.' + event.target?.files[0]?.name?.split('.').pop();
    this.isFileUploaded = true
    this.imagedisplay = null;


    var allowedMimes = [
      "application/pdf",
    ];

    if (this.uploadService.invalid && this.noService) {
      error = true;
      message = "Please select Service And Provider";
    }
    // this.bankfileArray = [];

    if (allowedMimes.includes(event.target.files[0].type)) {
      const maxFileSize = 1024 * 1024 * (environment.fileSize ? +environment.fileSize : 5);

      if (event.target.files[0].size > maxFileSize) {
        error = true;
        // message = "File size is too large,maximum file size is 5 MB";
        message = `File size is too large,maximum file size is 5 MB`
      }
    } else {
      error = true;
      message = "Invalid file type. Only pdf file is allowed.";
    }

    if (error) {
      Swal.fire({
        title: "Error",
        html: message,
        width: "50%",
        showCancelButton: false,
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.value) {
          this.myFileInputService.nativeElement.value = null;
          this.uploadService.get('uploadhealthCardFile').setValue(null);
          this.uploadService.get('uploadhealthCardFile').updateValueAndValidity();
        }
      });
      return
    }

    let fileData = {
      type: type,
      file: event.target.files[0]
    }
    if (index >= 0) {
      this.bankfileArray[index] = (fileData);
    }
    else {
      this.bankfileArray.push(fileData);
    }
    console.log(fileData, index, this.bankfileArray)

    if (this.types && this.types?.length > 0 && this.bankfileArray?.length == this.types?.length) {
      this.typesError = false
    }
    if (this.bankfileArray.length > 0) {
      this.uploadError = false

    }


    console.log(this.bankfileArray, this.types, index)
  }

  async mergePDFs(array): Promise<any> {
    if (array.length > 0) {
      const mergedPdf = await PDFDocument.create();

      for (const file of array) {
        const pdfBytes = await file.arrayBuffer();
        const pdf = await PDFDocument.load(pdfBytes);
        const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
        copiedPages.forEach((page) => mergedPdf.addPage(page));
      }

      const mergedPdfBytes: any = await mergedPdf.save();
      const mergedPdfFile = new File([mergedPdfBytes], 'merged.pdf', { type: 'application/pdf' });
      return mergedPdfFile
      // this.downloadMergedPDF(mergedPdfBytes);
    }
  }

  getHealthCards() {
    let customerDataEndpoint = '/customer/' + this.customerid + '/uploadHealthcard';
    this.http.get(environment.apiUrl + '/api/ap' + customerDataEndpoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        console.log('responceOfHealthCards', response);
        this.servicesDetails = response.data.healthcard_services_with_providers;
        this.showProvider = false;
        if (Object.keys(this.servicesDetails).length > 0) {
          this.noService = true;
          this.uploadService.invalid

          let keys = ['uploadhealthCardProvider', 'uploadhealthCardFile']
          for (let key of keys) {
            this.uploadService.get(key).clearValidators();
            this.uploadService.get(key).updateValueAndValidity();
          }

        } else {
          this.noService = false;
        }

      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
    });
  }

  showProviders(e: any) {
    this.types = []
    this.bankfileArray = [];
    this.multiUpload = false
    this.multiUploadArray = [];

    this.uploadService.get('uploadhealthCardProvider')?.setValue('')
    this.uploadService.get('uploadhealthCardProvider').updateValueAndValidity();
    this.myFileInputService.nativeElement.value = null;

    if (this.servicesDetails[e.target.value]?.multipleUpload == true) {
      this.multiUpload = true
      this.multiUploadArray.push(' ')
    }
    else {
      this.multiUpload = false;
      this.multiUploadArray = []
    }

    if (this.servicesDetails[e.target.value]?.provider.length != 0 && this.servicesDetails[e.target.value]?.provider != undefined) {
      this.showProvider = true;
      this.providersArray = this.servicesDetails[e.target.value].provider;

      this.uploadService.get('uploadhealthCardProvider').setValidators(Validators.required);
      this.uploadService.get('uploadhealthCardProvider').updateValueAndValidity();

    }
    else {

      this.showProvider = false;
      this.uploadService.get('uploadhealthCardProvider').clearValidators();
      this.uploadService.get('uploadhealthCardProvider').updateValueAndValidity();
      this.changeUploadService(e);
    }
    // console.log(this.multiUploadArray)
  }

  showType(e: any) {
    const service = this.uploadService.get('uploadhealthCard').value
    this.myFileInputService.nativeElement.value = null;
    this.bankfileArray = [];
    if (this.servicesDetails[service]?.multipleUpload == true) {
      const typeForService: any = this.servicesDetails[service].type[e.target.value]
      if (typeForService && typeForService.length > 0) {
        this.types = [...typeForService]
      }

    }
    else {
      this.types = []

    }
    console.log(this.multiUploadArray, this.types)
  }

  addCard() {
    if (this.multiUploadArray.length <= 10) {
      this.multiUploadArray.push(' ')
    }
  }
  async UploadHealthCard() {

    console.log(this.bankfileArray)
    if (this.bankfileArray.length <= 0) {
      this.uploadError = true
      return
    }
    if (this.types && this.types?.length > 0 && this.bankfileArray?.length != this.types?.length) {
      this.typesError = true
      return
    }

    if (this.uploadService.invalid) {//this.uploadService.invalid&&this.noService
      this.uploadService.markAllAsTouched();
      return false;
    }

    let accessToken = sessionStorage.getItem('accessToken');
    let customerDataEndpoint = `/${this.customerid}/uploadHealthcard`;


    var formData: any = new FormData();
    let service;
    let provider;
    console.log(this.servicesDetails)



    if (this.uploadService.get('uploadhealthCard')) {
      service = this.uploadService.get('uploadhealthCard').value
    } else {
      service = ' '
    }
    if (this.uploadService.get('uploadhealthCardProvider')) {
      provider = this.uploadService.get('uploadhealthCardProvider').value
      if (!provider) {
        provider = ' '
      }
    } else {
      // alert("1")
      provider = ' '
    }

    let serviceType = service.replaceAll(' ', '').replaceAll('-', '') || ''
    let providerType = provider.replace(' ', "").toLowerCase() || ''
    formData.append("firstName", this.customerData?.firstName);
    formData.append("service", serviceType);

    if (this.bankfileArray.length > 1) {
      let pdf: any;
      let files: any;
      if (this.types && this.types.length > 0) {
        files = this.bankfileArray.map(item => item.file)
        // pdf = await this.mergePDFs(files)
      } else {
        pdf = await this.mergePDFs(this.bankfileArray)
      }
      // if (pdf.size > 3000 * 1024) {
      //     Swal.fire({ title: this.lang?.Error, text: "Files combined size cant be greater than 3 MB" })
      //     return;
      // }
      if (serviceType == 'privatehealth' && providerType == 'bestdoctors') {
        for (const bfa of this.bankfileArray) {
          formData.append(bfa.type, bfa.file)
        }
        const fileTypes = this.bankfileArray.map(item => item.type)
        formData.append("filesData", JSON.stringify(fileTypes))
      } else {
        formData.append("card", pdf);
      }
    }
    else {
      if (serviceType == 'privatehealth') {
        formData.append("card", this.bankfileArray[0].file)
      } else {
        formData.append("card", this.bankfileArray[0])
      }
    }


    formData.append("provider", providerType)

    this.http.post(environment.apiUrl + '/api/ap/customer' + customerDataEndpoint, formData,
      {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Accept': '*'

        }
      }).subscribe((response: any) => {

        console.log(response);
        if (response.status == 200) {
          this.closeUploadHealthCard()

          this.getCustomerData();
          $('#healthCardDropdown').modal('hide');
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message }).then((result) => {
            if (result.value) {
              this.closeUploadHealthCard()
            }
          });
        }
      }, (error) => {
        console.log(error)
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.message }).then((result) => {
          if (result.value) {
            this.closeUploadHealthCard()
            this.uploadService.get('uploadhealthCardFile').setValue(null);
            this.uploadService.get('uploadhealthCardFile').updateValueAndValidity();
            this.myFileInputService.nativeElement.value = null;
          } else {
          }
        });
      });


  }

  getCreditcard() {

    return false
    let Endpoint = '/customer/' + this.customerid + '/creditCards';
    this.http.get(environment.apiUrl + '/api/ap' + Endpoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.ccDetails = response.data[0];
        this.publicapikey = response.data[0].publicKey;
        // this.paymentMethodId = response.data[0].paymentMethodId;
        this.creditCardNo = response.data[0].maskedCardNumber;
        this.fullName = response.data[0].firstName + ' ' + response.data[0].lastName;
        this.expire = response.data[0].expirationMonth + '/' + response.data[0].expirationYear;
      }
      else {
        // Swal.fire({allowOutsideClick: false,title: this.lang?.Error, text:response.message})
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
    });
  }


  viewBooklet(value: any) {
    console.log('bookletlink', value)
    setTimeout(() => {
      this.bookletLink = value;
    }, 1000);
    this.hidebooklet = true;
  }

  viewinvoices(value: any) {
    console.log('bookletlink', value)
    setTimeout(() => {
      this.invoiceslink = value;
    }, 1000);
    // this.hidebooklet = true;
  }

  closeBooklet() {
    this.hidebooklet = false;
    this.displayBooklet = "none";
  }
  closeInvoice() {
    // this.hidebooklet = false;
    // this.displayBooklet = "none";
  }

  // lifeEventChanges() {
  //   Swal.fire({allowOutsideClick: false,title:this.lang?.Info,text:"Work in progress!"});
  // }

  resetPaymentForm() {
    this.paymentMethodControls['bankCode'].reset();
    this.paymentMethodControls['branchCode'].reset();
    this.paymentMethodControls['accountNumber'].reset();
    this.paymentMethodControls['files'].reset();
    this.bankDetails = false;
    this.uploadCheque = false;
    this.resetButton = false;
    // document.getElementById('bankDetails')?.remove();
  }

  resetPadForm() {
    this.bankinfo = false;
    this.cheque = false;
    this.resetbutton = false;
    this.padForm['bankcode'].reset();
    this.padForm['transitNumber'].reset();
    this.padForm['accountNo'].reset();
    this.padForm['file'].reset();
    this.existVoid = false;
    // document.getElementById('bankinfo')?.remove();
  }

  onFileSelect(event: any) {
    // if (event.target.files.length > 0) {
    //   const file = event.target.files[0];
    //   this.paymentMethodForm.get('files')?.setValue(file);
    // }
    this.fileExtension = "." + event.target.files[0].name.split(".").pop();
    this.paymentVoidCheque = event.target.files[0];
    this.selectedBase64 = this.convertFile(this.paymentVoidCheque);
    // if(this.paymentVoidCheque) {
    //   const reader = new FileReader();
    //   reader.readAsBinaryString(this.paymentVoidCheque);
    //   reader.onload = (e) => {
    //     this.selectedBase64 = e.target?.result as string;
    //   };
    // }

    var allowedMimes = [
      "image/jpeg",
      "image/pjpeg",
      "image/png",
      "application/pdf",
    ];
    let error = false;
    let message = "";
    if (allowedMimes.includes(this.paymentVoidCheque.type)) {
      const maxFileSize = 1024 * 1024 * (environment.fileSize ? +environment.fileSize : 5);

      if (this.paymentVoidCheque.size <= maxFileSize) {
        error = false;
      } else {
        error = true;
        message = `File size is too large,maximum file size is 5 MB`
        // message = this.lang?.File_size_is_too_large_maximum_file_size_is_5MB;
      }
    } else {
      error = true;
      message = this.lang?.Invalid_file_type_Only_pdf_files_is_allowed;
    }
    if (error) {
      Swal.fire({
        allowOutsideClick: false,
        title: this.lang?.Error,
        html: message,
        width: "50%",
        showCancelButton: false,
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.value) {
          this.paymentMethodForm.get('files')?.reset();
        } else {
        }
      });
    }
    else {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (_event) => {
        this.imagedisplay = reader.result;
        this.previewbutton = true;
      };
    }
  }

  fileSelect(event: any) {
    // if (event.target.files.length > 0) {
    //   const file = event.target.files[0];
    //   this.paymentMethodForm.get('files')?.setValue(file);
    // }
    this.fileExtension = "." + event.target.files[0].name.split(".").pop();
    if (this.fileExtension == '.pdf') {
      this.voidCheckFileType = 'application/pdf';
    }
    else {
      this.voidCheckFileType = 'image/jpeg';
    }
    this.paymentVoidCheque = event.target.files[0];
    this.selectedBase64 = this.convertFile(this.paymentVoidCheque);
    // if(this.paymentVoidCheque) {
    //   const reader = new FileReader();
    //   reader.readAsBinaryString(this.paymentVoidCheque);
    //   reader.onload = (e) => {
    //     this.selectedBase64 = e.target?.result as string;
    //   };
    // }

    var allowedMimes = [
      "image/jpeg",
      "image/pjpeg",
      "image/png",
      "application/pdf",
    ];
    let error = false;
    let message = "";
    if (allowedMimes.includes(this.paymentVoidCheque.type)) {
      const maxFileSize = 1024 * 1024 * (environment.fileSize ? +environment.fileSize : 5);

      if (this.paymentVoidCheque.size <= maxFileSize) {
        error = false;
      } else {
        error = true;
        message = `File size is too large,maximum file size is 5 MB`
        // message = this.lang?.File_size_is_too_large_maximum_file_size_is_5MB;
      }
    } else {
      error = true;
      message = this.lang?.Invalid_file_type_Only_pdf_files_is_allowed;
    }
    if (error) {
      Swal.fire({
        allowOutsideClick: false,
        title: this.lang?.Error,
        html: message,
        width: "30%",
        showCancelButton: false,
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.value) {
          this.paymentMethodForm.get('files')?.reset();
        } else {
        }
      });
    }
    else {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (_event) => {
        this.imagedisplay = reader.result;
        this.updatepreviewbutton = true;
        if (this.padform.get('file')?.value != '') {
          this.review = false;
        }
      };
    }
  }

  convertFile(file: File): Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (event) => {
      if (event.target?.result) {
        result.next(btoa(event.target.result.toString()));
      }
    }
    return result;
  }

  DataURIToBlob(dataURI: string) {
    const byteCharacters = atob(dataURI);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: 'application/octet-stream' });
  }

  generateCorporatePAD() {

    let inputData1 = {
      bankCode: this.paymentMethodForm.get("bankCode")?.value,
      branchCode: this.paymentMethodForm.get("branchCode")?.value,
      accountNumber: this.paymentMethodForm.get("accountNumber")?.value,
    };
    let bankAddress = this.address;
    let bankAdressArr = bankAddress.split(",")
    let provincePostal = bankAdressArr[bankAdressArr.length - 1];
    let provincePostalArr = provincePostal.split(" ");
    let bankobject = {
      name: this.bankInfo.bank.name,
      address: this.bankInfo.bank.address.split(",")[0],
      city: bankAdressArr[bankAdressArr.length - 2].replace(" ", ''),
      province: provincePostalArr[provincePostalArr.length - 3],
      postalCode: provincePostalArr[provincePostalArr.length - 2] + " " + provincePostalArr[provincePostalArr.length - 1],
    }
    //  var fileExtension = '.' +this.bankfile.name.split('.').pop();
    // event.target.files[0].name ="void_cheque_"+Date.now()+fileExtension
    var fileExtension = "." + this.paymentVoidCheque.name.split(".").pop();
    this.encBank = btoa(JSON.stringify(inputData1));
    var formData: any = new FormData();
    formData.append("bank", JSON.stringify(bankobject));
    // formData.append("files", this.paymentVoidCheque, this.paymentVoidCheque.name);
    formData.append(

      "files",

      this.paymentVoidCheque,

      "void_cheque_" + Date.now() + fileExtension.toLowerCase()

    );
    // formData.append("files", this.paymentVoidCheque,"void_cheque_"+Date.now()+this.fileExtension.toLowerCase());
    // if(this.selectedBase64) {
    //   let file = this.DataURIToBlob(this.selectedBase64);
    //   let file = this.selectedBase64._buffer[0];
    // formData.append("files", file, this.paymentVoidCheque.name);
    // }
    // formData.append("files", this.bankfile.name,"void.pdf");
    formData.append("session", this.encBank) || "";
    formData.append("timestamp", new Date().getTime());
    let Endpoint = '/' + this.customerid + '/generatePAD';
    // let data = this.paymentMethodForm.value.files;
    this.http.post(environment.apiUrl + '/api/ap' + Endpoint, formData, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.pad = response.data.url;
        this.filename = response.data.filename;
        this.padfilename = response.data.padfilename;
        this.ext = response.data.ext;
        this.mimetype = response.data.mimetype;
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
    });
  }

  updateCorporatePAD() {

    let inputData1 = {
      bankCode: this.padform.get("bankcode")?.value,
      branchCode: this.padform.get("transitNumber")?.value,
      accountNumber: this.padform.get("accountNo")?.value,
      amount: this.PADdetails.nextBillingPrice,
      customerId: this.customerid
    };
    let bankAddress;
    if (this.address == null) {
      bankAddress = this.bankinformation;
    }
    else {
      bankAddress = this.address;
    }
    let bankAdressArr = bankAddress.split(",")
    let provincePostal = bankAdressArr[bankAdressArr.length - 1];
    let provincePostalArr = provincePostal.split(" ");
    let bankobject = {
      name: this.bank.bank.name,
      address: this.bank.bank.address.split(",")[0],
      city: bankAdressArr[bankAdressArr.length - 2].replace(" ", ''),
      province: provincePostalArr[provincePostalArr.length - 3],
      postalCode: provincePostalArr[provincePostalArr.length - 2] + " " + provincePostalArr[provincePostalArr.length - 1],
    }
    //  var fileExtension = '.' +this.bankfile.name.split('.').pop();
    // event.target.files[0].name ="void_cheque_"+Date.now()+fileExtension;
    const doc = new jsPDF();

    doc.addImage(this.voidCheckImage, 'JPEG', 10, 10, 190, 100);
    const pdfFile = doc.output('blob');
    this.voidCheckPdf = new File([pdfFile], 'voidCheque.pdf', { type: 'application/pdf' });
    if (!this.paymentVoidCheque) {

      this.paymentVoidCheque = this.voidCheckPdf;
      console.log(this.paymentVoidCheque)
    }
    console.log(this.paymentVoidCheque)
    var fileExtension = "." + this.paymentVoidCheque.name.split(".").pop();
    this.encBank = btoa(JSON.stringify(inputData1));
    var formData: any = new FormData();
    formData.append("bank", JSON.stringify(bankobject));
    // formData.append("files", this.paymentVoidCheque, this.paymentVoidCheque.name);
    formData.append(

      "files",

      this.paymentVoidCheque,

      "void_cheque_" + Date.now() + fileExtension.toLowerCase()

    );
    // formData.append("files", this.paymentVoidCheque,"void_cheque_"+Date.now()+this.fileExtension.toLowerCase());
    // if(this.selectedBase64) {
    //   let file = this.DataURIToBlob(this.selectedBase64);
    //   let file = this.selectedBase64._buffer[0];
    // formData.append("files", file, this.paymentVoidCheque.name);
    // }
    // formData.append("files", this.bankfile.name,"void.pdf");
    formData.append("session", this.encBank) || "";
    formData.append("timestamp", new Date().getTime());
    let Endpoint = '/' + this.customerid + '/generatePAD';
    // let data = this.paymentMethodForm.value.files;
    this.http.post(environment.apiUrl + '/api/ap' + Endpoint, formData, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.pad = response.data.url;
        this.filename = response.data.filename;
        this.padfilename = response.data.padfilename;
        this.ext = response.data.ext;
        this.mimetype = response.data.mimetype;
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
    });
  }

  closeAgreement() {

  }

  drawComplete() {
  }

  drawStart() {
  }

  clearSignature() {
    this.signaturePad.clear();
  }

  savePad() {
    const base64Data = this.signaturePad.toDataURL();
    // const base64Data = "";

    this.signatureImg = base64Data;
    let Endpoint = '/' + this.customerid + '/updatePAD';
    let data = {
      url: this.pad,
      signature: this.signatureImg,
      session: this.encBank,
      filename: this.filename,
      padfilename: this.padfilename,
      ext: this.ext,
      mimetype: this.mimetype,
      adminName: 'sai',
    }
    this.http.post(environment.apiUrl + '/api/ap' + Endpoint, data, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.signedPad = response.data.url;
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
    });
  }

  closeSignaturePad() {
    this.closePaymentmodal.nativeElement.click();
  }


  addSpouse() {
    this.spouseUpdate = false;
    if (JSON.stringify(this.spouseInfo) === '{}') {
      this.spouseStatus = true;
      this.spouseForm['martialStatus'].clearValidators();
      this.spouseForm['martialStatus'].updateValueAndValidity();
      this.spouseForm['effectiveDate'].clearValidators();
      this.spouseForm['effectiveDate'].updateValueAndValidity();
    }
    else {
      this.spouseStatus = false;
      // this.spouseForm['firstName'].clearValidators();
      // this.spouseForm['firstName'].updateValueAndValidity();
      // this.spouseForm['lastName'].clearValidators();
      // this.spouseForm['lastName'].updateValueAndValidity();
      // this.spouseForm['dob'].clearValidators();
      // this.spouseForm['dob'].updateValueAndValidity();
      // this.spouseForm['phoneNum'].clearValidators();
      // this.spouseForm['phoneNum'].updateValueAndValidity();
      // this.spouseForm['coveredByAnotherPlan'].clearValidators();
      // this.spouseForm['coveredByAnotherPlan'].updateValueAndValidity();
      // this.spouseForm['healthPlan'].clearValidators();
      // this.spouseForm['healthPlan'].updateValueAndValidity();
      // this.spouseForm['insurer'].clearValidators();
      // this.spouseForm['insurer'].updateValueAndValidity();
    }
    this.spouseform.reset();
  }

  addSpouseData() {

    // Object.keys(this.spouseForm).forEach(controlName => {
    //   if (controlName !== 'martialStatus' && controlName !== 'effectiveDate') {
    //     const control = this.spouseForm[controlName];
    //     control.reset();
    //   }
    //   if(controlName == 'email') {
    //     const control = this.spouseForm[controlName];
    //     control.setErrors(null);
    //     const updatedErrors = { ...control.errors };
    //     delete updatedErrors['pattern'];
    //     control.setErrors(updatedErrors);
    //   }
    // });

    if (this.spouseStatus) {

      if (this.spouseform.invalid) {
        this.spouseform.markAllAsTouched();
        return;
      }
      else {
        const endPoint = '/customer/' + this.customerid + '/lifeChange/spouse/add/true';
        this.spouseData = this.spouseform.value;
        if (this.spouseform.value.coveredByAnotherPlan != true) {
          this.spouseData["coverage"] = ""
          this.spouseData["carrierName"] = ""
        }
        else {
          this.spouseData["coverage"] = this.spouseform.value.healthPlan
          this.spouseData["carrierName"] = this.spouseform.value.insurer
        }
        if (this.spouseform.value.email == null) {
          this.spouseData["email"] = ""
        }
        this.spouseData["dob"] = this.datePipe.transform(new Date(this.spouseform.value.dob).toLocaleString(), 'MM-dd-yyyy')
        this.spouseData["relationType"] = "SPOUSE"

        let data: any;
        data = {
          'spouse': this.spouseData,
          'dependent': []
        }

        this.http.post(environment.apiUrl + '/api/ap/admin' + endPoint, data, {
          headers: {
            Authorization: 'Bearer ' + this.accessToken,
            'Content-Type': 'application/json',
          }
        }).subscribe((response: any) => {
          if (response.status == 200) {
            // this.getCustomerData();
            this.closeSpousemodal.nativeElement.click();
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
          }
          else {
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
          }
        }, (error) => {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
        });
      }
    }
    else {
      if (this.spouseForm['effectiveDate'].invalid || this.spouseForm['martialStatus'].invalid) {

        this.spouseform.markAllAsTouched();
        return;
      }
      else {


        let spouseData = this.childrenInfo;


        let data = this.spouseform.value;
        console.log(data)

        for (let spouse of spouseData) {
          console.log(spouse)
          if (spouse["relationType"] == "spouse") {
            data["firstName"] = spouse.firstName;
            data["lastName"] = spouse.lastName;
            data["dob"] = spouse.dob;
            data["gender"] = spouse.gender;
            data["email"] = spouse.email || "";
            data["coverage"] = spouse.healthPlan;
            data["carrierName"] = spouse.insurer;
            data["healthPlan"] = spouse.healthPlan;
            data["insurer"] = spouse.insurer;
          }

        }
        data["effectiveDate"] = this.spouseForm['effectiveDate'].value
        data["martialStatus"] = this.spouseForm['martialStatus'].value || ""
        data["email"] = this.spouseForm['email'].value || ""
        data["relationType"] = "SPOUSE"
        // this.spouseData["dob"]= this.datePipe.transform(new Date(this.spouseform.value.dob).toLocaleString(),'MM-dd-yyyy')

        if (this.spouseform.value.coveredByAnotherPlan === true) {
          data["coveredByAnotherPlan"] = true
        }
        else {
          data["coveredByAnotherPlan"] = false
        }

        data = {
          'spouse': data,
          'dependent': []
        }
        const endPoint = '/customer/' + this.customerid + '/lifeChange/spouse/add/false';

        // data["dob"]= this.datePipe.transform(new Date(this.spouseform.value.dob).toLocaleString(),'MM-dd-yyyy')
        this.http.post(environment.apiUrl + '/api/ap/admin' + endPoint, data, {
          headers: {
            Authorization: 'Bearer ' + this.accessToken,
            'Content-Type': 'application/json',
          }
        }).subscribe((response: any) => {
          if (response.status == 200) {
            this.getCustomerData();
            // this.getServiceWorkerDetails();
            this.closeSpousemodal.nativeElement.click();
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
          }
          else {
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
          }
        }, (error) => {
          console.log(error)
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
        });
      }
    }


    // this.closeSpousemodal.nativeElement.click();
  }

  addDependent() {
    this.dependentform.reset();
    this.dependentUpdate = false;
    this.postSecondaryStudent = false;
    // if(this.childrenInfo.length!==0) {
    this.dependentStatus = true;
    //   this.dependentForm['effectiveDate'].clearValidators();
    //   this.dependentForm['effectiveDate'].updateValueAndValidity();
    // }
    // else {
    //   this.dependentStatus = false;
    // }
    this.dependentForm['graduationDate'].clearValidators();
    this.dependentForm['graduationDate'].updateValueAndValidity();
    this.dependentData = [];
  }

  addAnotherDependent() {
    if (this.dependentform.valid) {
      if (this.dependentform.value.coveredByAnotherPlan === false) {
        this.dependentForm["carrierName"].setValue("");
      }
      if (this.dependentform.value.postSecondaryStudent != true) {
        this.dependentForm["graduationDate"].setValue("");
      }
      this.dependentData.push(this.dependentform.value);
      this.dependentform.reset();
    }
    else {
      this.dependentform.markAllAsTouched();
    }

  }

  addDependentData() {
    if (this.dependentform.valid) {
      let data: any;
      if (this.dependentform.value.coveredByAnotherPlan === false) {
        this.dependentForm["carrierName"].setValue("");
      }
      if (this.dependentform.value.postSecondaryStudent != true) {
        this.dependentForm["graduationDate"].setValue("");
      }

      this.dependentData.push(this.dependentform.value);
      if (this.dependentData['graduationDate']) {
        this.dependentData['graduationDate'] = moment(this.dependentData['graduationDate'].format('MM-DD-YYYY'));
      }
      else {
        this.dependentData['graduationDate'] = "";
      }
      this.dependentData['dob'] = moment(this.dependentData['dob'].format('MM-DD-YYYY'));
      // this.dependentData['dob']= this.datePipe.transform(new Date(this.dependentform.value.dob).toLocaleString(),'MM-dd-yyyy')
      data = {
        'spouse': {},
        'dependent': this.dependentData
      }
      const endPoint = '/customer/' + this.customerid + '/lifeChange/dependent/add/true';
      this.http.post(environment.apiUrl + '/api/ap/admin' + endPoint, data, {
        headers: {
          Authorization: 'Bearer ' + this.accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200) {
          // this.getCustomerData();
          this.closeSpousemodal.nativeElement.click();
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
        }
      }, (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
      });
      this.closeDependentmodal.nativeElement.click();
    }
    else {
      this.dependentform.markAllAsTouched();
    }
  }

  getMonth(event: any) {
    this.expireMonth = event.target.value;
    this.validateExpire(this.expireYear, this.expireMonth);
  }

  getYear(event: any) {
    this.expireYear = event.target.value;
    this.validateExpire(this.expireYear, this.expireMonth);
  }

  validateExpire(year: any, month: any) {
    let date = 31
    if (month == 4 || month == 6 || month == 9 || month == 11) {
      date = 30
    }
    else if (month == 2) {
      if ((year % 4 == 0 && year % 100 !== 0) || (year % 400 == 0)) {
        date = 29;
      }
      else {
        date = 28;
      }
    }
    if (year != null && month != null) {
      const expiry = new Date(parseInt("20" + year), month - 1, date);
      const current = new Date();
      if (expiry.getTime() < current.getTime()) {
        this.invalidExpiration = true;
      }
      else {
        this.invalidExpiration = false;
      }
    }
  }

  closePaymentInfo() {
    this.paymentform.reset();
    this.paymentform.get('expireMonth')?.setValue('');
    this.paymentform.get('expireYear')?.setValue('');
  }

  closeCcInfo() {
    this.ccform.reset();
    this.ccform.get('expireMonth')?.setValue('');
    this.ccform.get('expireYear')?.setValue('');
  }

  // closeButton() {
  //   this.closebutton.nativeElement.click();
  // }

  changeToCC() {
    this.getCreditcard();
    // this.paymentform.get('FirstName')?.setValue(this.customerData?.firstName);
    // this.paymentform.get('LastName')?.setValue(this.customerData?.lastName);
    // this.paymentform.get('address1')?.setValue(this.customerData?.line1);
    // this.paymentform.get('streetaddressline2')?.setValue(this.customerData?.line2);
    // this.paymentform.get('countryId')?.setValue(this.customerData?.country);
    // this.paymentform.get('email')?.setValue(this.customerData?.email);
    // this.paymentform.get('city')?.setValue(this.customerData?.city);
    // this.paymentform.get('province')?.setValue(this.customerData?.province);
    // this.paymentform.get('postalcode')?.setValue(this.customerData?.postalCode);
  }

  saveCcPayment(value: any, value1: any) {
    if (this.paymentform.invalid) {
      this.paymentform.markAllAsTouched();
      return;
    }
    else {
      // value1.CutomerID.value=parseInt(value1.CustomerID.value)
      value1.submit();
      // value.submit();
    }
  }

  checkEmail(FormGroup1, formControl1) {
    let pattern = /^(?!\\s)[_A-Za-z0-9-]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;
    let email = FormGroup1.get(formControl1).value;
    if (pattern.test(email)) {
      this.checkEmailKey = false;
    } else {
      this.checkEmailKey = true;
    }
  }

  updateCcInfo(value: any, value1: any) {
    if (this.ccform.invalid) {
      this.ccform.markAllAsTouched();
      return;
    }
    else {
      value1.submit();
    }
  }

  padUpdate() {
    // alert("!")
    $("#updatePADinfo1").show()
    this.padform.patchValue(this.PADdetails);
    this.padForm['branchCode'] = this.PADdetails.transitNumber;
    this.padform.get('accountNo')?.setValue(this.PADdetails.accountNumber)
    this.padform.get('bankcode')?.setValue(this.PADdetails.bankCode)
    // this.padform.get('bankdetails')?.setValue(this.bankinformation)
    this.banknameres = this.bankinformation;
    this.bankinfo = true;
    this.resetbutton = true;
  }

  checkFirstCharacter(event: any, form: any) {
    console.log(event)
    if (event.target.value.startsWith(' ')) {
      event.target.value = event.target.value.trimStart();
    }
    console.log(form)
    console.log(event.target.id)
    console.log(this.addressform.get('line1')?.value)
    console.log(form.get(event.target.id));
    // Removing the special characters
    form.get(event.target.id).setValue(event.target.value.replace(/[^a-zA-Z0-9\s]/g, ''));
  }
  public formatCreditCardNumber(event: any): void {
    let inputVal = event.target.value.replace(/\s+/g, ''); // Remove existing spaces

    if (inputVal.length > 0) {
      // Format the input with spaces every 4 digits
      inputVal = inputVal.match(/.{1,4}/g).join(' ');


    }
    // this.paymentForm.patchValue({ CardNumber: inputVal });
    this.ccform.get('CardNumber')?.setValue(inputVal);

    // this.creditCardForm.patchValue({ CardNumber: inputVal });
  }
  public formatAmericaCreditCardNumber(event: any): void {
    let inputVal = event.target.value.replace(/\s+/g, ''); // Remove existing spaces

    if (inputVal.length > 0) {
      // Format the input with spaces every 4 digits
      // inputVal = inputVal.match(/.{1,4}/g).join(' ');

      inputVal = inputVal.replace(/(\d{4})(\d{1,6})?(\d{1,5})?/, function (match, p1, p2, p3) {
        return p1 + (p2 ? ' ' + p2 : '') + (p3 ? ' ' + p3 : '');
      });
    }
    this.ccform.get('CardNumber')?.setValue(inputVal);
    // if (this.isValidAmexCard(inputVal.replaceAll(' ',''))) {
    //   console.log("This is a valid American Express card number.");
    // } else {
    //   console.log("This is not a valid American Express card number.");
    // }
    // this.creditCardForm.patchValue({ CardNumber: inputVal });
  }
  public isValidAmexCard(cardNumber) {
    // Remove any non-digit characters
    const cleanedCardNumber = cardNumber.replace(/\D/g, '');

    // Check if the card number has 15 digits and starts with 34 or 37
    const isAmex = /^3[47]\d{13}$/.test(cleanedCardNumber);

    return isAmex;
  }
  public isValidAmexCardNumber(val) {
    // Define the regex pattern for formatted Amex card number
    const amexPattern = /^3[47][0-9]{2} [0-9]{6} [0-9]{5}$/;
    console.log(amexPattern)
    return amexPattern.test(val.replaceAll(' ', ''));


  }
  public creditcardlblurmethod(event) {
    // this.postalvalue = event.target.value
    this.validateCreditCardNumber(event)


    let val = event.target.value;


    console.log(val.slice(0, 2))


    if (val.slice(0, 2) == 34 || val.slice(0, 2) == 37) {
      this.creditcardvalidationAmerica(val)
      this.formatAmericaCreditCardNumber(event)
      // this.isValidAmexCardNumber(val)
    }
    else {
      this.creditcardvalidation(val)
      this.formatCreditCardNumber(event)

      // this.dependentForm['cardNumber'].setValidators([Validators.required]);

    }

    val = val.replaceAll(' ', '')
    let checksum = 0; // running checksum total
    let j = 1; // takes value of 1 or 2
    // Process each digit one by one starting from the last
    for (let i = val.length - 1; i >= 0; i--) {
      let calc = 0;
      // Extract the next digit and multiply by 1 or 2 on alternative digits.
      calc = Number(val.charAt(i)) * j;

      // If the result is in two digits add 1 to the checksum total
      if (calc > 9) {
        checksum = checksum + 1;
        calc = calc - 10;
      }
      // Add the units element to the checksum total
      checksum = checksum + calc;
      // Switch the value of j
      if (j == 1) {
        j = 2;
      } else {
        j = 1;
      }
    }
    //Check if it is divisible by 10 or not.
    // return (checksum % 10) == 0;
    if (checksum % 10 == 0) {
      this.invalidcreditcard = false;
    } else {
      this.invalidcreditcard = true;
    }

    if (event.target.value.length == 0) {
      this.invalidcreditcard = false;
    }
  }
  validateCreditCardNumber(val) {
    const cardImage = document.getElementById('card-image');

    console.log(val.target.value)
    const visaPattern = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
    const mastPattern = /^(?:5[1-5][0-9]{14})$/;
    const amexPattern = /^(?:3[47][0-9]{13})$/;
    const discPattern = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;

    const ccNum: string = val.target.value.replaceAll(' ', '')

    const isVisa = visaPattern.test(ccNum) === true;
    const isMast = mastPattern.test(ccNum) === true;
    const isAmex = amexPattern.test(ccNum) === true;
    const isDisc = discPattern.test(ccNum) === true;

    if (isVisa || isMast || isAmex || isDisc) {
      // at least one regex matches, so the card number is valid.
      if (isVisa) {
        this.cardType = 'Visa card'
        // Visa-specific logic goes here
      }
      else if (isMast) {
        this.cardType = 'Master card'
        // Mastercard-specific logic goes here
      }
      else if (isAmex) {
        this.cardType = 'Amex card';
        // cardImage['src']= 'path/to/amex.png';
        // cardImage.style.display = 'inline';
        // AMEX-specific logic goes here
      }
      else if (isDisc) {
        this.cardType = 'Discover card'
        // Discover-specific logic goes here
      }
      // return of (null);
    }
    else {
      this.cardType = '';
      // cardImage.style.display = 'none';
      // return of({
      //   invalid: true
      // });
      // alert("Please enter a valid card number.");
    }
  }

  creditcardvalidation(value: any) {
    console.log(value)
    var creditcardRegexp = /^[0-9_ ]{19,19}$/;
    if (value && !creditcardRegexp.test(value)) {
      this.invalidcreditcarddetails = true

      console.log("test")

    } else {
      this.invalidcreditcarddetails = false

    }
  }
  creditcardvalidationAmerica(value: any) {
    console.log(value)
    var creditcardRegexp = /^[0-9_ ]{17,17}$/;
    if (value && !creditcardRegexp.test(value)) {
      this.invalidcreditcarddetails = true
    } else {
      this.invalidcreditcarddetails = false

    }
  }
  changepad() {
    this.changetopad = true;
    setTimeout(() => {
      this.voidCheque1 = this.imagedisplay;
    }, 1000);
  }

  updatePadpreview() {
    this.changetopad = false;
    setTimeout(() => {
      this.voidCheque2 = this.imagedisplay;
    }, 1000);
  }

  uploadNewVoid() {
    this.bankinfo = true;
    this.cheque = true;
    this.resetbutton = true;
    this.existVoid = false;
    if (this.padform.get('file')?.value == null) {
      this.review = false;
    }
  }

  existingVoidCheque() {
    setTimeout(() => {
      if (this.voidCheckFileType == 'application/pdf') {
        this.voidCheque2 = this.voidCheckImage;
      }
    }, 1000);
    setTimeout(() => {
      this.pad = this.padAgreement;
    }, 1000);
  }

  padformValid() {
    if (this.padform.invalid) {
      this.resetbutton = false;
      this.bankinfo = false;
      this.cheque = false;
      return
    }
  }

  paymentMethodFormValid() {
    if (this.paymentMethodForm.invalid) {
      this.resetButton = false;
      this.bankDetails = false;
      this.uploadCheque = false;
      return
    }
  }

  ccUpdate() {
    // alert("!")
    if (this.ccDetails.firstName == "Rakesh") {
      this.ccform.get('FirstName')?.setValue(this.customerData.firstName);
    }
    else {
      this.ccform.get('FirstName')?.setValue(this.ccDetails.firstName);
    }
    if (this.ccDetails.lastName == "test") {
      this.ccform.get('LastName')?.setValue(this.customerData.lastName);
    }
    else {
      this.ccform.get('LastName')?.setValue(this.ccDetails.lastName);
    }
    // this.ccform.get('FirstName')?.setValue(this.ccDetails.firstName);
    // this.ccform.get('LastName')?.setValue(this.ccDetails.lastName);
    this.ccform.get('ExpirationMonth')?.setValue(this.ccDetails.expirationMonth);
    this.ccform.get('ExpirationYear')?.setValue(this.ccDetails.expirationYear);
  }

  changeToPAD() {
    let Endpoint = '/' + this.customerid + '/paymentType/ACH/change';
    this.http.post(environment.apiUrl + '/api/ap' + Endpoint, { "paymentId": 0 }, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.getCustomerData();
        // this.getServiceWorkerDetails();
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
    });
    this.bankinfo = true;
    this.resetbutton = true;
    this.cheque = false;
    this.paymentMethodForm.reset();
    this.paymentMethodForm.get('paymentmethod')?.setValue('');
    this.resetButton = false;
    this.uploadCheque = false;
    this.bankDetails = false;
    this.updatepreviewbutton = false;
    this.existVoid = true;
    this.padform.get('file')?.setValue('');
    this.voidCheckFileType = this.PADdetails.voidCheckFileType;
  }

  resolved(captchaResponse: any) {
    this.recaptchaResponse = captchaResponse;
  }

  dependentnextcard() {
    // this.index = i+1;
    this.currentIndex = (this.currentIndex + 1) % this.childrenInfo.length;
  }

  dependentpreviouscard() {
    // this.index = i;
    this.currentIndex = (this.currentIndex - 1 + this.childrenInfo.length) % this.childrenInfo.length;
  }

  getindex(i: any) {
  }

  getPlanes() {
    let accessToken = sessionStorage.getItem('accessToken');
    let customerId = sessionStorage.getItem('customerId');
    let customerEndpoint = `/customer/${customerId}/plans/false`;
    this.http.get(environment.apiUrl + '/api/ap/admin' + customerEndpoint, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-type': 'applivation/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.plans = response.data.plans;

        console.log(this.plans)
        setTimeout(() => {
          this.getcoverflow()
        }, 1000);
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
    });
  }

  getbenefits() {
    let accessToken = sessionStorage.getItem('accessToken');
    let customerId = sessionStorage.getItem('customerId');
    let customerEndpoint = `/customer/${customerId}/planBenefits/false`;
    this.http.get(environment.apiUrl + '/api/ap/admin' + customerEndpoint, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-type': 'applivation/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        let planbenefits = response.data.plansBenefits;
        this.benefits = [];
        for (let benefit of planbenefits) {
          if (benefit.content.includes('{{booklet_link}}')) {
            this.headerName = benefit.name;
            console.log('headerName', this.headerName)
            benefit.content = benefit.content.replace('{{booklet_link}}', benefit.bookletLink)
          }
          // if(benefit.content.includes('greenshield')) {
          //   this.headerName = benefit.name;
          //   console.log('headerName',this.headerName)
          //   benefit.content = benefit.content.replace('{{booklet_link}}',benefit.bookletLink)
          // }
          if (this.hicList && this.hicList.length > 0) {
            if (benefit.content.includes('{{health_card_link}}')) {
              benefit.content = benefit.content.replace('{{health_card_link}}', this.hicList[0].healthCard);
            }
          }
          this.benefits.push(benefit)
          // console.log("rakesh",this.benefits)
          setTimeout(() => {
            this.getcoverflow()
          }, 1000);
        }
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
    });
  }



  openVideoPopup() {
    let el: HTMLElement = this.openPopup.nativeElement;
    el.click();
  }

  // closeVideo() {
  //   var video = document.getElementsByTagName('video')[0];
  //   video.pause()
  // }

  openiframePopup() {
    let el: HTMLElement = this.openiframe.nativeElement;
    el.click();
  }

  openequitablePopup() {
    let el: HTMLElement = this.openequitable.nativeElement;
    el.click();
  }

  openSupportPopup() {
    let el: HTMLElement = this.opensupport.nativeElement;
    el.click();
  }

  downloadCard() {
    this.http.get(this.health_card, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const fileName = this.health_card + ".pdf";
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
      });
  }

  onSlideChangeDependents(event: any) {
    console.log(event)

    this.currentIndexOfSwipperDependents = event[0].realIndex + 1;
    if (this.childrenInfo[event[0].realIndex].relationType == "spouse") {

      this.editSpouse = true;

      this.editChild = false;

    }

    else if (this.childrenInfo[event[0].realIndex].relationType == "child") {

      this.editSpouse = false;

      this.editChild = true;

    }

  }



  handleMarriageType(e) {
    this.functionClearSettings()
    console.log(e.target.value)
    this.spouseform.get('martialStatus')?.setValue('COUPLE', { emitEvent: false })
    this.dependentTypeForm.get('marriageType')?.setValue(e.target.value, { emitEvent: false })
    console.log(this.dependentTypeForm)
    this.marriageType = e.target.value;
    if (e.target.value == 'commonLaw') {
      this.isCommonLaw = true;
      this.isMarried = false;
    } else {
      this.isMarried = true;
      this.isCommonLaw = false;
    }
  }

  functionClearSettings() {
    // this.dependentTypeForm.get('marriageDate')?.setValue('')
    // this.dependentTypeForm.get('marriageType')?.setValue('')
    this.dependentform.reset();
    this.validateCheck = true;
    this.spouseform.reset();
    this.isMarried = false;
    this.childCount = 0;
    this.showValidatePlans = false;
    this.showPlanDetails = false;
    this.showSpouseInfo = false;
    this.specialpackages = []
    this.plansSummaryObj = []
    this.childCoverage = false;
    this.isCommonLaw = false;
    this.showChildForm = false;
    this.childrenDetails = []
    this.normalSpouseRegistration = true;
    this.normalDependentRegistration = false;
  }

  changeDependent(e: any) {
    this.functionClearSettings()
    this.dependentType = e.target.value;
    // this.mode = '';
    // this.spouseform.get('martialStatus')?.setValue('')
    if (this.dependentType == 'spouse' || this.dependentType == 'multiple')
      this.dependentTypeForm.get('marriageType')?.setValue('')
    if (this.dependentType == 'spouse') {
      this.dependentTypeForm.get('marriageDate')?.setValue('')
    }
    this.dependentTypeForm.get('childrenCountData')?.setValue('')
    this.dependentform.get('effectiveDate')?.setValue('')
    sessionStorage.removeItem("plansummarymain")
    sessionStorage.removeItem("plansskumain");
    sessionStorage.removeItem("plansummaryopt");
    sessionStorage.removeItem("plansummary");
    sessionStorage.removeItem("selectedPlans");
    sessionStorage.removeItem("totalAmount");
    sessionStorage.removeItem("totalAmountUI");
  }

  onSlideChangeDownload(event: any) {

    this.currentIndexOfSwipperDownload = event[0].realIndex + 1;

  }

  onSlideChangePlan(event: any) {

    this.currentIndexOfSwipperPlan = event[0].realIndex + 1;

  }

  onSlideChangeBenifuts(event: any) {

    this.currentIndexOfSwipperBenifits = event[0].realIndex + 1;

  }

  setlanguage(event: any) {
    this.getFormConfiguration(event);
    console.log("123")
  }

  getcoverflow() {
    var TrandingSlider = new Swiper('.tranding-slider', {
      effect: 'coverflow',
      centeredSlides: true,
      loop: true,
      slidesPerView: 'auto',
      allowTouchMove: false,
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 2.5,
      },
      pagination: {
        el: '.swiper-pagination',
        type: "fraction",
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });
    console.log(TrandingSlider.activeIndex)
  }

  // ngOnDestroy(): void {
  //   //Called once, before the instance is destroyed.
  //   //Add 'implements OnDestroy' to the class.
  //   this.elementRef.nativeElement.remove();

  // }
  numbersOnly(event) {
    const key = event.key || String.fromCharCode(event.keyCode);
    // console.log({ key })
    // Check if the key is an alphabetical character (A-Z or a-z) or a space
    if (/(^[0-9 \-]+$)/.test(key)) {
      return true;
    } else {
      return false;
    }
  }
  public checkDateOfBirth(event: any) {
    if (event.target.value == "Invalid date") {
      this.brokerregform.controls["effectiveDate"].reset();
      this.brokerregform.controls["effectiveDate"].markAsTouched();
    }
  }
  public checkDateOfBirth1(event: any) {
    console.log(event.target.value)

    const birthDate = new Date(event.target.value);
    const today = new Date();
    const age = today.getFullYear() - birthDate.getFullYear();

    const validDatePattern = /^\d{2}-\d{2}-\d{4}/;

    // Extract the first valid date part
    const match = event.target.value.match(validDatePattern);
    console.log(match)
    if (match[0] != event.target.value) {
      this.addressform.controls['dob'].reset();
      this.addressform.controls['dob'].markAsTouched();
    }


    if (event.type === 'input') {
      if (event.target.value == '') {
        this.addressform.controls['dob'].reset();
        this.addressform.controls['dob'].markAsTouched();
      }
    } else {
      if (event.target.value == 'Invalid date') {
        this.addressform.controls['dob'].reset();
        this.addressform.controls['dob'].markAsTouched();
      }
      if (event.target.value == '') {
        this.addressform.controls['dob'].reset();
        this.addressform.controls['dob'].markAsTouched();
      }
    }
  }

  // filterInvoices() {
  //   console.log('Selected filter:', this.filterInvoice);
  //   console.log('customerFinalInvoices1:', this.customerFinalInvoices1);
  //   console.log('customerFinalInvoicesIGBMS:', this.customerFinalInvoicesIGBMS);

  //   if (this.filterInvoice === 'All') {
  //     this.customerFinalInvoicesIGBMS = this.allCustomerFinalInvoicesIGBMS;
  //     this.customerFinalInvoices = this.allCustomerFinalInvoices1
  //     this.getCustomerDraftDate = this.getCustomerDraftDate1;
  //   } else {
  //     const selectedYear = this.filterInvoice;
  //     this.customerFinalInvoicesIGBMS = this.allCustomerFinalInvoicesIGBMS.filter(invoice => {
  //       const dueDate = new Date(invoice.dueDate);
  //       return dueDate.getFullYear().toString() == selectedYear;
  //     });
  //     this.customerFinalInvoices1 = this.allCustomerFinalInvoices1.filter(invoice => {
  //       const dueDate = new Date(invoice.dueDate);
  //       return dueDate.getFullYear().toString() == selectedYear;
  //     });
  //     const draftYear = new Date(this.getCustomerDraftDate1).getFullYear().toString();
  //     console.log(draftYear, selectedYear)
  //     if (draftYear == selectedYear) {
  //       this.getCustomerDraftDate = this.getCustomerDraftDate1; // If it matches the selected year, keep the date
  //     } else {
  //       this.getCustomerDraftDate = ''; // Otherwise, set it to null (or any other default behavior)
  //     }
  //   }

  //   console.log('Filtered invoices:', this.filteredInvoices);
  // }

  filterInvoices() {
    console.log('Selected filter:', this.filterInvoice);
    console.log('customerFinalInvoices1:', this.customerFinalInvoices);

    if (this.filterInvoice === 'All') {
      this.customerFinalInvoices = this.allCustomerFinalInvoices1
    } else {
      const selectedYear = this.filterInvoice;
      this.customerFinalInvoices = this.allCustomerFinalInvoices1.filter(invoice => {
        const dueDate = new Date(invoice.dueDate);
        return dueDate.getFullYear().toString() == selectedYear;
      });
    }

    console.log('Filtered invoices:', this.filteredInvoices);
  }

  CustomInvoiceFilter() {
    console.log('this.filterDateSelection', this.filterDateSelection);
    if (this.filterDateSelection) {
      this.updateCustomRange();
      // if (this.dropdown) {
      //   this.dropdown.hide();
      // }
    } else {
      console.log('No date selected');
    }
  }

  updateCustomRange() {
    const [startDate, endDate] = this.filterDateSelection.map(date => new Date(date));

    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);

    if (isNaN(startDate) || isNaN(endDate)) {
      console.log('Invalid start or end date');
      return;
    }

    console.log('Custom date range:', startDate, 'to', endDate);

    // Filter invoices within the date range
    this.customerFinalInvoices1 = this.allCustomerFinalInvoices1.filter(invoice => {
      const invoiceDate = new Date(invoice.dueDate);
      invoiceDate.setHours(0, 0, 0, 0);
      return invoiceDate >= startDate && invoiceDate <= endDate;
    });

    this.customerFinalInvoicesIGBMS = this.allCustomerFinalInvoicesIGBMS.filter(invoice => {
      const invoiceDate = new Date(invoice.dueDate);
      invoiceDate.setHours(0, 0, 0, 0);
      return invoiceDate >= startDate && invoiceDate <= endDate;
    });

    const draftDate = new Date(this.getCustomerDraftDate1);
    draftDate.setHours(0, 0, 0, 0);
    console.log(draftDate,startDate,endDate)
    if (draftDate >= startDate && draftDate <= endDate) {
      this.getCustomerDraftDate = this.getCustomerDraftDate1;
    } else {
      this.getCustomerDraftDate = '';
    }

    $('#dropdownMenuButton').click()
  }

  onCustomClick(event: MouseEvent) {
    event.stopPropagation();
    this.filterInvoice = 'Custom';
  }

  updateExpiryStatus(cardExpiry) {
    // current date
    const currentDate = new Date();

    // split expiry month and year
    const expiryParts = cardExpiry.split('/');
    const expiryMonth = parseInt(expiryParts[0], 10);
    const expiryYear = parseInt('20' + expiryParts[1], 10);

    // get formated expiry date
    const expiryDate = new Date(expiryYear, expiryMonth - 1);

    // get the difference between current date and expiry date
    const monthDiff = (expiryDate.getFullYear() - currentDate.getFullYear()) * 12 + expiryDate.getMonth() - currentDate.getMonth();

    if (monthDiff <= 0) {
      // expired
      this.ccExpiryTitle = 'Expired'
      this.ccExpiryColor = 'red'
    } else if (monthDiff === 1) {
      // expires in 1 month
      this.ccExpiryTitle = 'Expires next month'
      this.ccExpiryColor = 'darkorange'
    } else if (monthDiff === 2) {
      // expires in 2 months
      this.ccExpiryTitle = 'Expires in couple of months'
      this.ccExpiryColor = 'orange'
    } else if (monthDiff === 3) {
      // expires in 3 months
      this.ccExpiryTitle = 'Expires in 3 months'
      this.ccExpiryColor = '#dcbd15'
    } else if (monthDiff > 3) {
      // expires in more than 3 months
      this.ccExpiryTitle = ''
      this.ccExpiryColor = 'green'
    }
  }

  removeUnderscores(input) {
    return input.replace('_', ' ').toLowerCase()
  }

  capitalizeFirstLetter(str: string): string {
    if (str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }
    return ''; // Return an empty string if the input is falsy (null, undefined, or empty)
  }


  // Life event changes

  addDependentForm() {
    this.dependentTypeForm.get('dependentType')?.setValue('')
    // this.dependentTypeForm.get('marriageDate')?.setValue('')
    // this.dependentTypeForm.get('marriageType')?.setValue('')
    this.functionClearSettings();
    this.dependentType = '';
    sessionStorage.removeItem("plansummarymain")
    sessionStorage.removeItem("plansskumain");
    sessionStorage.removeItem("plansummaryopt");
    sessionStorage.removeItem("plansummary");
    sessionStorage.removeItem("selectedPlans");
    sessionStorage.removeItem("totalAmount");
    sessionStorage.removeItem("totalAmountUI");
    this.totalSummaryPrice = 0
    // if (this.dependentTypeForm.invalid) {
    //     this.dependentTypeForm.markAllAsTouched();
    //     return;
    // }
    this.dependentform.get('effectiveDate')?.setValue('')

    const dependentType = this.dependentTypeForm.value.dependentType
    this.addDependentWithSpouse = false;
    console.log('this.dependentCoverage', this.dependentCoverage)
    this.totalCount = 0;
    this.childCoverage = '';
  }

  reAuthorize() {
      const paymentDetails = this.customerData?.latestPaymentDetails;
      const payload = {
        customerProfileId: paymentDetails?.customerProfileId,
        paymentProfileId: paymentDetails?.paymentProfileId,
        amount: paymentDetails?.amount
      }
      console.log(payload);
      fetch(`${environment.authorizeApiUrl}/api/authorize-net/authorize`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(payload),
      })
      .then(async (res) => {
        if (!res.ok) {
          const reason = await res.text();
          console.error('Payment authorization failed:', reason);
  
          // Call backend to update status as failed
          this.authorizeNetService.updatePaymentStatus({
            id: paymentDetails?.id,
            status: 'Failed',
          }).subscribe();
  
          return;
        }
  
        const json = await res.json();
  
        // Update status as Authorized
        this.authorizeNetService.updatePaymentStatus({
          id: paymentDetails?.id,
          status: 'Authorized',
          authTransId: json.transactionId,
        }).subscribe();
  
        console.log('Payment authorized:', json);
      })
      .catch((err) => {
        console.error('Error during authorization:', err);
  
        this.authorizeNetService.updatePaymentStatus({
          id: paymentDetails?.id,
          status: 'Failed',
        }).subscribe();
      });
  
    }
  
  
    retryPayment() {
      const paymentDetails = this.customerData?.latestPaymentDetails;
      const today = new Date();
      const payload = {
        customerProfileId: paymentDetails?.customerProfileId,
        paymentProfileId: paymentDetails?.paymentProfileId,
        amount: paymentDetails?.amount
      }
      console.log(payload);
      fetch(`${environment.authorizeApiUrl}/api/authorize-net/charge-now`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(payload),
      })
      .then(async (res) => {
        if (!res.ok) {
          const reason = await res.text();
          console.error('Payment failed:', reason);
  
          // Call backend to update status as failed
          this.authorizeNetService.updatePaymentStatus({
            id: paymentDetails?.id,
            status: 'Failed',
            retryCount: (paymentDetails.retryCount ?? 0) + 1,
            lastRetryAttempt: today.toISOString(),
          }).subscribe();
  
          return;
        }
  
        const json = await res.json();
  
        // Update status as Authorized
        this.authorizeNetService.updatePaymentStatus({
          id: paymentDetails?.id,
          status: 'Captured',
          captureTransId: json.transactionId,
        }).subscribe();
  
        console.log('Payment Captured:', json);
      })
      .catch((err) => {
        console.error('Error during authorization:', err);
  
        this.authorizeNetService.updatePaymentStatus({
          id: paymentDetails?.id,
          status: 'Failed',
          retryCount: (paymentDetails.retryCount ?? 0) + 1,
          lastRetryAttempt: today.toISOString(),
        }).subscribe();
      });
  
    }

  // get igbmsId(): string {
  //   return 'IGBMS_' + this.customerId + (
  //     this.paymentPlatform === 'Staxbill' 
  //     ? '-SB_' + (this.MemberfusebillId??0) 
  //     : this.authorizenetCustomerId ? '-AN_' + (this.authorizenetCustomerId ?? 0) : '');
  // }
}

export function postalcodeValidator(control: FormControl): { [key: string]: any } | null {
  var postalRegexp = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/gm;
  if (control.value && !postalRegexp.test(control.value)) {
    return { invalidPostalCode: true };
  }
  return null
}
export function childrenminimumAgeValidator(control: FormControl): { [key: string]: any } | null {

  const birthDate = new Date(control.value);

  const today = new Date();
  const age = today.getFullYear() - birthDate.getFullYear();

  console.log(birthDate)
  console.log(age)

  if (age == 55) {
    return { childrenminimumAge: false };
  }
  if (age > 21 || age < 0) {
    return { childrenminimumAge: true };
  }


  return null;

}

function phoneNumbersMustBeDifferent(control: AbstractControl): { [key: string]: boolean } | null {
  const primaryPhoneNumber = control.get('primaryPhone')?.value;
  const secondaryPhoneNumber = control.get('secondaryPhone')?.value;
  if (secondaryPhoneNumber == "") {
    return { phoneNumbersMatch: false };
  } else if (primaryPhoneNumber === secondaryPhoneNumber) {
    return { phoneNumbersMatch: true };
  }
  return null;
}

function hasWhiteSpace(s: any) {
  return /\s/g.test(s);
}

// export function postalcodeValidator2(control: FormControl): {
//   [key: string]: any;
// } {
//   var postalRegexp = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/gm;
//   if (control.value && !postalRegexp.test(control.value)) {
//     return { invalidPostalCode: true };
//   }
// }



